/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: string;
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-01-01 13:00:00`. */
  DateTime: string;
};

export type AddGroupSignupInput = {
  companion: Scalars['ID'];
  souls: Array<Scalars['ID']>;
};

export type AddSignupsInput = {
  eventId: Scalars['ID'];
  group?: InputMaybe<AddGroupSignupInput>;
  loneCompanions?: InputMaybe<Array<Scalars['ID']>>;
  loneSouls?: InputMaybe<Array<Scalars['ID']>>;
  notes?: InputMaybe<Scalars['String']>;
};

export type Allotment = {
  __typename?: 'Allotment';
  amount: Scalars['Int'];
  amount_left: Scalars['Int'];
  created_at: Scalars['DateTime'];
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  start: Scalars['DateTime'];
  status: AllotmentStatus;
  updated_at: Scalars['DateTime'];
};

export enum AllotmentStatus {
  Active = 'ACTIVE',
  Depleted = 'DEPLETED',
  Expired = 'EXPIRED',
  Planned = 'PLANNED'
}

export type Applicant = Companion | Soul;

export type AuthPayload = {
  __typename?: 'AuthPayload';
  user: Employee;
};

export type CancelEventInput = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};

export type CandidatesInput = {
  cardholder: Scalars['ID'];
  companions: Array<Scalars['ID']>;
  groups: Array<GroupInput>;
  souls: Array<Scalars['ID']>;
  teams: Array<GroupInput>;
};

export type Category = {
  __typename?: 'Category';
  color: Scalars['String'];
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type CategoryDataPayload = {
  __typename?: 'CategoryDataPayload';
  previous_signups: Scalars['Int'];
  previous_tickets: Scalars['Int'];
  signups: Scalars['Int'];
  tickets: Scalars['Int'];
};

export type CategoryStatsInput = {
  range: Scalars['String'];
  range_type: StatsRangeType;
  target_groups?: InputMaybe<Array<SoulTargetGroup>>;
};

export type CategoryStatsPayload = {
  __typename?: 'CategoryStatsPayload';
  category: Category;
  data: CategoryDataPayload;
};

export type Companion = User & {
  __typename?: 'Companion';
  attends?: Maybe<SignupPaginator>;
  birthdate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailPaginator>;
  fax?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  future_signups?: Maybe<SignupPaginator>;
  gdpr_consent: Scalars['Boolean'];
  gdpr_consent_source?: Maybe<GdprConsentSource>;
  id: Scalars['ID'];
  last_name: Scalars['String'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  meta: CompanionMeta;
  mobile?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organisation?: Maybe<Organisation>;
  permissions: Array<Permission>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  signups?: Maybe<SignupPaginator>;
  status: UserStatus;
  street?: Maybe<Scalars['String']>;
  tags: Array<Tag>;
  updated_at: Scalars['DateTime'];
};


export type CompanionAttendsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type CompanionEmailsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type CompanionFuture_SignupsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type CompanionOrganisationArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CompanionSignupsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type CompanionMeta = {
  __typename?: 'CompanionMeta';
  can_blind: Scalars['Boolean'];
  can_drive: Scalars['Boolean'];
  can_trainstation_fetch: Scalars['Boolean'];
  can_wheelchair: Scalars['Boolean'];
  can_wheeled_walker: Scalars['Boolean'];
};

export type CompanionMetaInput = {
  can_blind: Scalars['Boolean'];
  can_drive: Scalars['Boolean'];
  can_trainstation_fetch: Scalars['Boolean'];
  can_wheelchair: Scalars['Boolean'];
  can_wheeled_walker: Scalars['Boolean'];
};

/** A paginated list of Companion items. */
export type CompanionPaginator = {
  __typename?: 'CompanionPaginator';
  /** A list of Companion items. */
  data: Array<Companion>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Contact = User & {
  __typename?: 'Contact';
  birthdate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  donor: Donor;
  donor_id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailPaginator>;
  fax?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name: Scalars['String'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  mobile?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  status: UserStatus;
  street?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type ContactDonorArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type ContactEmailsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type CreateAllotmentInput = {
  amount: Scalars['Int'];
  end?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  start: Scalars['DateTime'];
};

export type CreateCategoryInput = {
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateCompanionInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  gdpr_consent?: InputMaybe<Scalars['Boolean']>;
  gdpr_consent_source?: InputMaybe<GdprConsentSource>;
  last_name: Scalars['String'];
  meta: CompanionMetaInput;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<UpdateOrganisationRelation>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<UpdateRolesRelation>;
  status?: InputMaybe<UserStatus>;
  street?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<UpdateTagsRelation>;
};

export type CreateContactInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  donor_id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  street?: InputMaybe<Scalars['String']>;
};

export type CreateDonorInput = {
  city?: InputMaybe<Scalars['String']>;
  locations: UpdateLocationsRelation;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateEmployeeInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  meta: EmployeeMetaInput;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<UpdateRolesRelation>;
  status?: InputMaybe<UserStatus>;
  street?: InputMaybe<Scalars['String']>;
};

export type CreateEventInput = {
  allotment?: InputMaybe<UpdateAllotmentRelation>;
  categories?: InputMaybe<UpdateCategoriesRelation>;
  contact: UpdateContactRelation;
  description?: InputMaybe<Scalars['String']>;
  description_html?: InputMaybe<Scalars['String']>;
  description_markdown?: InputMaybe<Scalars['String']>;
  donor: UpdateDonorRelation;
  end?: InputMaybe<Scalars['DateTime']>;
  location: UpdateLocationRelation;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  reservation_number?: InputMaybe<Scalars['String']>;
  start: Scalars['DateTime'];
  status: EventStatus;
  ticket_retrieval_location?: InputMaybe<Scalars['String']>;
  ticket_retrieval_type?: InputMaybe<EventTicketRetrievalType>;
  ticket_time?: InputMaybe<Scalars['Int']>;
  ticket_type: EventTicketType;
  tickets?: InputMaybe<Scalars['Int']>;
};

export type CreateLocationInput = {
  accessibility_info_audio?: InputMaybe<Scalars['String']>;
  accessibility_info_audio_html?: InputMaybe<Scalars['String']>;
  accessibility_info_audio_markdown?: InputMaybe<Scalars['String']>;
  accessibility_info_physical?: InputMaybe<Scalars['String']>;
  accessibility_info_physical_html?: InputMaybe<Scalars['String']>;
  accessibility_info_physical_markdown?: InputMaybe<Scalars['String']>;
  accessibility_info_visual?: InputMaybe<Scalars['String']>;
  accessibility_info_visual_html?: InputMaybe<Scalars['String']>;
  accessibility_info_visual_markdown?: InputMaybe<Scalars['String']>;
  accessible: Scalars['Boolean'];
  city: Scalars['String'];
  donors: UpdateDonorsRelation;
  meeting_point: Scalars['String'];
  name: Scalars['String'];
  postal_code: Scalars['String'];
  public_transport?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
};

export type CreateMediaInput = {
  file_name: Scalars['String'];
  file_path: Scalars['String'];
};

export type CreateNewsletterInput = {
  body: Scalars['String'];
  events?: InputMaybe<UpdateEventsRelation>;
  segment: MailcoachSegment;
  subject: Scalars['String'];
};

export type CreateOrganisationInput = {
  companions?: InputMaybe<UpdateOrganisationCompanionRelation>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  souls?: InputMaybe<UpdateOrganisationSoulRelation>;
};

export type CreateRoleInput = {
  name: Scalars['String'];
  permissions?: InputMaybe<UpdatePermissionsRelation>;
};

export type CreateSoulInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  gdpr_consent?: InputMaybe<Scalars['Boolean']>;
  gdpr_consent_source?: InputMaybe<GdprConsentSource>;
  last_name: Scalars['String'];
  meta: SoulMetaInput;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<UpdateOrganisationRelation>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  street?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<UpdateTagsRelation>;
};

export type CreateTagInput = {
  description?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  intent: Intent;
  name: Scalars['String'];
};

export type CreateUserInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  street?: InputMaybe<Scalars['String']>;
};

export type DateRange = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type DateTimeRange = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Donor = {
  __typename?: 'Donor';
  city?: Maybe<Scalars['String']>;
  contacts: Array<Contact>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  locations: Array<Location>;
  logo?: Maybe<Media>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  public: Scalars['Boolean'];
  street?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  website?: Maybe<Scalars['String']>;
};


export type DonorContactsArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type DonorLocationsArgs = {
  trashed?: InputMaybe<Trashed>;
};

/** A paginated list of Donor items. */
export type DonorPaginator = {
  __typename?: 'DonorPaginator';
  /** A list of Donor items. */
  data: Array<Donor>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Email = {
  __typename?: 'Email';
  body?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  opened_first_at?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['DateTime']>;
  status: EmailStatus;
  subject: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

/** A paginated list of Email items. */
export type EmailPaginator = {
  __typename?: 'EmailPaginator';
  /** A list of Email items. */
  data: Array<Email>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum EmailStatus {
  Delayed = 'DELAYED',
  Delivered = 'DELIVERED',
  HardBounced = 'HARD_BOUNCED',
  Invalid = 'INVALID',
  MarkedSpam = 'MARKED_SPAM',
  Opened = 'OPENED',
  Queued = 'QUEUED',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
  SoftBounced = 'SOFT_BOUNCED',
  Unknown = 'UNKNOWN'
}

export type EmailUsersInput = {
  body: Scalars['String'];
  subject: Scalars['String'];
  users: Array<Scalars['String']>;
};

export type Employee = User & {
  __typename?: 'Employee';
  birthdate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailPaginator>;
  fax?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name: Scalars['String'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  meta: EmployeeMeta;
  mobile?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  permissions: Array<Permission>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  status: UserStatus;
  street?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type EmployeeEmailsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type EmployeeMeta = {
  __typename?: 'EmployeeMeta';
  position: Scalars['String'];
};

export type EmployeeMetaInput = {
  position: Scalars['String'];
};

/** A paginated list of Employee items. */
export type EmployeePaginator = {
  __typename?: 'EmployeePaginator';
  /** A list of Employee items. */
  data: Array<Employee>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Event = {
  __typename?: 'Event';
  allotment?: Maybe<Allotment>;
  archived_at?: Maybe<Scalars['DateTime']>;
  attendeeCount: Scalars['Int'];
  attendees: Array<Signup>;
  available_tickets?: Maybe<Scalars['Int']>;
  candidateCount: Scalars['Int'];
  candidates: Array<Signup>;
  candidates_chosen: Scalars['Boolean'];
  cardholder?: Maybe<Companion>;
  categories: Array<Category>;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  description_html?: Maybe<Scalars['String']>;
  description_markdown?: Maybe<Scalars['String']>;
  donor?: Maybe<Donor>;
  end?: Maybe<Scalars['DateTime']>;
  groups: Array<Signup>;
  id: Scalars['ID'];
  inviteeCount: Scalars['Int'];
  invitees: Array<Signup>;
  is_archived: Scalars['Boolean'];
  location: Location;
  loneCompanions: Array<Signup>;
  loneSouls: Array<Signup>;
  name: Scalars['String'];
  needsInvite: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  prospectCount: Scalars['Int'];
  prospects: Array<Signup>;
  reservation_number?: Maybe<Scalars['String']>;
  signups: Array<Signup>;
  slug: Scalars['String'];
  start: Scalars['DateTime'];
  status: EventStatus;
  taken_tickets: Scalars['Int'];
  teams: Array<Signup>;
  ticket_retrieval_location?: Maybe<Scalars['String']>;
  ticket_retrieval_type?: Maybe<EventTicketRetrievalType>;
  ticket_time: Scalars['Int'];
  ticket_type: EventTicketType;
  tickets?: Maybe<Scalars['Int']>;
  updated_at: Scalars['DateTime'];
};


export type EventCardholderArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type EventCategoriesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type EventContactArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type EventDonorArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type EventLocationArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type EventSignupsArgs = {
  trashed?: InputMaybe<Trashed>;
};

/** A paginated list of Event items. */
export type EventPaginator = {
  __typename?: 'EventPaginator';
  /** A list of Event items. */
  data: Array<Event>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum EventStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Ready = 'READY'
}

export enum EventTicketRetrievalType {
  Delivery = 'DELIVERY',
  Onsite = 'ONSITE'
}

export enum EventTicketType {
  Allotment = 'ALLOTMENT',
  Fixed = 'FIXED',
  Unlimited = 'UNLIMITED'
}

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export enum GdprConsentSource {
  Employee = 'EMPLOYEE',
  User = 'USER'
}

export type GroupInput = {
  companion: Scalars['ID'];
  souls: Array<Scalars['ID']>;
};

export enum Intent {
  Danger = 'danger',
  None = 'none',
  Primary = 'primary',
  Success = 'success',
  Warning = 'warning'
}

export type Location = {
  __typename?: 'Location';
  accessibility_info_audio?: Maybe<Scalars['String']>;
  accessibility_info_audio_html?: Maybe<Scalars['String']>;
  accessibility_info_audio_markdown?: Maybe<Scalars['String']>;
  accessibility_info_physical?: Maybe<Scalars['String']>;
  accessibility_info_physical_html?: Maybe<Scalars['String']>;
  accessibility_info_physical_markdown?: Maybe<Scalars['String']>;
  accessibility_info_visual?: Maybe<Scalars['String']>;
  accessibility_info_visual_html?: Maybe<Scalars['String']>;
  accessibility_info_visual_markdown?: Maybe<Scalars['String']>;
  accessible: Scalars['Boolean'];
  city: Scalars['String'];
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  donors: Array<Donor>;
  id: Scalars['ID'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  meeting_point: Scalars['String'];
  name: Scalars['String'];
  postal_code: Scalars['String'];
  poster?: Maybe<Media>;
  public_transport?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

/** A paginated list of Location items. */
export type LocationPaginator = {
  __typename?: 'LocationPaginator';
  /** A list of Location items. */
  data: Array<Location>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export enum MailcoachSegment {
  Active = 'ACTIVE',
  All = 'ALL',
  Companions = 'COMPANIONS',
  Souls = 'SOULS'
}

export type Media = {
  __typename?: 'Media';
  id: Scalars['ID'];
  name: Scalars['String'];
  thumb_url?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptSignups?: Maybe<Event>;
  activateCompanion: Companion;
  activateSoul: Soul;
  addSignups?: Maybe<Event>;
  approveCompanion: Companion;
  approveSoul: Soul;
  cancelEvent?: Maybe<Event>;
  createAllotment: Allotment;
  createCategory: Category;
  createCompanion: Companion;
  createContact: Contact;
  createDonor: Donor;
  createEmployee: Employee;
  createEvent: Event;
  createLocation: Location;
  createNewsletter: Newsletter;
  createOrganisation: Organisation;
  createRole: Role;
  createSoul: Soul;
  createTag: Tag;
  deactivateCompanion: Companion;
  deactivateSoul: Soul;
  deleteAllotment?: Maybe<Allotment>;
  deleteCategory?: Maybe<Category>;
  deleteCompanion: Companion;
  deleteContact: Contact;
  deleteDonor: Donor;
  deleteEmployee: Employee;
  deleteEvent?: Maybe<Event>;
  deleteLocation: Location;
  deleteNewsletter?: Maybe<Newsletter>;
  deleteOrganisation: Organisation;
  deleteRole?: Maybe<Role>;
  deleteSignup?: Maybe<Signup>;
  deleteSoul: Soul;
  deleteTag?: Maybe<Tag>;
  denyCompanion: Companion;
  denySoul: Soul;
  emailUsers?: Maybe<Scalars['Boolean']>;
  emptyCategoryTrash: Array<Maybe<Category>>;
  emptyCompanionTrash: Array<Maybe<Companion>>;
  emptyContactTrash: Array<Maybe<Contact>>;
  emptyDonorTrash: Array<Maybe<Donor>>;
  emptyEmployeeTrash: Array<Maybe<Employee>>;
  emptyEventTrash: Array<Maybe<Event>>;
  emptyLocationTrash: Array<Maybe<Location>>;
  emptyOrganisationTrash: Array<Maybe<Organisation>>;
  emptySoulTrash: Array<Maybe<Soul>>;
  forceDeleteCategories: Array<Maybe<Category>>;
  forceDeleteCompanions: Array<Maybe<Companion>>;
  forceDeleteContacts: Array<Maybe<Contact>>;
  forceDeleteDonors: Array<Maybe<Donor>>;
  forceDeleteEmployees: Array<Maybe<Employee>>;
  forceDeleteEvents: Array<Maybe<Event>>;
  forceDeleteLocations: Array<Maybe<Location>>;
  forceDeleteOrganisations: Array<Maybe<Organisation>>;
  forceDeleteSouls: Array<Maybe<Soul>>;
  forgotPassword: ForgotPasswordResponse;
  inviteCandidates?: Maybe<Event>;
  login: AuthPayload;
  logout: LogoutResponse;
  publishEvent?: Maybe<Event>;
  regenerateApiKey: Tenant;
  restoreCategories: Array<Maybe<Category>>;
  restoreCompanions: Array<Maybe<Companion>>;
  restoreContacts: Array<Maybe<Contact>>;
  restoreDonors: Array<Maybe<Donor>>;
  restoreEmployees: Array<Maybe<Employee>>;
  restoreEvents: Array<Maybe<Event>>;
  restoreLocations: Array<Maybe<Location>>;
  restoreOrganisations: Array<Maybe<Organisation>>;
  restoreSouls: Array<Maybe<Soul>>;
  sendResetLinkForUser?: Maybe<Scalars['Boolean']>;
  setDonorLogo?: Maybe<Donor>;
  setLocationPoster?: Maybe<Location>;
  updateAllotment?: Maybe<Allotment>;
  updateCandidates?: Maybe<Event>;
  updateCategory?: Maybe<Category>;
  updateCompanion?: Maybe<Companion>;
  updateContact?: Maybe<Contact>;
  updateDonor?: Maybe<Donor>;
  updateEmployee?: Maybe<Employee>;
  updateEvent?: Maybe<Event>;
  updateForgottenPassword: ForgotPasswordResponse;
  updateLocation?: Maybe<Location>;
  updateOrganisation?: Maybe<Organisation>;
  updateRole?: Maybe<Role>;
  updateSoul?: Maybe<Soul>;
  updateTag?: Maybe<Tag>;
  updateTenant?: Maybe<Tenant>;
};


export type MutationAcceptSignupsArgs = {
  id: Scalars['ID'];
  token: Scalars['String'];
};


export type MutationActivateCompanionArgs = {
  id: Scalars['ID'];
};


export type MutationActivateSoulArgs = {
  id: Scalars['ID'];
};


export type MutationAddSignupsArgs = {
  input: AddSignupsInput;
};


export type MutationApproveCompanionArgs = {
  id: Scalars['ID'];
};


export type MutationApproveSoulArgs = {
  id: Scalars['ID'];
};


export type MutationCancelEventArgs = {
  input: CancelEventInput;
};


export type MutationCreateAllotmentArgs = {
  input: CreateAllotmentInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCompanionArgs = {
  input: CreateCompanionInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateDonorArgs = {
  input: CreateDonorInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateNewsletterArgs = {
  input: CreateNewsletterInput;
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSoulArgs = {
  input: CreateSoulInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationDeactivateCompanionArgs = {
  id: Scalars['ID'];
};


export type MutationDeactivateSoulArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAllotmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCompanionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDonorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNewsletterArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSignupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSoulArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID'];
};


export type MutationDenyCompanionArgs = {
  id: Scalars['ID'];
};


export type MutationDenySoulArgs = {
  id: Scalars['ID'];
};


export type MutationEmailUsersArgs = {
  input: EmailUsersInput;
};


export type MutationForceDeleteCategoriesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteCompanionsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteContactsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteDonorsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteEmployeesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteEventsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteLocationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteOrganisationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForceDeleteSoulsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationInviteCandidatesArgs = {
  id: Scalars['ID'];
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};


export type MutationPublishEventArgs = {
  id: Scalars['ID'];
};


export type MutationRegenerateApiKeyArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreCategoriesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreCompanionsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreContactsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreDonorsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreEmployeesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreEventsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreLocationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreOrganisationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRestoreSoulsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationSendResetLinkForUserArgs = {
  id: Scalars['ID'];
};


export type MutationSetDonorLogoArgs = {
  input: SetMediaInput;
};


export type MutationSetLocationPosterArgs = {
  input: SetMediaInput;
};


export type MutationUpdateAllotmentArgs = {
  input: UpdateAllotmentInput;
};


export type MutationUpdateCandidatesArgs = {
  input: UpdateCandidatesInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateCompanionArgs = {
  input: UpdateCompanionInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateDonorArgs = {
  input: UpdateDonorInput;
};


export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateForgottenPasswordArgs = {
  input?: InputMaybe<NewPasswordWithCodeInput>;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSoulArgs = {
  input: UpdateSoulInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};

export type NewPasswordWithCodeInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  token: Scalars['String'];
};

export type Newsletter = {
  __typename?: 'Newsletter';
  body: Scalars['String'];
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['ID'];
  segment: MailcoachSegment;
  sent_at?: Maybe<Scalars['DateTime']>;
  status: NewsletterStatus;
  subject: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

/** A paginated list of Newsletter items. */
export type NewsletterPaginator = {
  __typename?: 'NewsletterPaginator';
  /** A list of Newsletter items. */
  data: Array<Newsletter>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum NewsletterStatus {
  Draft = 'DRAFT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Organisation = {
  __typename?: 'Organisation';
  companions: Array<Companion>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  souls: Array<Soul>;
  updated_at: Scalars['DateTime'];
};

export type OverviewStatsInput = {
  range: Scalars['String'];
  range_type: StatsRangeType;
};

export type OverviewStatsPayload = {
  __typename?: 'OverviewStatsPayload';
  attends: Scalars['Int'];
  signups: Scalars['Int'];
  tickets: Scalars['Int'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type Permission = {
  __typename?: 'Permission';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  title: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type Query = {
  __typename?: 'Query';
  allotment?: Maybe<Allotment>;
  allotments: Array<Allotment>;
  categories: Array<Category>;
  category?: Maybe<Category>;
  categoryStats: Array<CategoryStatsPayload>;
  companion?: Maybe<Companion>;
  companions?: Maybe<CompanionPaginator>;
  contact?: Maybe<Contact>;
  contacts: Array<Contact>;
  currentTenant: Tenant;
  donor?: Maybe<Donor>;
  donors?: Maybe<DonorPaginator>;
  email?: Maybe<Email>;
  employee?: Maybe<Employee>;
  employees?: Maybe<EmployeePaginator>;
  event?: Maybe<Event>;
  events?: Maybe<EventPaginator>;
  isAuthenticated: Scalars['Boolean'];
  location?: Maybe<Location>;
  locations?: Maybe<LocationPaginator>;
  newsletter?: Maybe<Newsletter>;
  newsletters?: Maybe<NewsletterPaginator>;
  organisation?: Maybe<Organisation>;
  organisations: Array<Organisation>;
  overviewStats: OverviewStatsPayload;
  permission?: Maybe<Permission>;
  permissions: Array<Permission>;
  role?: Maybe<Role>;
  roles: Array<Role>;
  signup?: Maybe<Signup>;
  soul?: Maybe<Soul>;
  souls?: Maybe<SoulPaginator>;
  tag?: Maybe<Tag>;
  tags: Array<Tag>;
  targetGroupStats: Array<TargetGroupStatsPayload>;
  tenant?: Maybe<Tenant>;
};


export type QueryAllotmentArgs = {
  id: Scalars['ID'];
};


export type QueryCategoriesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryCategoryStatsArgs = {
  input: CategoryStatsInput;
};


export type QueryCompanionArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryCompanionsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryCompanionsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<UserStatus>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryContactArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryContactsArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryDonorArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryDonorsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryEmailArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryEmployeeArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryEmployeesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<UserStatus>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryEventArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryEventsArgs = {
  donor?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  onlyArchived?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<QueryEventsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<DateTimeRange>;
  status?: InputMaybe<EventStatus>;
  trashed?: InputMaybe<Trashed>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryLocationsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryNewsletterArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryNewslettersArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  sent_at?: InputMaybe<DateTimeRange>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryOrganisationArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryOrganisationsArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryOverviewStatsArgs = {
  input: OverviewStatsInput;
};


export type QueryPermissionArgs = {
  id: Scalars['ID'];
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QuerySignupArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QuerySoulArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QuerySoulsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QuerySoulsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<UserStatus>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTargetGroupStatsArgs = {
  input: TargetGroupStatsInput;
};


export type QueryTenantArgs = {
  id: Scalars['ID'];
};

/** Allowed column names for Query.companions.orderBy. */
export enum QueryCompanionsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.companions.orderBy. */
export type QueryCompanionsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryCompanionsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.events.orderBy. */
export enum QueryEventsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Start = 'START'
}

/** Order by clause for Query.events.orderBy. */
export type QueryEventsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryEventsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.souls.orderBy. */
export enum QuerySoulsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.souls.orderBy. */
export type QuerySoulsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QuerySoulsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type RegisterInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions: Array<Permission>;
  updated_at: Scalars['DateTime'];
};

export type SetMediaInput = {
  id: Scalars['ID'];
  image: UpdateMediaInput;
};

export type Signup = {
  __typename?: 'Signup';
  companion?: Maybe<Companion>;
  conflicting_signups: Array<Signup>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  emails: Array<Email>;
  event: Event;
  event_id: Scalars['String'];
  has_accepted: Scalars['Boolean'];
  has_rejected: Scalars['Boolean'];
  id: Scalars['ID'];
  is_candidate: Scalars['Boolean'];
  is_cardholder: Scalars['Boolean'];
  is_companion: Scalars['Boolean'];
  is_first_attend: Scalars['Boolean'];
  is_invited: Scalars['Boolean'];
  is_soul: Scalars['Boolean'];
  leaderSignup?: Maybe<Signup>;
  memberSignups: Array<Signup>;
  notes?: Maybe<Scalars['String']>;
  priority: Scalars['Int'];
  soul?: Maybe<Soul>;
  token: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

/** A paginated list of Signup items. */
export type SignupPaginator = {
  __typename?: 'SignupPaginator';
  /** A list of Signup items. */
  data: Array<Signup>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Soul = User & {
  __typename?: 'Soul';
  attends?: Maybe<SignupPaginator>;
  birthdate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailPaginator>;
  fax?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  future_signups?: Maybe<SignupPaginator>;
  gdpr_consent: Scalars['Boolean'];
  gdpr_consent_source?: Maybe<GdprConsentSource>;
  id: Scalars['ID'];
  last_name: Scalars['String'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  meta: SoulMeta;
  mobile?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organisation?: Maybe<Organisation>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  signups?: Maybe<SignupPaginator>;
  status: UserStatus;
  street?: Maybe<Scalars['String']>;
  tags: Array<Tag>;
  updated_at: Scalars['DateTime'];
};


export type SoulAttendsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type SoulEmailsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type SoulFuture_SignupsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type SoulOrganisationArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SoulSignupsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type SoulMeta = {
  __typename?: 'SoulMeta';
  buys_ticket: Scalars['Boolean'];
  needs_blind: Scalars['Boolean'];
  needs_drive: Scalars['Boolean'];
  needs_trainstation_fetch: Scalars['Boolean'];
  needs_wheelchair: Scalars['Boolean'];
  needs_wheeled_walker: Scalars['Boolean'];
  target_group: SoulTargetGroup;
};

export type SoulMetaInput = {
  buys_ticket: Scalars['Boolean'];
  needs_blind: Scalars['Boolean'];
  needs_drive: Scalars['Boolean'];
  needs_trainstation_fetch: Scalars['Boolean'];
  needs_wheelchair: Scalars['Boolean'];
  needs_wheeled_walker: Scalars['Boolean'];
  target_group: SoulTargetGroup;
};

/** A paginated list of Soul items. */
export type SoulPaginator = {
  __typename?: 'SoulPaginator';
  /** A list of Soul items. */
  data: Array<Soul>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum SoulTargetGroup {
  Child = 'CHILD',
  Disabled = 'DISABLED',
  Immigrant = 'IMMIGRANT',
  None = 'NONE',
  Senior = 'SENIOR',
  SociallyInNeed = 'SOCIALLY_IN_NEED'
}

export enum StatsRangeType {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type Tag = {
  __typename?: 'Tag';
  created_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  icon: Scalars['String'];
  id: Scalars['ID'];
  intent: Intent;
  name: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type TargetGroupDataPayload = {
  __typename?: 'TargetGroupDataPayload';
  attends: Scalars['Int'];
  previous_attends: Scalars['Int'];
  previous_signups: Scalars['Int'];
  signups: Scalars['Int'];
};

export type TargetGroupStatsInput = {
  categories?: InputMaybe<Array<Scalars['ID']>>;
  range: Scalars['String'];
  range_type: StatsRangeType;
};

export type TargetGroupStatsPayload = {
  __typename?: 'TargetGroupStatsPayload';
  data: TargetGroupDataPayload;
  target_group: SoulTargetGroup;
};

export type Tenant = {
  __typename?: 'Tenant';
  id: Scalars['ID'];
  legacy_api_key: Scalars['String'];
  name: Scalars['String'];
  redirect_events?: Maybe<Scalars['String']>;
  redirect_password_reset?: Maybe<Scalars['String']>;
  redirect_ticket_accept_not_found?: Maybe<Scalars['String']>;
  redirect_ticket_accept_ok?: Maybe<Scalars['String']>;
  subdomain: Scalars['String'];
  use_legacy_newsletter: Scalars['Boolean'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdateAllotmentInput = {
  amount?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateAllotmentRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCandidatesInput = {
  candidates: CandidatesInput;
  id: Scalars['ID'];
};

export type UpdateCategoriesRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateCategoryInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanionInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gdpr_consent?: InputMaybe<Scalars['Boolean']>;
  gdpr_consent_source?: InputMaybe<GdprConsentSource>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<CompanionMetaInput>;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<UpdateOrganisationRelation>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<UpdateTagsRelation>;
};

export type UpdateContactInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  donor_id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  street?: InputMaybe<Scalars['String']>;
};

export type UpdateContactRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDonorInput = {
  city?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  locations?: InputMaybe<UpdateLocationsRelation>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateDonorRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDonorsRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateEmployeeInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<EmployeeMetaInput>;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<UpdateRolesRelation>;
  street?: InputMaybe<Scalars['String']>;
};

export type UpdateEventInput = {
  allotment?: InputMaybe<UpdateAllotmentRelation>;
  categories?: InputMaybe<UpdateCategoriesRelation>;
  contact?: InputMaybe<UpdateContactRelation>;
  description?: InputMaybe<Scalars['String']>;
  description_html?: InputMaybe<Scalars['String']>;
  description_markdown?: InputMaybe<Scalars['String']>;
  donor?: InputMaybe<UpdateDonorRelation>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location?: InputMaybe<UpdateLocationRelation>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reservation_number?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<EventStatus>;
  ticket_retrieval_location?: InputMaybe<Scalars['String']>;
  ticket_retrieval_type?: InputMaybe<EventTicketRetrievalType>;
  ticket_time?: InputMaybe<Scalars['Int']>;
  ticket_type?: InputMaybe<EventTicketType>;
  tickets?: InputMaybe<Scalars['Int']>;
};

export type UpdateEventsRelation = {
  sync: Array<Scalars['ID']>;
};

export type UpdateLocationInput = {
  accessibility_info_audio?: InputMaybe<Scalars['String']>;
  accessibility_info_audio_html?: InputMaybe<Scalars['String']>;
  accessibility_info_audio_markdown?: InputMaybe<Scalars['String']>;
  accessibility_info_physical?: InputMaybe<Scalars['String']>;
  accessibility_info_physical_html?: InputMaybe<Scalars['String']>;
  accessibility_info_physical_markdown?: InputMaybe<Scalars['String']>;
  accessibility_info_visual?: InputMaybe<Scalars['String']>;
  accessibility_info_visual_html?: InputMaybe<Scalars['String']>;
  accessibility_info_visual_markdown?: InputMaybe<Scalars['String']>;
  accessible?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  donors?: InputMaybe<UpdateDonorsRelation>;
  id: Scalars['ID'];
  meeting_point?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  public_transport?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type UpdateLocationRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateLocationsRelation = {
  create?: InputMaybe<Array<CreateLocationInput>>;
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateMediaInput = {
  create?: InputMaybe<CreateMediaInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNewsletterInput = {
  body: Scalars['String'];
  events?: InputMaybe<UpdateEventsRelation>;
  id: Scalars['ID'];
  segment: MailcoachSegment;
  subject: Scalars['String'];
};

export type UpdateOrganisationCompanionRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateOrganisationInput = {
  companions?: InputMaybe<UpdateOrganisationCompanionRelation>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  souls?: InputMaybe<UpdateOrganisationSoulRelation>;
};

export type UpdateOrganisationRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganisationSoulRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdatePermissionsRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<UpdatePermissionsRelation>;
};

export type UpdateRolesRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateSoulInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gdpr_consent?: InputMaybe<Scalars['Boolean']>;
  gdpr_consent_source?: InputMaybe<GdprConsentSource>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<SoulMetaInput>;
  mobile?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<UpdateOrganisationRelation>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<UpdateTagsRelation>;
};

export type UpdateTagInput = {
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  intent?: InputMaybe<Intent>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTagsRelation = {
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateTenantInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  redirect_events?: InputMaybe<Scalars['String']>;
  redirect_password_reset?: InputMaybe<Scalars['String']>;
  redirect_ticket_accept_not_found?: InputMaybe<Scalars['String']>;
  redirect_ticket_accept_ok?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  birthdate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type User = {
  birthdate?: Maybe<Scalars['Date']>;
  city?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name: Scalars['String'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  mobile?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  status: UserStatus;
  street?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  New = 'NEW',
  Passive = 'PASSIVE'
}

export type AttendListItemFragment = { __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> }, leaderSignup?: { __typename?: 'Signup', id: string, companion?: { __typename?: 'Companion', id: string, display_name: string } | null } | null, memberSignups: Array<{ __typename?: 'Signup', id: string, soul?: { __typename?: 'Soul', id: string, display_name: string } | null }> };

export type FutureSignupListItemFragment = { __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, event: { __typename?: 'Event', id: string, name: string, status: EventStatus, candidates_chosen: boolean, start: string, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } };

export type PersonOrganisationSelectFragment = { __typename?: 'Organisation', id: string, name: string };

export type PersonTagIconFragment = { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent };

export type PersonTagMultiSelectFragment = { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent };

export type AllotmentCreateFormFragment = { __typename?: 'Allotment', name: string, amount: number, start: string, end?: string | null };

export type AllotmentEditFormFragment = { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null };

export type AllotmentListItemFragment = { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null };

export type AllotmentDetailPageFragment = { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null };

export type AllotmentListQueryVariables = Exact<{ [key: string]: never; }>;


export type AllotmentListQuery = { __typename?: 'Query', allotments: Array<{ __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null }> };

export type AllotmentDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AllotmentDetailQuery = { __typename?: 'Query', allotment?: { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null } | null };

export type AllotmentEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AllotmentEditQuery = { __typename?: 'Query', allotment?: { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null } | null };

export type CreateAllotmentMutationVariables = Exact<{
  input: CreateAllotmentInput;
}>;


export type CreateAllotmentMutation = { __typename?: 'Mutation', createAllotment: { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null } };

export type UpdateAllotmentMutationVariables = Exact<{
  input: UpdateAllotmentInput;
}>;


export type UpdateAllotmentMutation = { __typename?: 'Mutation', updateAllotment?: { __typename?: 'Allotment', id: string, name: string, status: AllotmentStatus, amount: number, amount_left: number, start: string, end?: string | null } | null };

export type DeleteAllotmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAllotmentMutation = { __typename?: 'Mutation', deleteAllotment?: { __typename?: 'Allotment', id: string } | null };

export type AttendeeGroupFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type AcceptSignupsFragment = { __typename?: 'Event', id: string, signups: Array<{ __typename?: 'Signup', id: string, token: string, has_accepted: boolean, has_rejected: boolean }> };

export type AttendeeListItemFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type AttendeeLoneCompanionFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type AttendeeLoneSoulFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type AttendeeTeamFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type IsUserAuthenticatedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsUserAuthenticatedQuery = { __typename?: 'Query', isAuthenticated: boolean };

export type CurrentTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTenantQuery = { __typename?: 'Query', currentTenant: { __typename?: 'Tenant', id: string, subdomain: string, name: string, use_legacy_newsletter: boolean } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', user: { __typename?: 'Employee', id: string, email?: string | null, display_name: string, permissions: Array<{ __typename?: 'Permission', id: string, name: string }> } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', status: string, message?: string | null } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponse', status: string, message?: string | null } };

export type UpdateForgottenPasswordMutationVariables = Exact<{
  input: NewPasswordWithCodeInput;
}>;


export type UpdateForgottenPasswordMutation = { __typename?: 'Mutation', updateForgottenPassword: { __typename?: 'ForgotPasswordResponse', status: string, message?: string | null } };

export type CategoryCreateFormFragment = { __typename?: 'Category', name: string, description?: string | null, color: string };

export type CategoryEditFormFragment = { __typename?: 'Category', id: string, name: string, description?: string | null, color: string };

export type CategoryListItemFragment = { __typename?: 'Category', id: string, name: string, description?: string | null, color: string };

export type CategoryDetailPageFragment = { __typename?: 'Category', id: string, name: string, description?: string | null, color: string };

export type CategoryListQueryVariables = Exact<{
  trashed?: InputMaybe<Trashed>;
}>;


export type CategoryListQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, description?: string | null, color: string }> };

export type CategoryDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CategoryDetailQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: string, name: string, description?: string | null, color: string } | null };

export type CategoryEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CategoryEditQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: string, name: string, description?: string | null, color: string } | null };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'Category', id: string, name: string, description?: string | null, color: string } };

export type UpdateCategoryMutationVariables = Exact<{
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'Category', id: string, name: string, description?: string | null, color: string } | null };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory?: { __typename?: 'Category', id: string } | null };

export type RestoreCategoriesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreCategoriesMutation = { __typename?: 'Mutation', restoreCategories: Array<{ __typename?: 'Category', id: string } | null> };

export type ForceDeleteCategoriesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteCategoriesMutation = { __typename?: 'Mutation', forceDeleteCategories: Array<{ __typename?: 'Category', id: string } | null> };

export type EmptyCategoryTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyCategoryTrashMutation = { __typename?: 'Mutation', emptyCategoryTrash: Array<{ __typename?: 'Category', id: string } | null> };

export type CompanionCreateFormFragment = { __typename?: 'Companion', notes?: string | null, first_name: string, last_name: string, status: UserStatus, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean, can_trainstation_fetch: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type CompanionEditFormFragment = { __typename?: 'Companion', id: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean, can_trainstation_fetch: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type CompanionInfoFragment = { __typename?: 'Companion', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type CompanionListItemFragment = { __typename?: 'Companion', id: string, status: UserStatus, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type CompanionListQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
  orderByColumn?: InputMaybe<QueryCompanionsOrderByColumn>;
  orderByOrder?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
}>;


export type CompanionListQuery = { __typename?: 'Query', companions?: { __typename?: 'CompanionPaginator', data: Array<{ __typename?: 'Companion', id: string, status: UserStatus, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type CompanionDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanionDetailQuery = { __typename?: 'Query', companion?: { __typename?: 'Companion', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null };

export type CompanionEmailsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type CompanionEmailsQuery = { __typename?: 'Query', companion?: { __typename?: 'Companion', id: string, emails?: { __typename?: 'EmailPaginator', data: Array<{ __typename?: 'Email', id: string, status: EmailStatus, subject: string, sent_at?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, hasMorePages: boolean, lastPage: number } } | null } | null };

export type CompanionEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanionEditQuery = { __typename?: 'Query', companion?: { __typename?: 'Companion', id: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean, can_trainstation_fetch: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null };

export type CreateCompanionMutationVariables = Exact<{
  input: CreateCompanionInput;
}>;


export type CreateCompanionMutation = { __typename?: 'Mutation', createCompanion: { __typename?: 'Companion', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } };

export type UpdateCompanionMutationVariables = Exact<{
  input: UpdateCompanionInput;
}>;


export type UpdateCompanionMutation = { __typename?: 'Mutation', updateCompanion?: { __typename?: 'Companion', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null };

export type ApproveCompanionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveCompanionMutation = { __typename?: 'Mutation', approveCompanion: { __typename?: 'Companion', id: string, status: UserStatus } };

export type DenyCompanionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DenyCompanionMutation = { __typename?: 'Mutation', denyCompanion: { __typename?: 'Companion', id: string, status: UserStatus } };

export type ActivateCompanionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateCompanionMutation = { __typename?: 'Mutation', activateCompanion: { __typename?: 'Companion', id: string, status: UserStatus } };

export type DeactivateCompanionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateCompanionMutation = { __typename?: 'Mutation', deactivateCompanion: { __typename?: 'Companion', id: string, status: UserStatus } };

export type DeleteCompanionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCompanionMutation = { __typename?: 'Mutation', deleteCompanion: { __typename?: 'Companion', id: string } };

export type RestoreCompanionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreCompanionsMutation = { __typename?: 'Mutation', restoreCompanions: Array<{ __typename?: 'Companion', id: string } | null> };

export type ForceDeleteCompanionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteCompanionsMutation = { __typename?: 'Mutation', forceDeleteCompanions: Array<{ __typename?: 'Companion', id: string } | null> };

export type EmptyCompanionTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyCompanionTrashMutation = { __typename?: 'Mutation', emptyCompanionTrash: Array<{ __typename?: 'Companion', id: string } | null> };

export type ContactCreateFormFragment = { __typename?: 'Contact', first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, donor_id: string };

export type ContactEditFormFragment = { __typename?: 'Contact', id: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null };

export type ContactInfoFragment = { __typename?: 'Contact', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null };

export type ContactListItemFragment = { __typename?: 'Contact', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null };

export type ContactListQueryVariables = Exact<{
  trashed?: InputMaybe<Trashed>;
}>;


export type ContactListQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'Contact', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null }> };

export type ContactDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactDetailQuery = { __typename?: 'Query', contact?: { __typename?: 'Contact', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null } | null };

export type ContactEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactEditQuery = { __typename?: 'Query', contact?: { __typename?: 'Contact', id: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null } | null };

export type ContactEmailsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type ContactEmailsQuery = { __typename?: 'Query', contact?: { __typename?: 'Contact', id: string, emails?: { __typename?: 'EmailPaginator', data: Array<{ __typename?: 'Email', id: string, status: EmailStatus, subject: string, sent_at?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, hasMorePages: boolean, lastPage: number } } | null } | null };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'Contact', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null } | null };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: { __typename?: 'Contact', id: string } };

export type RestoreContactsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreContactsMutation = { __typename?: 'Mutation', restoreContacts: Array<{ __typename?: 'Contact', id: string } | null> };

export type ForceDeleteContactsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteContactsMutation = { __typename?: 'Mutation', forceDeleteContacts: Array<{ __typename?: 'Contact', id: string } | null> };

export type EmptyContactTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyContactTrashMutation = { __typename?: 'Mutation', emptyContactTrash: Array<{ __typename?: 'Contact', id: string } | null> };

export type DonorCreateFormFragment = { __typename?: 'Donor', name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, public: boolean, website?: string | null, logo?: { __typename?: 'Media', name: string, url: string } | null, locations: Array<{ __typename?: 'Location', id: string }> };

export type DonorEditFormFragment = { __typename?: 'Donor', id: string, name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, public: boolean, website?: string | null, logo?: { __typename?: 'Media', name: string, url: string } | null, locations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type DonorInfoFragment = { __typename?: 'Donor', id: string, name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, website?: string | null, public: boolean, logo?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null };

export type DonorListItemFragment = { __typename?: 'Donor', id: string, name: string, contacts: Array<{ __typename?: 'Contact', id: string, display_name: string }> };

export type DonorListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
}>;


export type DonorListQuery = { __typename?: 'Query', donors?: { __typename?: 'DonorPaginator', data: Array<{ __typename?: 'Donor', id: string, name: string, contacts: Array<{ __typename?: 'Contact', id: string, display_name: string }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type DonorDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DonorDetailQuery = { __typename?: 'Query', donor?: { __typename?: 'Donor', id: string, name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, website?: string | null, public: boolean, logo?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } | null };

export type DonorContactsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DonorContactsQuery = { __typename?: 'Query', donor?: { __typename?: 'Donor', id: string, contacts: Array<{ __typename?: 'Contact', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null }> } | null };

export type DonorContactSelectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DonorContactSelectQuery = { __typename?: 'Query', donor?: { __typename?: 'Donor', id: string, contacts: Array<{ __typename?: 'Contact', id: string, display_name: string }> } | null };

export type DonorLocationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DonorLocationsQuery = { __typename?: 'Query', donor?: { __typename?: 'Donor', id: string, locations: Array<{ __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean }> } | null };

export type DonorLocationSelectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DonorLocationSelectQuery = { __typename?: 'Query', donor?: { __typename?: 'Donor', id: string, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null };

export type CreateDonorMutationVariables = Exact<{
  input: CreateDonorInput;
}>;


export type CreateDonorMutation = { __typename?: 'Mutation', createDonor: { __typename?: 'Donor', id: string, name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, website?: string | null, public: boolean, logo?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } };

export type DonorEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DonorEditQuery = { __typename?: 'Query', donor?: { __typename?: 'Donor', id: string, name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, public: boolean, website?: string | null, logo?: { __typename?: 'Media', name: string, url: string } | null, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null };

export type UpdateDonorMutationVariables = Exact<{
  input: UpdateDonorInput;
}>;


export type UpdateDonorMutation = { __typename?: 'Mutation', updateDonor?: { __typename?: 'Donor', id: string, name: string, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, website?: string | null, public: boolean, logo?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } | null };

export type SetDonorLogoMutationVariables = Exact<{
  input: SetMediaInput;
}>;


export type SetDonorLogoMutation = { __typename?: 'Mutation', setDonorLogo?: { __typename?: 'Donor', id: string, logo?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } | null };

export type DeleteDonorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDonorMutation = { __typename?: 'Mutation', deleteDonor: { __typename?: 'Donor', id: string } };

export type RestoreDonorsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreDonorsMutation = { __typename?: 'Mutation', restoreDonors: Array<{ __typename?: 'Donor', id: string } | null> };

export type ForceDeleteDonorsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteDonorsMutation = { __typename?: 'Mutation', forceDeleteDonors: Array<{ __typename?: 'Donor', id: string } | null> };

export type EmptyDonorTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyDonorTrashMutation = { __typename?: 'Mutation', emptyDonorTrash: Array<{ __typename?: 'Donor', id: string } | null> };

export type EmailListItemFragment = { __typename?: 'Email', id: string, status: EmailStatus, subject: string, sent_at?: string | null };

export type EmailOverlayFragment = { __typename?: 'Email', id: string, status: EmailStatus, reason?: string | null, subject: string, sent_at?: string | null, body?: string | null };

export type EmailDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmailDetailsQuery = { __typename?: 'Query', email?: { __typename?: 'Email', id: string, status: EmailStatus, reason?: string | null, subject: string, sent_at?: string | null, body?: string | null } | null };

export type EmployeeCreateFormFragment = { __typename?: 'Employee', status: UserStatus, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string }>, meta: { __typename?: 'EmployeeMeta', position: string } };

export type EmployeeEditFormFragment = { __typename?: 'Employee', id: string, status: UserStatus, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } };

export type EmployeeInfoFragment = { __typename?: 'Employee', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } };

export type EmployeeListItemFragment = { __typename?: 'Employee', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } };

export type RoleMultiSelectFragment = { __typename?: 'Role', id: string, name: string };

export type EmployeeListQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
}>;


export type EmployeeListQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeePaginator', data: Array<{ __typename?: 'Employee', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type EmployeeDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmployeeDetailQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } } | null };

export type EmployeeEmailsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type EmployeeEmailsQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', id: string, emails?: { __typename?: 'EmailPaginator', data: Array<{ __typename?: 'Email', id: string, status: EmailStatus, subject: string, sent_at?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, hasMorePages: boolean, lastPage: number } } | null } | null };

export type EmployeeEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmployeeEditQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', id: string, status: UserStatus, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } } | null };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } } };

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee?: { __typename?: 'Employee', id: string, display_name: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, meta: { __typename?: 'EmployeeMeta', position: string } } | null };

export type DeleteEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee: { __typename?: 'Employee', id: string } };

export type RestoreEmployeesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreEmployeesMutation = { __typename?: 'Mutation', restoreEmployees: Array<{ __typename?: 'Employee', id: string } | null> };

export type ForceDeleteEmployeesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteEmployeesMutation = { __typename?: 'Mutation', forceDeleteEmployees: Array<{ __typename?: 'Employee', id: string } | null> };

export type EmptyEmployeeTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyEmployeeTrashMutation = { __typename?: 'Mutation', emptyEmployeeTrash: Array<{ __typename?: 'Employee', id: string } | null> };

export type AllotmentSelectFragment = { __typename?: 'Allotment', id: string, name: string };

export type CategoryMultiSelectFragment = { __typename?: 'Category', id: string, name: string };

export type ContactSelectFragment = { __typename?: 'Contact', id: string, display_name: string };

export type EventCreateFormFragment = { __typename?: 'Event', name: string, status: EventStatus, description?: string | null, description_markdown?: string | null, description_html?: string | null, start: string, end?: string | null, tickets?: number | null, ticket_time: number, ticket_type: EventTicketType, reservation_number?: string | null, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, notes?: string | null, categories: Array<{ __typename?: 'Category', id: string }>, donor?: { __typename?: 'Donor', id: string } | null, contact?: { __typename?: 'Contact', id: string } | null, location: { __typename?: 'Location', id: string }, allotment?: { __typename?: 'Allotment', id: string } | null };

export type EventEditFormFragment = { __typename?: 'Event', id: string, name: string, status: EventStatus, description?: string | null, description_markdown?: string | null, description_html?: string | null, start: string, end?: string | null, tickets?: number | null, ticket_time: number, ticket_type: EventTicketType, reservation_number?: string | null, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, notes?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string }>, donor?: { __typename?: 'Donor', id: string, name: string } | null, contact?: { __typename?: 'Contact', id: string, display_name: string } | null, location: { __typename?: 'Location', id: string, name: string }, allotment?: { __typename?: 'Allotment', id: string, name: string } | null };

export type EventListItemFragment = { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, available_tickets?: number | null, taken_tickets: number, is_archived: boolean, candidateCount: number, attendeeCount: number, attendees: Array<{ __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean }>, signups: Array<{ __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean }>, location: { __typename?: 'Location', id: string, name: string, accessible: boolean } };

export type LocationSelectFragment = { __typename?: 'Location', id: string, name: string };

export type RemoveSignupFragment = { __typename?: 'Event', prospects: Array<{ __typename?: 'Signup', id: string }>, signups: Array<{ __typename?: 'Signup', id: string }> };

export type SignupListItemFragment = { __typename?: 'Signup', id: string, event_id: string, notes?: string | null, companion?: { __typename?: 'Companion', id: string, display_name: string, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type EventDetailPageFragment = { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> };

export type EventListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<EventStatus>;
  start?: InputMaybe<DateTimeRange>;
  donor?: InputMaybe<Scalars['Int']>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']>;
  orderByColumn?: InputMaybe<QueryEventsOrderByColumn>;
  orderByOrder?: InputMaybe<SortOrder>;
  trashed?: InputMaybe<Trashed>;
}>;


export type EventListQuery = { __typename?: 'Query', events?: { __typename?: 'EventPaginator', data: Array<{ __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, available_tickets?: number | null, taken_tickets: number, is_archived: boolean, candidateCount: number, attendeeCount: number, attendees: Array<{ __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean }>, signups: Array<{ __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean }>, location: { __typename?: 'Location', id: string, name: string, accessible: boolean } }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type EventDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventDetailQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type EventEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventEditQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name: string, status: EventStatus, description?: string | null, description_markdown?: string | null, description_html?: string | null, start: string, end?: string | null, tickets?: number | null, ticket_time: number, ticket_type: EventTicketType, reservation_number?: string | null, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, notes?: string | null, categories: Array<{ __typename?: 'Category', id: string, name: string }>, donor?: { __typename?: 'Donor', id: string, name: string } | null, contact?: { __typename?: 'Contact', id: string, display_name: string } | null, location: { __typename?: 'Location', id: string, name: string }, allotment?: { __typename?: 'Allotment', id: string, name: string } | null } | null };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type CancelEventMutationVariables = Exact<{
  input: CancelEventInput;
}>;


export type CancelEventMutation = { __typename?: 'Mutation', cancelEvent?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } };

export type PublishEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublishEventMutation = { __typename?: 'Mutation', publishEvent?: { __typename?: 'Event', id: string, status: EventStatus } | null };

export type DeleteSignupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSignupMutation = { __typename?: 'Mutation', deleteSignup?: { __typename?: 'Signup', id: string } | null };

export type AcceptSignupsMutationVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type AcceptSignupsMutation = { __typename?: 'Mutation', acceptSignups?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type AddSignupsMutationVariables = Exact<{
  input: AddSignupsInput;
}>;


export type AddSignupsMutation = { __typename?: 'Mutation', addSignups?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type InviteCandidatesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InviteCandidatesMutation = { __typename?: 'Mutation', inviteCandidates?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: { __typename?: 'Event', id: string } | null };

export type RestoreEventsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreEventsMutation = { __typename?: 'Mutation', restoreEvents: Array<{ __typename?: 'Event', id: string } | null> };

export type ForceDeleteEventsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteEventsMutation = { __typename?: 'Mutation', forceDeleteEvents: Array<{ __typename?: 'Event', id: string } | null> };

export type EmptyEventTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyEventTrashMutation = { __typename?: 'Mutation', emptyEventTrash: Array<{ __typename?: 'Event', id: string } | null> };

export type LocationCreateFormFragment = { __typename?: 'Location', name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, url: string } | null, donors: Array<{ __typename?: 'Donor', id: string }> };

export type LocationEditFormFragment = { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, url: string } | null, donors: Array<{ __typename?: 'Donor', id: string, name: string }> };

export type LocationInfoFragment = { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null };

export type LocationListItemFragment = { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean };

export type LocationListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
}>;


export type LocationListQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationPaginator', data: Array<{ __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type LocationDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationDetailQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } | null };

export type LocationDonorsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationDonorsQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, donors: Array<{ __typename?: 'Donor', id: string, name: string, contacts: Array<{ __typename?: 'Contact', id: string, display_name: string }> }> } | null };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } };

export type LocationEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocationEditQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, url: string } | null, donors: Array<{ __typename?: 'Donor', id: string, name: string }> } | null };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation?: { __typename?: 'Location', id: string, name: string, street: string, city: string, postal_code: string, meeting_point: string, public_transport?: string | null, accessible: boolean, accessibility_info_visual?: string | null, accessibility_info_visual_html?: string | null, accessibility_info_visual_markdown?: string | null, accessibility_info_audio?: string | null, accessibility_info_audio_html?: string | null, accessibility_info_audio_markdown?: string | null, accessibility_info_physical?: string | null, accessibility_info_physical_html?: string | null, accessibility_info_physical_markdown?: string | null, poster?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } | null };

export type SetLocationPosterMutationVariables = Exact<{
  input: SetMediaInput;
}>;


export type SetLocationPosterMutation = { __typename?: 'Mutation', setLocationPoster?: { __typename?: 'Location', id: string, poster?: { __typename?: 'Media', name: string, thumb_url?: string | null } | null } | null };

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: { __typename?: 'Location', id: string } };

export type RestoreLocationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreLocationsMutation = { __typename?: 'Mutation', restoreLocations: Array<{ __typename?: 'Location', id: string } | null> };

export type ForceDeleteLocationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteLocationsMutation = { __typename?: 'Mutation', forceDeleteLocations: Array<{ __typename?: 'Location', id: string } | null> };

export type EmptyLocationTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyLocationTrashMutation = { __typename?: 'Mutation', emptyLocationTrash: Array<{ __typename?: 'Location', id: string } | null> };

export type CandidateListFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type CandidateListItemFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type CompanionMatchListItemFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type CompanionMatchingTabFragment = { __typename?: 'Event', id: string, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, location: { __typename?: 'Location', id: string, street: string, postal_code: string, city: string, lat: number, lng: number } };

export type ProspectGroupListItemFragment = { __typename?: 'Signup', id: string, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, memberSignups: Array<{ __typename?: 'Signup', id: string, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null }> };

export type ProspectListFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type ProspectListItemFragment = { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null };

export type MatchingPageFragment = { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, is_archived: boolean, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string, lat: number, lng: number } };

export type EventMatchingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventMatchingQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, is_archived: boolean, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string, lat: number, lng: number } } | null };

export type UpdateEventCandidatesMutationVariables = Exact<{
  input: UpdateCandidatesInput;
}>;


export type UpdateEventCandidatesMutation = { __typename?: 'Mutation', updateCandidates?: { __typename?: 'Event', id: string, name: string, status: EventStatus, start: string, end?: string | null, notes?: string | null, description?: string | null, description_html?: string | null, description_markdown?: string | null, taken_tickets: number, available_tickets?: number | null, candidates_chosen: boolean, ticket_type: EventTicketType, ticket_time: number, ticket_retrieval_type?: EventTicketRetrievalType | null, ticket_retrieval_location?: string | null, reservation_number?: string | null, is_archived: boolean, needsInvite: boolean, candidateCount: number, attendeeCount: number, prospects: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, candidates: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, attendees: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, groups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, teams: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneSouls: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, loneCompanions: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, cardholder?: { __typename?: 'Companion', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, memberSignups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, leaderSignup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, is_soul: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, is_first_attend: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, contact?: { __typename?: 'Contact', id: string, display_name: string, mobile?: string | null, phone?: string | null, email?: string | null } | null, location: { __typename?: 'Location', id: string, name: string, accessible: boolean, meeting_point: string, public_transport?: string | null, street: string, postal_code: string, city: string }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null };

export type CandidateSignupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CandidateSignupQuery = { __typename?: 'Query', signup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, is_cardholder: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null };

export type ProspectSignupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProspectSignupQuery = { __typename?: 'Query', signup?: { __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null } | null };

export type ProspectGroupSignupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProspectGroupSignupQuery = { __typename?: 'Query', signup?: { __typename?: 'Signup', id: string, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null, memberSignups: Array<{ __typename?: 'Signup', id: string, notes?: string | null, priority: number, is_first_attend: boolean, conflicting_signups: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string } }>, soul?: { __typename?: 'Soul', id: string, display_name: string, birthdate?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_blind: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null }> } | null };

export type CompanionMatchingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanionMatchingQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, signups: Array<{ __typename?: 'Signup', id: string, event_id: string, token: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, notes?: string | null, priority: number, companion?: { __typename?: 'Companion', id: string, display_name: string, birthdate?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, lat?: number | null, lng?: number | null, notes?: string | null, meta: { __typename?: 'CompanionMeta', can_blind: boolean, can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }>, organisation?: { __typename?: 'Organisation', id: string, name: string } | null } | null }>, location: { __typename?: 'Location', id: string, street: string, postal_code: string, city: string, lat: number, lng: number } } | null };

export type SoulAttendsQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type SoulAttendsQuery = { __typename?: 'Query', soul?: { __typename?: 'Soul', id: string, attends?: { __typename?: 'SignupPaginator', data: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> }, leaderSignup?: { __typename?: 'Signup', id: string, companion?: { __typename?: 'Companion', id: string, display_name: string } | null } | null, memberSignups: Array<{ __typename?: 'Signup', id: string, soul?: { __typename?: 'Soul', id: string, display_name: string } | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null } | null };

export type CompanionAttendsQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type CompanionAttendsQuery = { __typename?: 'Query', companion?: { __typename?: 'Companion', id: string, attends?: { __typename?: 'SignupPaginator', data: Array<{ __typename?: 'Signup', id: string, event: { __typename?: 'Event', id: string, name: string, start: string, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> }, leaderSignup?: { __typename?: 'Signup', id: string, companion?: { __typename?: 'Companion', id: string, display_name: string } | null } | null, memberSignups: Array<{ __typename?: 'Signup', id: string, soul?: { __typename?: 'Soul', id: string, display_name: string } | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null } | null };

export type SoulFutureSignupsQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type SoulFutureSignupsQuery = { __typename?: 'Query', soul?: { __typename?: 'Soul', id: string, future_signups?: { __typename?: 'SignupPaginator', data: Array<{ __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, event: { __typename?: 'Event', id: string, name: string, status: EventStatus, candidates_chosen: boolean, start: string, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null } | null };

export type CompanionFutureSignupsQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type CompanionFutureSignupsQuery = { __typename?: 'Query', companion?: { __typename?: 'Companion', id: string, future_signups?: { __typename?: 'SignupPaginator', data: Array<{ __typename?: 'Signup', id: string, is_candidate: boolean, is_invited: boolean, has_accepted: boolean, has_rejected: boolean, emails: Array<{ __typename?: 'Email', id: string, status: EmailStatus }>, event: { __typename?: 'Event', id: string, name: string, status: EventStatus, candidates_chosen: boolean, start: string, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null } | null };

export type NewsletterEventListItemFragment = { __typename?: 'Event', id: string, name: string, start: string, end?: string | null, location: { __typename?: 'Location', id: string, name: string } };

export type NewsletterCreateFormFragment = { __typename?: 'Newsletter', subject: string, body: string, segment: MailcoachSegment, events: Array<{ __typename?: 'Event', id: string }> };

export type NewsletterListItemFragment = { __typename?: 'Newsletter', id: string, subject: string, status: NewsletterStatus, sent_at?: string | null, segment: MailcoachSegment };

export type NewsletterDetailPageFragment = { __typename?: 'Newsletter', id: string, status: NewsletterStatus, subject: string, body: string, sent_at?: string | null, segment: MailcoachSegment, events: Array<{ __typename?: 'Event', id: string, name: string }> };

export type NewsletterListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  sentAt?: InputMaybe<DateTimeRange>;
  trashed?: InputMaybe<Trashed>;
}>;


export type NewsletterListQuery = { __typename?: 'Query', newsletters?: { __typename?: 'NewsletterPaginator', data: Array<{ __typename?: 'Newsletter', id: string, subject: string, status: NewsletterStatus, sent_at?: string | null, segment: MailcoachSegment }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type NewsletterDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewsletterDetailQuery = { __typename?: 'Query', newsletter?: { __typename?: 'Newsletter', id: string, status: NewsletterStatus, subject: string, body: string, sent_at?: string | null, segment: MailcoachSegment, events: Array<{ __typename?: 'Event', id: string, name: string }> } | null };

export type CreateNewsletterMutationVariables = Exact<{
  input: CreateNewsletterInput;
}>;


export type CreateNewsletterMutation = { __typename?: 'Mutation', createNewsletter: { __typename?: 'Newsletter', id: string, status: NewsletterStatus, subject: string, body: string, sent_at?: string | null, segment: MailcoachSegment, events: Array<{ __typename?: 'Event', id: string, name: string }> } };

export type OrganisationCompanionListItemFragment = { __typename?: 'Companion', id: string, display_name: string, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type OrganisationCreateFormFragment = { __typename?: 'Organisation', name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string }>, companions: Array<{ __typename?: 'Companion', id: string }> };

export type OrganisationEditFormFragment = { __typename?: 'Organisation', id: string, name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string, display_name: string }>, companions: Array<{ __typename?: 'Companion', id: string, display_name: string }> };

export type OrganisationListItemFragment = { __typename?: 'Organisation', id: string, name: string };

export type OrganisationSoulListItemFragment = { __typename?: 'Soul', id: string, display_name: string, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type OrganisationDetailPageFragment = { __typename?: 'Organisation', id: string, name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string, display_name: string, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }>, companions: Array<{ __typename?: 'Companion', id: string, display_name: string, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }> };

export type OrganisationListQueryVariables = Exact<{
  trashed?: InputMaybe<Trashed>;
}>;


export type OrganisationListQuery = { __typename?: 'Query', organisations: Array<{ __typename?: 'Organisation', id: string, name: string }> };

export type OrganisationDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganisationDetailQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', id: string, name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string, display_name: string, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }>, companions: Array<{ __typename?: 'Companion', id: string, display_name: string, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }> } | null };

export type OrganisationEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganisationEditQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', id: string, name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string, display_name: string }>, companions: Array<{ __typename?: 'Companion', id: string, display_name: string }> } | null };

export type CreateOrganisationMutationVariables = Exact<{
  input: CreateOrganisationInput;
}>;


export type CreateOrganisationMutation = { __typename?: 'Mutation', createOrganisation: { __typename?: 'Organisation', id: string, name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string, display_name: string, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }>, companions: Array<{ __typename?: 'Companion', id: string, display_name: string, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }> } };

export type UpdateOrganisationMutationVariables = Exact<{
  input: UpdateOrganisationInput;
}>;


export type UpdateOrganisationMutation = { __typename?: 'Mutation', updateOrganisation?: { __typename?: 'Organisation', id: string, name: string, description?: string | null, notes?: string | null, souls: Array<{ __typename?: 'Soul', id: string, display_name: string, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }>, companions: Array<{ __typename?: 'Companion', id: string, display_name: string, meta: { __typename?: 'CompanionMeta', can_wheelchair: boolean, can_wheeled_walker: boolean, can_drive: boolean, can_blind: boolean }, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }> } | null };

export type DeleteOrganisationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganisationMutation = { __typename?: 'Mutation', deleteOrganisation: { __typename?: 'Organisation', id: string } };

export type RestoreOrganisationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreOrganisationsMutation = { __typename?: 'Mutation', restoreOrganisations: Array<{ __typename?: 'Organisation', id: string } | null> };

export type ForceDeleteOrganisationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteOrganisationsMutation = { __typename?: 'Mutation', forceDeleteOrganisations: Array<{ __typename?: 'Organisation', id: string } | null> };

export type EmptyOrganisationTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyOrganisationTrashMutation = { __typename?: 'Mutation', emptyOrganisationTrash: Array<{ __typename?: 'Organisation', id: string } | null> };

export type PermissionMultiSelectFragment = { __typename?: 'Permission', id: string, title: string };

export type RoleCreateFormFragment = { __typename?: 'Role', name: string, permissions: Array<{ __typename?: 'Permission', id: string }> };

export type RoleEditFormFragment = { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> };

export type RoleListItemFragment = { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> };

export type RoleDetailPageFragment = { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> };

export type RoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleListQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> }> };

export type RoleDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RoleDetailQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> } | null };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> } };

export type RoleEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RoleEditQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> } | null };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', id: string, name: string, permissions: Array<{ __typename?: 'Permission', id: string, title: string }> } | null };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: { __typename?: 'Role', id: string } | null };

export type SettingsDetailPageFragment = { __typename?: 'Tenant', id: string, subdomain: string, legacy_api_key: string, redirect_events?: string | null, redirect_ticket_accept_ok?: string | null, redirect_ticket_accept_not_found?: string | null, redirect_password_reset?: string | null };

export type CurrentTenantDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTenantDetailQuery = { __typename?: 'Query', currentTenant: { __typename?: 'Tenant', id: string, subdomain: string, legacy_api_key: string, redirect_events?: string | null, redirect_ticket_accept_ok?: string | null, redirect_ticket_accept_not_found?: string | null, redirect_password_reset?: string | null } };

export type UpdateTenantMutationVariables = Exact<{
  input: UpdateTenantInput;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant?: { __typename?: 'Tenant', id: string, subdomain: string, legacy_api_key: string, redirect_events?: string | null, redirect_ticket_accept_ok?: string | null, redirect_ticket_accept_not_found?: string | null, redirect_password_reset?: string | null } | null };

export type RegenerateApiKeyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegenerateApiKeyMutation = { __typename?: 'Mutation', regenerateApiKey: { __typename?: 'Tenant', id: string, subdomain: string, legacy_api_key: string, redirect_events?: string | null, redirect_ticket_accept_ok?: string | null, redirect_ticket_accept_not_found?: string | null, redirect_password_reset?: string | null } };

export type SoulCreateFormFragment = { __typename?: 'Soul', first_name: string, last_name: string, status: UserStatus, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type SoulEditFormFragment = { __typename?: 'Soul', id: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type SoulInfoFragment = { __typename?: 'Soul', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type SoulListItemFragment = { __typename?: 'Soul', id: string, status: UserStatus, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type SoulListQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
  orderByColumn?: InputMaybe<QuerySoulsOrderByColumn>;
  orderByOrder?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
}>;


export type SoulListQuery = { __typename?: 'Query', souls?: { __typename?: 'SoulPaginator', data: Array<{ __typename?: 'Soul', id: string, status: UserStatus, display_name: string, email?: string | null, phone?: string | null, mobile?: string | null, meta: { __typename?: 'SoulMeta', buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, hasMorePages: boolean } } | null };

export type SoulDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SoulDetailQuery = { __typename?: 'Query', soul?: { __typename?: 'Soul', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null };

export type SoulEmailsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type SoulEmailsQuery = { __typename?: 'Query', soul?: { __typename?: 'Soul', id: string, emails?: { __typename?: 'EmailPaginator', data: Array<{ __typename?: 'Email', id: string, status: EmailStatus, subject: string, sent_at?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, hasMorePages: boolean, lastPage: number } } | null } | null };

export type SoulEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SoulEditQuery = { __typename?: 'Query', soul?: { __typename?: 'Soul', id: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null };

export type CreateSoulMutationVariables = Exact<{
  input: CreateSoulInput;
}>;


export type CreateSoulMutation = { __typename?: 'Mutation', createSoul: { __typename?: 'Soul', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } };

export type UpdateSoulMutationVariables = Exact<{
  input: UpdateSoulInput;
}>;


export type UpdateSoulMutation = { __typename?: 'Mutation', updateSoul?: { __typename?: 'Soul', id: string, status: UserStatus, display_name: string, first_name: string, last_name: string, birthdate?: string | null, email?: string | null, gdpr_consent: boolean, gdpr_consent_source?: GdprConsentSource | null, phone?: string | null, mobile?: string | null, street?: string | null, city?: string | null, postal_code?: string | null, notes?: string | null, meta: { __typename?: 'SoulMeta', target_group: SoulTargetGroup, buys_ticket: boolean, needs_wheelchair: boolean, needs_wheeled_walker: boolean, needs_drive: boolean, needs_trainstation_fetch: boolean, needs_blind: boolean }, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> } | null };

export type ApproveSoulMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveSoulMutation = { __typename?: 'Mutation', approveSoul: { __typename?: 'Soul', id: string, status: UserStatus } };

export type DenySoulMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DenySoulMutation = { __typename?: 'Mutation', denySoul: { __typename?: 'Soul', id: string, status: UserStatus } };

export type ActivateSoulMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateSoulMutation = { __typename?: 'Mutation', activateSoul: { __typename?: 'Soul', id: string, status: UserStatus } };

export type DeactivateSoulMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateSoulMutation = { __typename?: 'Mutation', deactivateSoul: { __typename?: 'Soul', id: string, status: UserStatus } };

export type DeleteSoulMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSoulMutation = { __typename?: 'Mutation', deleteSoul: { __typename?: 'Soul', id: string } };

export type RestoreSoulsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RestoreSoulsMutation = { __typename?: 'Mutation', restoreSouls: Array<{ __typename?: 'Soul', id: string } | null> };

export type ForceDeleteSoulsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ForceDeleteSoulsMutation = { __typename?: 'Mutation', forceDeleteSouls: Array<{ __typename?: 'Soul', id: string } | null> };

export type EmptySoulTrashMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptySoulTrashMutation = { __typename?: 'Mutation', emptySoulTrash: Array<{ __typename?: 'Soul', id: string } | null> };

export type CategoryStatsFragment = { __typename?: 'CategoryStatsPayload', category: { __typename?: 'Category', id: string, name: string, color: string }, data: { __typename?: 'CategoryDataPayload', tickets: number, signups: number, previous_tickets: number, previous_signups: number } };

export type TargetGroupStatsFragment = { __typename?: 'TargetGroupStatsPayload', target_group: SoulTargetGroup, data: { __typename?: 'TargetGroupDataPayload', signups: number, attends: number, previous_signups: number, previous_attends: number } };

export type OverviewStatsQueryVariables = Exact<{
  input: OverviewStatsInput;
}>;


export type OverviewStatsQuery = { __typename?: 'Query', overviewStats: { __typename?: 'OverviewStatsPayload', tickets: number, signups: number, attends: number } };

export type TargetGroupStatsQueryVariables = Exact<{
  input: TargetGroupStatsInput;
}>;


export type TargetGroupStatsQuery = { __typename?: 'Query', targetGroupStats: Array<{ __typename?: 'TargetGroupStatsPayload', target_group: SoulTargetGroup, data: { __typename?: 'TargetGroupDataPayload', signups: number, attends: number, previous_signups: number, previous_attends: number } }> };

export type CategoryStatsQueryVariables = Exact<{
  input: CategoryStatsInput;
}>;


export type CategoryStatsQuery = { __typename?: 'Query', categoryStats: Array<{ __typename?: 'CategoryStatsPayload', category: { __typename?: 'Category', id: string, name: string, color: string }, data: { __typename?: 'CategoryDataPayload', tickets: number, signups: number, previous_tickets: number, previous_signups: number } }> };

export type TagCreateFormFragment = { __typename?: 'Tag', name: string, icon: string, intent: Intent, description?: string | null };

export type TagEditFormFragment = { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null };

export type TagListItemFragment = { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null };

export type TagDetailPageFragment = { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null };

export type TagListQueryVariables = Exact<{ [key: string]: never; }>;


export type TagListQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null }> };

export type TagDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagDetailQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null } | null };

export type TagEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagEditQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null } | null };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null } };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent, description?: string | null } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: { __typename?: 'Tag', id: string } | null };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string, icon: string, intent: Intent }> };

export type PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { __typename?: 'Query', permissions: Array<{ __typename?: 'Permission', id: string, title: string }> };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string }> };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string }> };

export type AllotmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllotmentsQuery = { __typename?: 'Query', allotments: Array<{ __typename?: 'Allotment', id: string, name: string }> };

export type OrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationsQuery = { __typename?: 'Query', organisations: Array<{ __typename?: 'Organisation', id: string, name: string }> };

export type EmailUsersMutationVariables = Exact<{
  input: EmailUsersInput;
}>;


export type EmailUsersMutation = { __typename?: 'Mutation', emailUsers?: boolean | null };

export type SendResetLinkForUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendResetLinkForUserMutation = { __typename?: 'Mutation', sendResetLinkForUser?: boolean | null };

export const AttendListItemFragmentDoc = gql`
    fragment AttendListItem on Signup {
  id
  event {
    id
    name
    start
    categories {
      id
      name
      color
    }
  }
  leaderSignup {
    id
    companion {
      id
      display_name
    }
  }
  memberSignups {
    id
    soul {
      id
      display_name
    }
  }
}
    `;
export const FutureSignupListItemFragmentDoc = gql`
    fragment FutureSignupListItem on Signup {
  id
  is_candidate
  is_invited
  has_accepted
  has_rejected
  emails {
    id
    status
  }
  event {
    id
    name
    status
    candidates_chosen
    start
    categories {
      id
      name
      color
    }
  }
}
    `;
export const PersonOrganisationSelectFragmentDoc = gql`
    fragment PersonOrganisationSelect on Organisation {
  id
  name
}
    `;
export const PersonTagMultiSelectFragmentDoc = gql`
    fragment PersonTagMultiSelect on Tag {
  id
  name
  icon
  intent
}
    `;
export const AllotmentCreateFormFragmentDoc = gql`
    fragment AllotmentCreateForm on Allotment {
  name
  amount
  start
  end
}
    `;
export const AllotmentEditFormFragmentDoc = gql`
    fragment AllotmentEditForm on Allotment {
  id
  name
  status
  amount
  amount_left
  start
  end
}
    `;
export const AllotmentListItemFragmentDoc = gql`
    fragment AllotmentListItem on Allotment {
  id
  name
  status
  amount
  amount_left
  start
  end
}
    `;
export const AllotmentDetailPageFragmentDoc = gql`
    fragment AllotmentDetailPage on Allotment {
  id
  name
  status
  amount
  amount_left
  start
  end
}
    `;
export const AcceptSignupsFragmentDoc = gql`
    fragment AcceptSignups on Event {
  id
  signups {
    id
    token
    has_accepted
    has_rejected
  }
}
    `;
export const CategoryCreateFormFragmentDoc = gql`
    fragment CategoryCreateForm on Category {
  name
  description
  color
}
    `;
export const CategoryEditFormFragmentDoc = gql`
    fragment CategoryEditForm on Category {
  id
  name
  description
  color
}
    `;
export const CategoryListItemFragmentDoc = gql`
    fragment CategoryListItem on Category {
  id
  name
  description
  color
}
    `;
export const CategoryDetailPageFragmentDoc = gql`
    fragment CategoryDetailPage on Category {
  id
  name
  description
  color
}
    `;
export const CompanionCreateFormFragmentDoc = gql`
    fragment CompanionCreateForm on Companion {
  notes
  first_name
  last_name
  status
  birthdate
  email
  gdpr_consent
  phone
  mobile
  street
  city
  postal_code
  meta {
    can_wheelchair
    can_wheeled_walker
    can_drive
    can_blind
    can_trainstation_fetch
  }
  organisation {
    id
    name
  }
  tags {
    id
    name
    icon
    intent
  }
}
    `;
export const CompanionEditFormFragmentDoc = gql`
    fragment CompanionEditForm on Companion {
  id
  first_name
  last_name
  birthdate
  email
  gdpr_consent
  phone
  mobile
  street
  city
  postal_code
  notes
  meta {
    can_wheelchair
    can_wheeled_walker
    can_drive
    can_blind
    can_trainstation_fetch
  }
  organisation {
    id
    name
  }
  tags {
    id
    name
    icon
    intent
  }
}
    `;
export const CompanionInfoFragmentDoc = gql`
    fragment CompanionInfo on Companion {
  id
  status
  display_name
  first_name
  last_name
  birthdate
  email
  gdpr_consent
  gdpr_consent_source
  phone
  mobile
  street
  city
  postal_code
  notes
  meta {
    can_wheelchair
    can_wheeled_walker
    can_drive
    can_blind
  }
  organisation {
    id
    name
  }
  tags {
    id
    name
    icon
    intent
  }
}
    `;
export const PersonTagIconFragmentDoc = gql`
    fragment PersonTagIcon on Tag {
  id
  name
  icon
  intent
}
    `;
export const CompanionListItemFragmentDoc = gql`
    fragment CompanionListItem on Companion {
  id
  status
  display_name
  email
  phone
  mobile
  meta {
    can_wheelchair
    can_wheeled_walker
    can_drive
    can_blind
  }
  organisation {
    id
    name
  }
  tags {
    ...PersonTagIcon
  }
}
    ${PersonTagIconFragmentDoc}`;
export const ContactCreateFormFragmentDoc = gql`
    fragment ContactCreateForm on Contact {
  first_name
  last_name
  email
  phone
  mobile
  street
  city
  postal_code
  notes
  donor_id
}
    `;
export const ContactEditFormFragmentDoc = gql`
    fragment ContactEditForm on Contact {
  id
  first_name
  last_name
  email
  phone
  mobile
  street
  city
  postal_code
  notes
}
    `;
export const ContactInfoFragmentDoc = gql`
    fragment ContactInfo on Contact {
  id
  display_name
  first_name
  last_name
  email
  phone
  mobile
  street
  city
  postal_code
  notes
}
    `;
export const ContactListItemFragmentDoc = gql`
    fragment ContactListItem on Contact {
  id
  display_name
  email
  phone
  mobile
}
    `;
export const DonorCreateFormFragmentDoc = gql`
    fragment DonorCreateForm on Donor {
  name
  street
  city
  postal_code
  notes
  public
  website
  logo {
    name
    url
  }
  locations {
    id
  }
}
    `;
export const DonorEditFormFragmentDoc = gql`
    fragment DonorEditForm on Donor {
  id
  name
  street
  city
  postal_code
  notes
  public
  website
  logo {
    name
    url
  }
  locations {
    id
    name
  }
}
    `;
export const DonorInfoFragmentDoc = gql`
    fragment DonorInfo on Donor {
  id
  name
  street
  city
  postal_code
  notes
  website
  public
  logo {
    name
    thumb_url
  }
}
    `;
export const DonorListItemFragmentDoc = gql`
    fragment DonorListItem on Donor {
  id
  name
  contacts {
    id
    display_name
  }
}
    `;
export const EmailListItemFragmentDoc = gql`
    fragment EmailListItem on Email {
  id
  status
  subject
  sent_at
}
    `;
export const EmailOverlayFragmentDoc = gql`
    fragment EmailOverlay on Email {
  id
  status
  reason
  subject
  sent_at
  body
}
    `;
export const EmployeeCreateFormFragmentDoc = gql`
    fragment EmployeeCreateForm on Employee {
  status
  first_name
  last_name
  email
  phone
  mobile
  street
  city
  postal_code
  roles {
    id
  }
  meta {
    position
  }
}
    `;
export const EmployeeEditFormFragmentDoc = gql`
    fragment EmployeeEditForm on Employee {
  id
  status
  first_name
  last_name
  email
  phone
  mobile
  street
  city
  postal_code
  roles {
    id
    name
  }
  meta {
    position
  }
}
    `;
export const EmployeeInfoFragmentDoc = gql`
    fragment EmployeeInfo on Employee {
  id
  display_name
  first_name
  last_name
  email
  phone
  mobile
  street
  city
  postal_code
  roles {
    id
    name
  }
  meta {
    position
  }
}
    `;
export const EmployeeListItemFragmentDoc = gql`
    fragment EmployeeListItem on Employee {
  id
  display_name
  email
  phone
  mobile
  roles {
    id
    name
  }
  meta {
    position
  }
}
    `;
export const RoleMultiSelectFragmentDoc = gql`
    fragment RoleMultiSelect on Role {
  id
  name
}
    `;
export const AllotmentSelectFragmentDoc = gql`
    fragment AllotmentSelect on Allotment {
  id
  name
}
    `;
export const CategoryMultiSelectFragmentDoc = gql`
    fragment CategoryMultiSelect on Category {
  id
  name
}
    `;
export const ContactSelectFragmentDoc = gql`
    fragment ContactSelect on Contact {
  id
  display_name
}
    `;
export const EventCreateFormFragmentDoc = gql`
    fragment EventCreateForm on Event {
  name
  status
  description
  description_markdown
  description_html
  start
  end
  tickets
  ticket_time
  ticket_type
  reservation_number
  ticket_retrieval_type
  ticket_retrieval_location
  notes
  categories {
    id
  }
  donor {
    id
  }
  contact {
    id
  }
  location {
    id
  }
  allotment {
    id
  }
}
    `;
export const EventEditFormFragmentDoc = gql`
    fragment EventEditForm on Event {
  id
  name
  status
  description
  description_markdown
  description_html
  start
  end
  tickets
  ticket_time
  ticket_type
  reservation_number
  ticket_retrieval_type
  ticket_retrieval_location
  notes
  categories {
    id
    name
  }
  donor {
    id
    name
  }
  contact {
    id
    display_name
  }
  location {
    id
    name
  }
  allotment {
    id
    name
  }
}
    `;
export const EventListItemFragmentDoc = gql`
    fragment EventListItem on Event {
  id
  name
  status
  start
  end
  available_tickets
  taken_tickets
  is_archived
  candidateCount @client
  attendeeCount @client
  attendees @client {
    id
    is_candidate
    is_invited
    is_soul
    has_accepted
    has_rejected
  }
  signups {
    id
    is_candidate
    is_invited
    is_soul
    has_accepted
    has_rejected
  }
  location {
    id
    name
    accessible
  }
}
    `;
export const LocationSelectFragmentDoc = gql`
    fragment LocationSelect on Location {
  id
  name
}
    `;
export const RemoveSignupFragmentDoc = gql`
    fragment RemoveSignup on Event {
  prospects @client {
    id
  }
  signups {
    id
  }
}
    `;
export const SignupListItemFragmentDoc = gql`
    fragment SignupListItem on Signup {
  id
  event_id
  notes
  companion {
    id
    display_name
    notes
    meta {
      can_blind
      can_wheelchair
      can_wheeled_walker
      can_drive
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
  soul {
    id
    display_name
    notes
    meta {
      buys_ticket
      needs_blind
      needs_wheelchair
      needs_wheeled_walker
      needs_drive
      needs_trainstation_fetch
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
}
    `;
export const AttendeeListItemFragmentDoc = gql`
    fragment AttendeeListItem on Signup {
  id
  event_id
  token
  is_candidate
  is_invited
  is_soul
  has_accepted
  has_rejected
  notes
  is_first_attend
  emails {
    id
    status
  }
  companion {
    id
    display_name
    email
    phone
    mobile
    notes
    meta {
      can_blind
      can_wheelchair
      can_wheeled_walker
      can_drive
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
  soul {
    id
    display_name
    email
    phone
    mobile
    notes
    meta {
      buys_ticket
      needs_blind
      needs_wheelchair
      needs_wheeled_walker
      needs_drive
      needs_trainstation_fetch
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
}
    `;
export const AttendeeGroupFragmentDoc = gql`
    fragment AttendeeGroup on Signup {
  ...AttendeeListItem
  memberSignups {
    ...AttendeeListItem
  }
}
    ${AttendeeListItemFragmentDoc}`;
export const AttendeeTeamFragmentDoc = gql`
    fragment AttendeeTeam on Signup {
  ...AttendeeListItem
  memberSignups {
    ...AttendeeListItem
  }
}
    ${AttendeeListItemFragmentDoc}`;
export const AttendeeLoneSoulFragmentDoc = gql`
    fragment AttendeeLoneSoul on Signup {
  ...AttendeeListItem
}
    ${AttendeeListItemFragmentDoc}`;
export const AttendeeLoneCompanionFragmentDoc = gql`
    fragment AttendeeLoneCompanion on Signup {
  ...AttendeeListItem
}
    ${AttendeeListItemFragmentDoc}`;
export const EventDetailPageFragmentDoc = gql`
    fragment EventDetailPage on Event {
  id
  name
  status
  start
  end
  notes
  description
  description_html
  description_markdown
  taken_tickets
  available_tickets
  candidates_chosen
  ticket_type
  ticket_time
  ticket_retrieval_type
  ticket_retrieval_location
  reservation_number
  is_archived
  needsInvite @client
  candidateCount @client
  attendeeCount @client
  prospects @client {
    ...AttendeeListItem
  }
  candidates @client {
    ...AttendeeListItem
  }
  attendees @client {
    ...AttendeeListItem
  }
  groups @client {
    ...AttendeeGroup
  }
  teams @client {
    ...AttendeeTeam
  }
  loneSouls @client {
    ...AttendeeLoneSoul
  }
  loneCompanions @client {
    ...AttendeeLoneCompanion
  }
  cardholder {
    id
    display_name
    mobile
    phone
    email
  }
  signups {
    ...AttendeeListItem
    memberSignups {
      ...AttendeeListItem
    }
    leaderSignup {
      ...AttendeeListItem
    }
  }
  contact {
    id
    display_name
    mobile
    phone
    email
  }
  location {
    id
    name
    accessible
    meeting_point
    public_transport
    street
    postal_code
    city
  }
  categories {
    id
    name
    color
  }
}
    ${AttendeeListItemFragmentDoc}
${AttendeeGroupFragmentDoc}
${AttendeeTeamFragmentDoc}
${AttendeeLoneSoulFragmentDoc}
${AttendeeLoneCompanionFragmentDoc}`;
export const LocationCreateFormFragmentDoc = gql`
    fragment LocationCreateForm on Location {
  name
  poster {
    name
    url
  }
  street
  city
  postal_code
  meeting_point
  public_transport
  accessible
  accessibility_info_visual
  accessibility_info_visual_html
  accessibility_info_visual_markdown
  accessibility_info_audio
  accessibility_info_audio_html
  accessibility_info_audio_markdown
  accessibility_info_physical
  accessibility_info_physical_html
  accessibility_info_physical_markdown
  donors {
    id
  }
}
    `;
export const LocationEditFormFragmentDoc = gql`
    fragment LocationEditForm on Location {
  id
  name
  poster {
    name
    url
  }
  street
  city
  postal_code
  meeting_point
  public_transport
  accessible
  accessibility_info_visual
  accessibility_info_visual_html
  accessibility_info_visual_markdown
  accessibility_info_audio
  accessibility_info_audio_html
  accessibility_info_audio_markdown
  accessibility_info_physical
  accessibility_info_physical_html
  accessibility_info_physical_markdown
  donors {
    id
    name
  }
}
    `;
export const LocationInfoFragmentDoc = gql`
    fragment LocationInfo on Location {
  id
  name
  poster {
    name
    thumb_url
  }
  street
  city
  postal_code
  meeting_point
  public_transport
  accessible
  accessibility_info_visual
  accessibility_info_visual_html
  accessibility_info_visual_markdown
  accessibility_info_audio
  accessibility_info_audio_html
  accessibility_info_audio_markdown
  accessibility_info_physical
  accessibility_info_physical_html
  accessibility_info_physical_markdown
}
    `;
export const LocationListItemFragmentDoc = gql`
    fragment LocationListItem on Location {
  id
  name
  street
  city
  postal_code
  meeting_point
  public_transport
  accessible
}
    `;
export const CompanionMatchListItemFragmentDoc = gql`
    fragment CompanionMatchListItem on Signup {
  id
  event_id
  token
  is_candidate
  is_invited
  has_accepted
  has_rejected
  notes
  priority
  companion {
    id
    display_name
    birthdate
    email
    phone
    mobile
    lat
    lng
    notes
    meta {
      can_blind
      can_wheelchair
      can_wheeled_walker
      can_drive
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
}
    `;
export const CompanionMatchingTabFragmentDoc = gql`
    fragment CompanionMatchingTab on Event {
  id
  signups {
    ...CompanionMatchListItem
  }
  location {
    id
    street
    postal_code
    city
    lat
    lng
  }
}
    ${CompanionMatchListItemFragmentDoc}`;
export const ProspectGroupListItemFragmentDoc = gql`
    fragment ProspectGroupListItem on Signup {
  id
  notes
  priority
  is_first_attend
  conflicting_signups {
    id
    event {
      id
      name
      start
    }
  }
  companion {
    id
    display_name
    birthdate
    notes
    meta {
      can_blind
      can_wheelchair
      can_wheeled_walker
      can_drive
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
  memberSignups {
    id
    notes
    priority
    is_first_attend
    conflicting_signups {
      id
      event {
        id
        name
        start
      }
    }
    soul {
      id
      display_name
      birthdate
      notes
      meta {
        buys_ticket
        needs_blind
        needs_wheelchair
        needs_wheeled_walker
        needs_drive
        needs_trainstation_fetch
      }
      tags {
        id
        name
        icon
        intent
      }
    }
  }
}
    `;
export const ProspectListItemFragmentDoc = gql`
    fragment ProspectListItem on Signup {
  id
  event_id
  token
  is_candidate
  is_invited
  has_accepted
  has_rejected
  notes
  priority
  is_first_attend
  conflicting_signups {
    id
    event {
      id
      name
      start
    }
  }
  emails {
    id
    status
  }
  companion {
    id
    display_name
    birthdate
    email
    phone
    mobile
    lat
    lng
    notes
    meta {
      can_blind
      can_wheelchair
      can_wheeled_walker
      can_drive
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
  soul {
    id
    display_name
    birthdate
    email
    phone
    mobile
    lat
    lng
    notes
    meta {
      buys_ticket
      needs_blind
      needs_wheelchair
      needs_wheeled_walker
      needs_drive
      needs_trainstation_fetch
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
}
    `;
export const ProspectListFragmentDoc = gql`
    fragment ProspectList on Signup {
  ...ProspectListItem
  memberSignups {
    ...ProspectListItem
  }
  leaderSignup {
    ...ProspectListItem
  }
}
    ${ProspectListItemFragmentDoc}`;
export const CandidateListItemFragmentDoc = gql`
    fragment CandidateListItem on Signup {
  id
  event_id
  token
  is_candidate
  is_invited
  has_accepted
  has_rejected
  is_cardholder
  notes
  priority
  is_first_attend
  conflicting_signups {
    id
    event {
      id
      name
      start
    }
  }
  emails {
    id
    status
  }
  companion {
    id
    display_name
    birthdate
    email
    phone
    mobile
    lat
    lng
    notes
    meta {
      can_blind
      can_wheelchair
      can_wheeled_walker
      can_drive
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
  soul {
    id
    display_name
    birthdate
    email
    phone
    mobile
    lat
    lng
    notes
    meta {
      buys_ticket
      needs_blind
      needs_wheelchair
      needs_wheeled_walker
      needs_drive
      needs_trainstation_fetch
    }
    tags {
      id
      name
      icon
      intent
    }
    organisation {
      id
      name
    }
  }
}
    `;
export const CandidateListFragmentDoc = gql`
    fragment CandidateList on Signup {
  ...CandidateListItem
  memberSignups {
    ...CandidateListItem
  }
  leaderSignup {
    ...CandidateListItem
  }
}
    ${CandidateListItemFragmentDoc}`;
export const MatchingPageFragmentDoc = gql`
    fragment MatchingPage on Event {
  id
  name
  status
  start
  end
  is_archived
  taken_tickets
  available_tickets
  candidates_chosen
  cardholder {
    id
    display_name
    mobile
    phone
    email
  }
  categories {
    id
    name
    color
  }
  signups {
    ...CandidateList
  }
  location {
    id
    name
    accessible
    meeting_point
    public_transport
    street
    postal_code
    city
    lat
    lng
  }
}
    ${CandidateListFragmentDoc}`;
export const NewsletterEventListItemFragmentDoc = gql`
    fragment NewsletterEventListItem on Event {
  id
  name
  start
  end
  location {
    id
    name
  }
}
    `;
export const NewsletterCreateFormFragmentDoc = gql`
    fragment NewsletterCreateForm on Newsletter {
  subject
  body
  segment
  events {
    id
  }
}
    `;
export const NewsletterListItemFragmentDoc = gql`
    fragment NewsletterListItem on Newsletter {
  id
  subject
  status
  sent_at
  segment
}
    `;
export const NewsletterDetailPageFragmentDoc = gql`
    fragment NewsletterDetailPage on Newsletter {
  id
  status
  subject
  body
  sent_at
  segment
  events {
    id
    name
  }
}
    `;
export const OrganisationCreateFormFragmentDoc = gql`
    fragment OrganisationCreateForm on Organisation {
  name
  description
  notes
  souls {
    id
  }
  companions {
    id
  }
}
    `;
export const OrganisationEditFormFragmentDoc = gql`
    fragment OrganisationEditForm on Organisation {
  id
  name
  description
  notes
  souls {
    id
    display_name
  }
  companions {
    id
    display_name
  }
}
    `;
export const OrganisationListItemFragmentDoc = gql`
    fragment OrganisationListItem on Organisation {
  id
  name
}
    `;
export const OrganisationSoulListItemFragmentDoc = gql`
    fragment OrganisationSoulListItem on Soul {
  id
  display_name
  meta {
    buys_ticket
    needs_wheelchair
    needs_wheeled_walker
    needs_drive
    needs_trainstation_fetch
    needs_blind
  }
  tags {
    ...PersonTagIcon
  }
}
    ${PersonTagIconFragmentDoc}`;
export const OrganisationCompanionListItemFragmentDoc = gql`
    fragment OrganisationCompanionListItem on Companion {
  id
  display_name
  meta {
    can_wheelchair
    can_wheeled_walker
    can_drive
    can_blind
  }
  tags {
    ...PersonTagIcon
  }
}
    ${PersonTagIconFragmentDoc}`;
export const OrganisationDetailPageFragmentDoc = gql`
    fragment OrganisationDetailPage on Organisation {
  id
  name
  description
  notes
  souls {
    ...OrganisationSoulListItem
  }
  companions {
    ...OrganisationCompanionListItem
  }
}
    ${OrganisationSoulListItemFragmentDoc}
${OrganisationCompanionListItemFragmentDoc}`;
export const PermissionMultiSelectFragmentDoc = gql`
    fragment PermissionMultiSelect on Permission {
  id
  title
}
    `;
export const RoleCreateFormFragmentDoc = gql`
    fragment RoleCreateForm on Role {
  name
  permissions {
    id
  }
}
    `;
export const RoleEditFormFragmentDoc = gql`
    fragment RoleEditForm on Role {
  id
  name
  permissions {
    id
    title
  }
}
    `;
export const RoleListItemFragmentDoc = gql`
    fragment RoleListItem on Role {
  id
  name
  permissions {
    id
    title
  }
}
    `;
export const RoleDetailPageFragmentDoc = gql`
    fragment RoleDetailPage on Role {
  id
  name
  permissions {
    id
    title
  }
}
    `;
export const SettingsDetailPageFragmentDoc = gql`
    fragment SettingsDetailPage on Tenant {
  id
  subdomain
  legacy_api_key
  redirect_events
  redirect_ticket_accept_ok
  redirect_ticket_accept_not_found
  redirect_password_reset
}
    `;
export const SoulCreateFormFragmentDoc = gql`
    fragment SoulCreateForm on Soul {
  first_name
  last_name
  status
  birthdate
  email
  gdpr_consent
  phone
  mobile
  street
  city
  postal_code
  notes
  meta {
    target_group
    buys_ticket
    needs_wheelchair
    needs_wheeled_walker
    needs_drive
    needs_trainstation_fetch
    needs_blind
  }
  organisation {
    id
    name
  }
  tags {
    id
    name
    icon
    intent
  }
}
    `;
export const SoulEditFormFragmentDoc = gql`
    fragment SoulEditForm on Soul {
  id
  first_name
  last_name
  birthdate
  email
  gdpr_consent
  phone
  mobile
  street
  city
  postal_code
  notes
  meta {
    target_group
    buys_ticket
    needs_wheelchair
    needs_wheeled_walker
    needs_drive
    needs_trainstation_fetch
    needs_blind
  }
  organisation {
    id
    name
  }
  tags {
    id
    name
    icon
    intent
  }
}
    `;
export const SoulInfoFragmentDoc = gql`
    fragment SoulInfo on Soul {
  id
  status
  display_name
  first_name
  last_name
  birthdate
  email
  gdpr_consent
  gdpr_consent_source
  phone
  mobile
  street
  city
  postal_code
  notes
  meta {
    target_group
    buys_ticket
    needs_wheelchair
    needs_wheeled_walker
    needs_drive
    needs_trainstation_fetch
    needs_blind
  }
  organisation {
    id
    name
  }
  tags {
    id
    name
    icon
    intent
  }
}
    `;
export const SoulListItemFragmentDoc = gql`
    fragment SoulListItem on Soul {
  id
  status
  display_name
  email
  phone
  mobile
  meta {
    buys_ticket
    needs_wheelchair
    needs_wheeled_walker
    needs_drive
    needs_trainstation_fetch
    needs_blind
  }
  organisation {
    id
    name
  }
  tags {
    ...PersonTagIcon
  }
}
    ${PersonTagIconFragmentDoc}`;
export const CategoryStatsFragmentDoc = gql`
    fragment CategoryStats on CategoryStatsPayload {
  category {
    id
    name
    color
  }
  data {
    tickets
    signups
    previous_tickets
    previous_signups
  }
}
    `;
export const TargetGroupStatsFragmentDoc = gql`
    fragment TargetGroupStats on TargetGroupStatsPayload {
  target_group
  data {
    signups
    attends
    previous_signups
    previous_attends
  }
}
    `;
export const TagCreateFormFragmentDoc = gql`
    fragment TagCreateForm on Tag {
  name
  icon
  intent
  description
}
    `;
export const TagEditFormFragmentDoc = gql`
    fragment TagEditForm on Tag {
  id
  name
  icon
  intent
  description
}
    `;
export const TagListItemFragmentDoc = gql`
    fragment TagListItem on Tag {
  id
  name
  icon
  intent
  description
}
    `;
export const TagDetailPageFragmentDoc = gql`
    fragment TagDetailPage on Tag {
  id
  name
  icon
  intent
  description
}
    `;
export const AllotmentListDocument = gql`
    query AllotmentList {
  allotments {
    ...AllotmentListItem
  }
}
    ${AllotmentListItemFragmentDoc}`;

/**
 * __useAllotmentListQuery__
 *
 * To run a query within a React component, call `useAllotmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllotmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllotmentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllotmentListQuery(baseOptions?: Apollo.QueryHookOptions<AllotmentListQuery, AllotmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllotmentListQuery, AllotmentListQueryVariables>(AllotmentListDocument, options);
      }
export function useAllotmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllotmentListQuery, AllotmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllotmentListQuery, AllotmentListQueryVariables>(AllotmentListDocument, options);
        }
export type AllotmentListQueryHookResult = ReturnType<typeof useAllotmentListQuery>;
export type AllotmentListLazyQueryHookResult = ReturnType<typeof useAllotmentListLazyQuery>;
export type AllotmentListQueryResult = Apollo.QueryResult<AllotmentListQuery, AllotmentListQueryVariables>;
export const AllotmentDetailDocument = gql`
    query AllotmentDetail($id: ID!) {
  allotment(id: $id) {
    id
    ...AllotmentDetailPage
  }
}
    ${AllotmentDetailPageFragmentDoc}`;

/**
 * __useAllotmentDetailQuery__
 *
 * To run a query within a React component, call `useAllotmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllotmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllotmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllotmentDetailQuery(baseOptions: Apollo.QueryHookOptions<AllotmentDetailQuery, AllotmentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllotmentDetailQuery, AllotmentDetailQueryVariables>(AllotmentDetailDocument, options);
      }
export function useAllotmentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllotmentDetailQuery, AllotmentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllotmentDetailQuery, AllotmentDetailQueryVariables>(AllotmentDetailDocument, options);
        }
export type AllotmentDetailQueryHookResult = ReturnType<typeof useAllotmentDetailQuery>;
export type AllotmentDetailLazyQueryHookResult = ReturnType<typeof useAllotmentDetailLazyQuery>;
export type AllotmentDetailQueryResult = Apollo.QueryResult<AllotmentDetailQuery, AllotmentDetailQueryVariables>;
export const AllotmentEditDocument = gql`
    query AllotmentEdit($id: ID!) {
  allotment(id: $id) {
    id
    ...AllotmentEditForm
  }
}
    ${AllotmentEditFormFragmentDoc}`;

/**
 * __useAllotmentEditQuery__
 *
 * To run a query within a React component, call `useAllotmentEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllotmentEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllotmentEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllotmentEditQuery(baseOptions: Apollo.QueryHookOptions<AllotmentEditQuery, AllotmentEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllotmentEditQuery, AllotmentEditQueryVariables>(AllotmentEditDocument, options);
      }
export function useAllotmentEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllotmentEditQuery, AllotmentEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllotmentEditQuery, AllotmentEditQueryVariables>(AllotmentEditDocument, options);
        }
export type AllotmentEditQueryHookResult = ReturnType<typeof useAllotmentEditQuery>;
export type AllotmentEditLazyQueryHookResult = ReturnType<typeof useAllotmentEditLazyQuery>;
export type AllotmentEditQueryResult = Apollo.QueryResult<AllotmentEditQuery, AllotmentEditQueryVariables>;
export const CreateAllotmentDocument = gql`
    mutation CreateAllotment($input: CreateAllotmentInput!) {
  createAllotment(input: $input) {
    ...AllotmentDetailPage
  }
}
    ${AllotmentDetailPageFragmentDoc}`;
export type CreateAllotmentMutationFn = Apollo.MutationFunction<CreateAllotmentMutation, CreateAllotmentMutationVariables>;

/**
 * __useCreateAllotmentMutation__
 *
 * To run a mutation, you first call `useCreateAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllotmentMutation, { data, loading, error }] = useCreateAllotmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllotmentMutation, CreateAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllotmentMutation, CreateAllotmentMutationVariables>(CreateAllotmentDocument, options);
      }
export type CreateAllotmentMutationHookResult = ReturnType<typeof useCreateAllotmentMutation>;
export type CreateAllotmentMutationResult = Apollo.MutationResult<CreateAllotmentMutation>;
export type CreateAllotmentMutationOptions = Apollo.BaseMutationOptions<CreateAllotmentMutation, CreateAllotmentMutationVariables>;
export const UpdateAllotmentDocument = gql`
    mutation UpdateAllotment($input: UpdateAllotmentInput!) {
  updateAllotment(input: $input) {
    ...AllotmentDetailPage
  }
}
    ${AllotmentDetailPageFragmentDoc}`;
export type UpdateAllotmentMutationFn = Apollo.MutationFunction<UpdateAllotmentMutation, UpdateAllotmentMutationVariables>;

/**
 * __useUpdateAllotmentMutation__
 *
 * To run a mutation, you first call `useUpdateAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllotmentMutation, { data, loading, error }] = useUpdateAllotmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllotmentMutation, UpdateAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllotmentMutation, UpdateAllotmentMutationVariables>(UpdateAllotmentDocument, options);
      }
export type UpdateAllotmentMutationHookResult = ReturnType<typeof useUpdateAllotmentMutation>;
export type UpdateAllotmentMutationResult = Apollo.MutationResult<UpdateAllotmentMutation>;
export type UpdateAllotmentMutationOptions = Apollo.BaseMutationOptions<UpdateAllotmentMutation, UpdateAllotmentMutationVariables>;
export const DeleteAllotmentDocument = gql`
    mutation DeleteAllotment($id: ID!) {
  deleteAllotment(id: $id) {
    id
  }
}
    `;
export type DeleteAllotmentMutationFn = Apollo.MutationFunction<DeleteAllotmentMutation, DeleteAllotmentMutationVariables>;

/**
 * __useDeleteAllotmentMutation__
 *
 * To run a mutation, you first call `useDeleteAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllotmentMutation, { data, loading, error }] = useDeleteAllotmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllotmentMutation, DeleteAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllotmentMutation, DeleteAllotmentMutationVariables>(DeleteAllotmentDocument, options);
      }
export type DeleteAllotmentMutationHookResult = ReturnType<typeof useDeleteAllotmentMutation>;
export type DeleteAllotmentMutationResult = Apollo.MutationResult<DeleteAllotmentMutation>;
export type DeleteAllotmentMutationOptions = Apollo.BaseMutationOptions<DeleteAllotmentMutation, DeleteAllotmentMutationVariables>;
export const IsUserAuthenticatedDocument = gql`
    query IsUserAuthenticated {
  isAuthenticated @client
}
    `;

/**
 * __useIsUserAuthenticatedQuery__
 *
 * To run a query within a React component, call `useIsUserAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserAuthenticatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserAuthenticatedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserAuthenticatedQuery(baseOptions?: Apollo.QueryHookOptions<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>(IsUserAuthenticatedDocument, options);
      }
export function useIsUserAuthenticatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>(IsUserAuthenticatedDocument, options);
        }
export type IsUserAuthenticatedQueryHookResult = ReturnType<typeof useIsUserAuthenticatedQuery>;
export type IsUserAuthenticatedLazyQueryHookResult = ReturnType<typeof useIsUserAuthenticatedLazyQuery>;
export type IsUserAuthenticatedQueryResult = Apollo.QueryResult<IsUserAuthenticatedQuery, IsUserAuthenticatedQueryVariables>;
export const CurrentTenantDocument = gql`
    query CurrentTenant {
  currentTenant {
    id
    subdomain
    name
    use_legacy_newsletter
  }
}
    `;

/**
 * __useCurrentTenantQuery__
 *
 * To run a query within a React component, call `useCurrentTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentTenantQuery(baseOptions?: Apollo.QueryHookOptions<CurrentTenantQuery, CurrentTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentTenantQuery, CurrentTenantQueryVariables>(CurrentTenantDocument, options);
      }
export function useCurrentTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentTenantQuery, CurrentTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentTenantQuery, CurrentTenantQueryVariables>(CurrentTenantDocument, options);
        }
export type CurrentTenantQueryHookResult = ReturnType<typeof useCurrentTenantQuery>;
export type CurrentTenantLazyQueryHookResult = ReturnType<typeof useCurrentTenantLazyQuery>;
export type CurrentTenantQueryResult = Apollo.QueryResult<CurrentTenantQuery, CurrentTenantQueryVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    user {
      id
      email
      display_name
      permissions {
        id
        name
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    status
    message
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    status
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const UpdateForgottenPasswordDocument = gql`
    mutation UpdateForgottenPassword($input: NewPasswordWithCodeInput!) {
  updateForgottenPassword(input: $input) {
    status
    message
  }
}
    `;
export type UpdateForgottenPasswordMutationFn = Apollo.MutationFunction<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>;

/**
 * __useUpdateForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateForgottenPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForgottenPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForgottenPasswordMutation, { data, loading, error }] = useUpdateForgottenPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateForgottenPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>(UpdateForgottenPasswordDocument, options);
      }
export type UpdateForgottenPasswordMutationHookResult = ReturnType<typeof useUpdateForgottenPasswordMutation>;
export type UpdateForgottenPasswordMutationResult = Apollo.MutationResult<UpdateForgottenPasswordMutation>;
export type UpdateForgottenPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>;
export const CategoryListDocument = gql`
    query CategoryList($trashed: Trashed) {
  categories(trashed: $trashed) {
    ...CategoryListItem
  }
}
    ${CategoryListItemFragmentDoc}`;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export const CategoryDetailDocument = gql`
    query CategoryDetail($id: ID!) {
  category(id: $id) {
    id
    ...CategoryDetailPage
  }
}
    ${CategoryDetailPageFragmentDoc}`;

/**
 * __useCategoryDetailQuery__
 *
 * To run a query within a React component, call `useCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryDetailQuery(baseOptions: Apollo.QueryHookOptions<CategoryDetailQuery, CategoryDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryDetailQuery, CategoryDetailQueryVariables>(CategoryDetailDocument, options);
      }
export function useCategoryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryDetailQuery, CategoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryDetailQuery, CategoryDetailQueryVariables>(CategoryDetailDocument, options);
        }
export type CategoryDetailQueryHookResult = ReturnType<typeof useCategoryDetailQuery>;
export type CategoryDetailLazyQueryHookResult = ReturnType<typeof useCategoryDetailLazyQuery>;
export type CategoryDetailQueryResult = Apollo.QueryResult<CategoryDetailQuery, CategoryDetailQueryVariables>;
export const CategoryEditDocument = gql`
    query CategoryEdit($id: ID!) {
  category(id: $id) {
    id
    ...CategoryEditForm
  }
}
    ${CategoryEditFormFragmentDoc}`;

/**
 * __useCategoryEditQuery__
 *
 * To run a query within a React component, call `useCategoryEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryEditQuery(baseOptions: Apollo.QueryHookOptions<CategoryEditQuery, CategoryEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryEditQuery, CategoryEditQueryVariables>(CategoryEditDocument, options);
      }
export function useCategoryEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryEditQuery, CategoryEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryEditQuery, CategoryEditQueryVariables>(CategoryEditDocument, options);
        }
export type CategoryEditQueryHookResult = ReturnType<typeof useCategoryEditQuery>;
export type CategoryEditLazyQueryHookResult = ReturnType<typeof useCategoryEditLazyQuery>;
export type CategoryEditQueryResult = Apollo.QueryResult<CategoryEditQuery, CategoryEditQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($input: CreateCategoryInput!) {
  createCategory(input: $input) {
    ...CategoryDetailPage
  }
}
    ${CategoryDetailPageFragmentDoc}`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    ...CategoryDetailPage
  }
}
    ${CategoryDetailPageFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($id: ID!) {
  deleteCategory(id: $id) {
    id
  }
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const RestoreCategoriesDocument = gql`
    mutation RestoreCategories($ids: [ID!]!) {
  restoreCategories(ids: $ids) {
    id
  }
}
    `;
export type RestoreCategoriesMutationFn = Apollo.MutationFunction<RestoreCategoriesMutation, RestoreCategoriesMutationVariables>;

/**
 * __useRestoreCategoriesMutation__
 *
 * To run a mutation, you first call `useRestoreCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCategoriesMutation, { data, loading, error }] = useRestoreCategoriesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCategoriesMutation, RestoreCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCategoriesMutation, RestoreCategoriesMutationVariables>(RestoreCategoriesDocument, options);
      }
export type RestoreCategoriesMutationHookResult = ReturnType<typeof useRestoreCategoriesMutation>;
export type RestoreCategoriesMutationResult = Apollo.MutationResult<RestoreCategoriesMutation>;
export type RestoreCategoriesMutationOptions = Apollo.BaseMutationOptions<RestoreCategoriesMutation, RestoreCategoriesMutationVariables>;
export const ForceDeleteCategoriesDocument = gql`
    mutation ForceDeleteCategories($ids: [ID!]!) {
  forceDeleteCategories(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteCategoriesMutationFn = Apollo.MutationFunction<ForceDeleteCategoriesMutation, ForceDeleteCategoriesMutationVariables>;

/**
 * __useForceDeleteCategoriesMutation__
 *
 * To run a mutation, you first call `useForceDeleteCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteCategoriesMutation, { data, loading, error }] = useForceDeleteCategoriesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteCategoriesMutation, ForceDeleteCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteCategoriesMutation, ForceDeleteCategoriesMutationVariables>(ForceDeleteCategoriesDocument, options);
      }
export type ForceDeleteCategoriesMutationHookResult = ReturnType<typeof useForceDeleteCategoriesMutation>;
export type ForceDeleteCategoriesMutationResult = Apollo.MutationResult<ForceDeleteCategoriesMutation>;
export type ForceDeleteCategoriesMutationOptions = Apollo.BaseMutationOptions<ForceDeleteCategoriesMutation, ForceDeleteCategoriesMutationVariables>;
export const EmptyCategoryTrashDocument = gql`
    mutation EmptyCategoryTrash {
  emptyCategoryTrash {
    id
  }
}
    `;
export type EmptyCategoryTrashMutationFn = Apollo.MutationFunction<EmptyCategoryTrashMutation, EmptyCategoryTrashMutationVariables>;

/**
 * __useEmptyCategoryTrashMutation__
 *
 * To run a mutation, you first call `useEmptyCategoryTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyCategoryTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyCategoryTrashMutation, { data, loading, error }] = useEmptyCategoryTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyCategoryTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyCategoryTrashMutation, EmptyCategoryTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyCategoryTrashMutation, EmptyCategoryTrashMutationVariables>(EmptyCategoryTrashDocument, options);
      }
export type EmptyCategoryTrashMutationHookResult = ReturnType<typeof useEmptyCategoryTrashMutation>;
export type EmptyCategoryTrashMutationResult = Apollo.MutationResult<EmptyCategoryTrashMutation>;
export type EmptyCategoryTrashMutationOptions = Apollo.BaseMutationOptions<EmptyCategoryTrashMutation, EmptyCategoryTrashMutationVariables>;
export const CompanionListDocument = gql`
    query CompanionList($status: UserStatus, $orderByColumn: QueryCompanionsOrderByColumn = LAST_NAME, $orderByOrder: SortOrder = ASC, $page: Int, $trashed: Trashed = WITHOUT) {
  companions(
    status: $status
    first: 20
    orderBy: [{column: $orderByColumn, order: $orderByOrder}]
    page: $page
    trashed: $trashed
  ) {
    data {
      ...CompanionListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${CompanionListItemFragmentDoc}`;

/**
 * __useCompanionListQuery__
 *
 * To run a query within a React component, call `useCompanionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      orderByColumn: // value for 'orderByColumn'
 *      orderByOrder: // value for 'orderByOrder'
 *      page: // value for 'page'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useCompanionListQuery(baseOptions?: Apollo.QueryHookOptions<CompanionListQuery, CompanionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionListQuery, CompanionListQueryVariables>(CompanionListDocument, options);
      }
export function useCompanionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionListQuery, CompanionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionListQuery, CompanionListQueryVariables>(CompanionListDocument, options);
        }
export type CompanionListQueryHookResult = ReturnType<typeof useCompanionListQuery>;
export type CompanionListLazyQueryHookResult = ReturnType<typeof useCompanionListLazyQuery>;
export type CompanionListQueryResult = Apollo.QueryResult<CompanionListQuery, CompanionListQueryVariables>;
export const CompanionDetailDocument = gql`
    query CompanionDetail($id: ID!) {
  companion(id: $id) {
    id
    ...CompanionInfo
  }
}
    ${CompanionInfoFragmentDoc}`;

/**
 * __useCompanionDetailQuery__
 *
 * To run a query within a React component, call `useCompanionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanionDetailQuery(baseOptions: Apollo.QueryHookOptions<CompanionDetailQuery, CompanionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionDetailQuery, CompanionDetailQueryVariables>(CompanionDetailDocument, options);
      }
export function useCompanionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionDetailQuery, CompanionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionDetailQuery, CompanionDetailQueryVariables>(CompanionDetailDocument, options);
        }
export type CompanionDetailQueryHookResult = ReturnType<typeof useCompanionDetailQuery>;
export type CompanionDetailLazyQueryHookResult = ReturnType<typeof useCompanionDetailLazyQuery>;
export type CompanionDetailQueryResult = Apollo.QueryResult<CompanionDetailQuery, CompanionDetailQueryVariables>;
export const CompanionEmailsDocument = gql`
    query CompanionEmails($id: ID!, $page: Int) {
  companion(id: $id) {
    id
    emails(first: 10, page: $page) {
      data {
        ...EmailListItem
      }
      paginatorInfo {
        currentPage
        hasMorePages
        lastPage
      }
    }
  }
}
    ${EmailListItemFragmentDoc}`;

/**
 * __useCompanionEmailsQuery__
 *
 * To run a query within a React component, call `useCompanionEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionEmailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCompanionEmailsQuery(baseOptions: Apollo.QueryHookOptions<CompanionEmailsQuery, CompanionEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionEmailsQuery, CompanionEmailsQueryVariables>(CompanionEmailsDocument, options);
      }
export function useCompanionEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionEmailsQuery, CompanionEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionEmailsQuery, CompanionEmailsQueryVariables>(CompanionEmailsDocument, options);
        }
export type CompanionEmailsQueryHookResult = ReturnType<typeof useCompanionEmailsQuery>;
export type CompanionEmailsLazyQueryHookResult = ReturnType<typeof useCompanionEmailsLazyQuery>;
export type CompanionEmailsQueryResult = Apollo.QueryResult<CompanionEmailsQuery, CompanionEmailsQueryVariables>;
export const CompanionEditDocument = gql`
    query CompanionEdit($id: ID!) {
  companion(id: $id) {
    ...CompanionEditForm
  }
}
    ${CompanionEditFormFragmentDoc}`;

/**
 * __useCompanionEditQuery__
 *
 * To run a query within a React component, call `useCompanionEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanionEditQuery(baseOptions: Apollo.QueryHookOptions<CompanionEditQuery, CompanionEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionEditQuery, CompanionEditQueryVariables>(CompanionEditDocument, options);
      }
export function useCompanionEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionEditQuery, CompanionEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionEditQuery, CompanionEditQueryVariables>(CompanionEditDocument, options);
        }
export type CompanionEditQueryHookResult = ReturnType<typeof useCompanionEditQuery>;
export type CompanionEditLazyQueryHookResult = ReturnType<typeof useCompanionEditLazyQuery>;
export type CompanionEditQueryResult = Apollo.QueryResult<CompanionEditQuery, CompanionEditQueryVariables>;
export const CreateCompanionDocument = gql`
    mutation CreateCompanion($input: CreateCompanionInput!) {
  createCompanion(input: $input) {
    ...CompanionInfo
  }
}
    ${CompanionInfoFragmentDoc}`;
export type CreateCompanionMutationFn = Apollo.MutationFunction<CreateCompanionMutation, CreateCompanionMutationVariables>;

/**
 * __useCreateCompanionMutation__
 *
 * To run a mutation, you first call `useCreateCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanionMutation, { data, loading, error }] = useCreateCompanionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanionMutation, CreateCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanionMutation, CreateCompanionMutationVariables>(CreateCompanionDocument, options);
      }
export type CreateCompanionMutationHookResult = ReturnType<typeof useCreateCompanionMutation>;
export type CreateCompanionMutationResult = Apollo.MutationResult<CreateCompanionMutation>;
export type CreateCompanionMutationOptions = Apollo.BaseMutationOptions<CreateCompanionMutation, CreateCompanionMutationVariables>;
export const UpdateCompanionDocument = gql`
    mutation UpdateCompanion($input: UpdateCompanionInput!) {
  updateCompanion(input: $input) {
    ...CompanionInfo
  }
}
    ${CompanionInfoFragmentDoc}`;
export type UpdateCompanionMutationFn = Apollo.MutationFunction<UpdateCompanionMutation, UpdateCompanionMutationVariables>;

/**
 * __useUpdateCompanionMutation__
 *
 * To run a mutation, you first call `useUpdateCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanionMutation, { data, loading, error }] = useUpdateCompanionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanionMutation, UpdateCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanionMutation, UpdateCompanionMutationVariables>(UpdateCompanionDocument, options);
      }
export type UpdateCompanionMutationHookResult = ReturnType<typeof useUpdateCompanionMutation>;
export type UpdateCompanionMutationResult = Apollo.MutationResult<UpdateCompanionMutation>;
export type UpdateCompanionMutationOptions = Apollo.BaseMutationOptions<UpdateCompanionMutation, UpdateCompanionMutationVariables>;
export const ApproveCompanionDocument = gql`
    mutation ApproveCompanion($id: ID!) {
  approveCompanion(id: $id) {
    id
    status
  }
}
    `;
export type ApproveCompanionMutationFn = Apollo.MutationFunction<ApproveCompanionMutation, ApproveCompanionMutationVariables>;

/**
 * __useApproveCompanionMutation__
 *
 * To run a mutation, you first call `useApproveCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCompanionMutation, { data, loading, error }] = useApproveCompanionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveCompanionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCompanionMutation, ApproveCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCompanionMutation, ApproveCompanionMutationVariables>(ApproveCompanionDocument, options);
      }
export type ApproveCompanionMutationHookResult = ReturnType<typeof useApproveCompanionMutation>;
export type ApproveCompanionMutationResult = Apollo.MutationResult<ApproveCompanionMutation>;
export type ApproveCompanionMutationOptions = Apollo.BaseMutationOptions<ApproveCompanionMutation, ApproveCompanionMutationVariables>;
export const DenyCompanionDocument = gql`
    mutation DenyCompanion($id: ID!) {
  denyCompanion(id: $id) {
    id
    status
  }
}
    `;
export type DenyCompanionMutationFn = Apollo.MutationFunction<DenyCompanionMutation, DenyCompanionMutationVariables>;

/**
 * __useDenyCompanionMutation__
 *
 * To run a mutation, you first call `useDenyCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyCompanionMutation, { data, loading, error }] = useDenyCompanionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDenyCompanionMutation(baseOptions?: Apollo.MutationHookOptions<DenyCompanionMutation, DenyCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyCompanionMutation, DenyCompanionMutationVariables>(DenyCompanionDocument, options);
      }
export type DenyCompanionMutationHookResult = ReturnType<typeof useDenyCompanionMutation>;
export type DenyCompanionMutationResult = Apollo.MutationResult<DenyCompanionMutation>;
export type DenyCompanionMutationOptions = Apollo.BaseMutationOptions<DenyCompanionMutation, DenyCompanionMutationVariables>;
export const ActivateCompanionDocument = gql`
    mutation ActivateCompanion($id: ID!) {
  activateCompanion(id: $id) {
    id
    status
  }
}
    `;
export type ActivateCompanionMutationFn = Apollo.MutationFunction<ActivateCompanionMutation, ActivateCompanionMutationVariables>;

/**
 * __useActivateCompanionMutation__
 *
 * To run a mutation, you first call `useActivateCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCompanionMutation, { data, loading, error }] = useActivateCompanionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateCompanionMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCompanionMutation, ActivateCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCompanionMutation, ActivateCompanionMutationVariables>(ActivateCompanionDocument, options);
      }
export type ActivateCompanionMutationHookResult = ReturnType<typeof useActivateCompanionMutation>;
export type ActivateCompanionMutationResult = Apollo.MutationResult<ActivateCompanionMutation>;
export type ActivateCompanionMutationOptions = Apollo.BaseMutationOptions<ActivateCompanionMutation, ActivateCompanionMutationVariables>;
export const DeactivateCompanionDocument = gql`
    mutation DeactivateCompanion($id: ID!) {
  deactivateCompanion(id: $id) {
    id
    status
  }
}
    `;
export type DeactivateCompanionMutationFn = Apollo.MutationFunction<DeactivateCompanionMutation, DeactivateCompanionMutationVariables>;

/**
 * __useDeactivateCompanionMutation__
 *
 * To run a mutation, you first call `useDeactivateCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCompanionMutation, { data, loading, error }] = useDeactivateCompanionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateCompanionMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCompanionMutation, DeactivateCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCompanionMutation, DeactivateCompanionMutationVariables>(DeactivateCompanionDocument, options);
      }
export type DeactivateCompanionMutationHookResult = ReturnType<typeof useDeactivateCompanionMutation>;
export type DeactivateCompanionMutationResult = Apollo.MutationResult<DeactivateCompanionMutation>;
export type DeactivateCompanionMutationOptions = Apollo.BaseMutationOptions<DeactivateCompanionMutation, DeactivateCompanionMutationVariables>;
export const DeleteCompanionDocument = gql`
    mutation DeleteCompanion($id: ID!) {
  deleteCompanion(id: $id) {
    id
  }
}
    `;
export type DeleteCompanionMutationFn = Apollo.MutationFunction<DeleteCompanionMutation, DeleteCompanionMutationVariables>;

/**
 * __useDeleteCompanionMutation__
 *
 * To run a mutation, you first call `useDeleteCompanionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanionMutation, { data, loading, error }] = useDeleteCompanionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanionMutation, DeleteCompanionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanionMutation, DeleteCompanionMutationVariables>(DeleteCompanionDocument, options);
      }
export type DeleteCompanionMutationHookResult = ReturnType<typeof useDeleteCompanionMutation>;
export type DeleteCompanionMutationResult = Apollo.MutationResult<DeleteCompanionMutation>;
export type DeleteCompanionMutationOptions = Apollo.BaseMutationOptions<DeleteCompanionMutation, DeleteCompanionMutationVariables>;
export const RestoreCompanionsDocument = gql`
    mutation RestoreCompanions($ids: [ID!]!) {
  restoreCompanions(ids: $ids) {
    id
  }
}
    `;
export type RestoreCompanionsMutationFn = Apollo.MutationFunction<RestoreCompanionsMutation, RestoreCompanionsMutationVariables>;

/**
 * __useRestoreCompanionsMutation__
 *
 * To run a mutation, you first call `useRestoreCompanionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCompanionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCompanionsMutation, { data, loading, error }] = useRestoreCompanionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreCompanionsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCompanionsMutation, RestoreCompanionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCompanionsMutation, RestoreCompanionsMutationVariables>(RestoreCompanionsDocument, options);
      }
export type RestoreCompanionsMutationHookResult = ReturnType<typeof useRestoreCompanionsMutation>;
export type RestoreCompanionsMutationResult = Apollo.MutationResult<RestoreCompanionsMutation>;
export type RestoreCompanionsMutationOptions = Apollo.BaseMutationOptions<RestoreCompanionsMutation, RestoreCompanionsMutationVariables>;
export const ForceDeleteCompanionsDocument = gql`
    mutation ForceDeleteCompanions($ids: [ID!]!) {
  forceDeleteCompanions(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteCompanionsMutationFn = Apollo.MutationFunction<ForceDeleteCompanionsMutation, ForceDeleteCompanionsMutationVariables>;

/**
 * __useForceDeleteCompanionsMutation__
 *
 * To run a mutation, you first call `useForceDeleteCompanionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteCompanionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteCompanionsMutation, { data, loading, error }] = useForceDeleteCompanionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteCompanionsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteCompanionsMutation, ForceDeleteCompanionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteCompanionsMutation, ForceDeleteCompanionsMutationVariables>(ForceDeleteCompanionsDocument, options);
      }
export type ForceDeleteCompanionsMutationHookResult = ReturnType<typeof useForceDeleteCompanionsMutation>;
export type ForceDeleteCompanionsMutationResult = Apollo.MutationResult<ForceDeleteCompanionsMutation>;
export type ForceDeleteCompanionsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteCompanionsMutation, ForceDeleteCompanionsMutationVariables>;
export const EmptyCompanionTrashDocument = gql`
    mutation EmptyCompanionTrash {
  emptyCompanionTrash {
    id
  }
}
    `;
export type EmptyCompanionTrashMutationFn = Apollo.MutationFunction<EmptyCompanionTrashMutation, EmptyCompanionTrashMutationVariables>;

/**
 * __useEmptyCompanionTrashMutation__
 *
 * To run a mutation, you first call `useEmptyCompanionTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyCompanionTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyCompanionTrashMutation, { data, loading, error }] = useEmptyCompanionTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyCompanionTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyCompanionTrashMutation, EmptyCompanionTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyCompanionTrashMutation, EmptyCompanionTrashMutationVariables>(EmptyCompanionTrashDocument, options);
      }
export type EmptyCompanionTrashMutationHookResult = ReturnType<typeof useEmptyCompanionTrashMutation>;
export type EmptyCompanionTrashMutationResult = Apollo.MutationResult<EmptyCompanionTrashMutation>;
export type EmptyCompanionTrashMutationOptions = Apollo.BaseMutationOptions<EmptyCompanionTrashMutation, EmptyCompanionTrashMutationVariables>;
export const ContactListDocument = gql`
    query ContactList($trashed: Trashed) {
  contacts(trashed: $trashed) {
    ...ContactListItem
  }
}
    ${ContactListItemFragmentDoc}`;

/**
 * __useContactListQuery__
 *
 * To run a query within a React component, call `useContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListQuery({
 *   variables: {
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useContactListQuery(baseOptions?: Apollo.QueryHookOptions<ContactListQuery, ContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListQuery, ContactListQueryVariables>(ContactListDocument, options);
      }
export function useContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListQuery, ContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListQuery, ContactListQueryVariables>(ContactListDocument, options);
        }
export type ContactListQueryHookResult = ReturnType<typeof useContactListQuery>;
export type ContactListLazyQueryHookResult = ReturnType<typeof useContactListLazyQuery>;
export type ContactListQueryResult = Apollo.QueryResult<ContactListQuery, ContactListQueryVariables>;
export const ContactDetailDocument = gql`
    query ContactDetail($id: ID!) {
  contact(id: $id) {
    id
    ...ContactInfo
  }
}
    ${ContactInfoFragmentDoc}`;

/**
 * __useContactDetailQuery__
 *
 * To run a query within a React component, call `useContactDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactDetailQuery(baseOptions: Apollo.QueryHookOptions<ContactDetailQuery, ContactDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactDetailQuery, ContactDetailQueryVariables>(ContactDetailDocument, options);
      }
export function useContactDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactDetailQuery, ContactDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactDetailQuery, ContactDetailQueryVariables>(ContactDetailDocument, options);
        }
export type ContactDetailQueryHookResult = ReturnType<typeof useContactDetailQuery>;
export type ContactDetailLazyQueryHookResult = ReturnType<typeof useContactDetailLazyQuery>;
export type ContactDetailQueryResult = Apollo.QueryResult<ContactDetailQuery, ContactDetailQueryVariables>;
export const ContactEditDocument = gql`
    query ContactEdit($id: ID!) {
  contact(id: $id) {
    id
    ...ContactEditForm
  }
}
    ${ContactEditFormFragmentDoc}`;

/**
 * __useContactEditQuery__
 *
 * To run a query within a React component, call `useContactEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactEditQuery(baseOptions: Apollo.QueryHookOptions<ContactEditQuery, ContactEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactEditQuery, ContactEditQueryVariables>(ContactEditDocument, options);
      }
export function useContactEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactEditQuery, ContactEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactEditQuery, ContactEditQueryVariables>(ContactEditDocument, options);
        }
export type ContactEditQueryHookResult = ReturnType<typeof useContactEditQuery>;
export type ContactEditLazyQueryHookResult = ReturnType<typeof useContactEditLazyQuery>;
export type ContactEditQueryResult = Apollo.QueryResult<ContactEditQuery, ContactEditQueryVariables>;
export const ContactEmailsDocument = gql`
    query ContactEmails($id: ID!, $page: Int) {
  contact(id: $id) {
    id
    emails(first: 10, page: $page) {
      data {
        ...EmailListItem
      }
      paginatorInfo {
        currentPage
        hasMorePages
        lastPage
      }
    }
  }
}
    ${EmailListItemFragmentDoc}`;

/**
 * __useContactEmailsQuery__
 *
 * To run a query within a React component, call `useContactEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactEmailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useContactEmailsQuery(baseOptions: Apollo.QueryHookOptions<ContactEmailsQuery, ContactEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactEmailsQuery, ContactEmailsQueryVariables>(ContactEmailsDocument, options);
      }
export function useContactEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactEmailsQuery, ContactEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactEmailsQuery, ContactEmailsQueryVariables>(ContactEmailsDocument, options);
        }
export type ContactEmailsQueryHookResult = ReturnType<typeof useContactEmailsQuery>;
export type ContactEmailsLazyQueryHookResult = ReturnType<typeof useContactEmailsLazyQuery>;
export type ContactEmailsQueryResult = Apollo.QueryResult<ContactEmailsQuery, ContactEmailsQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...ContactInfo
  }
}
    ${ContactInfoFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    ...ContactInfo
  }
}
    ${ContactInfoFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: ID!) {
  deleteContact(id: $id) {
    id
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const RestoreContactsDocument = gql`
    mutation RestoreContacts($ids: [ID!]!) {
  restoreContacts(ids: $ids) {
    id
  }
}
    `;
export type RestoreContactsMutationFn = Apollo.MutationFunction<RestoreContactsMutation, RestoreContactsMutationVariables>;

/**
 * __useRestoreContactsMutation__
 *
 * To run a mutation, you first call `useRestoreContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreContactsMutation, { data, loading, error }] = useRestoreContactsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreContactsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreContactsMutation, RestoreContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreContactsMutation, RestoreContactsMutationVariables>(RestoreContactsDocument, options);
      }
export type RestoreContactsMutationHookResult = ReturnType<typeof useRestoreContactsMutation>;
export type RestoreContactsMutationResult = Apollo.MutationResult<RestoreContactsMutation>;
export type RestoreContactsMutationOptions = Apollo.BaseMutationOptions<RestoreContactsMutation, RestoreContactsMutationVariables>;
export const ForceDeleteContactsDocument = gql`
    mutation ForceDeleteContacts($ids: [ID!]!) {
  forceDeleteContacts(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteContactsMutationFn = Apollo.MutationFunction<ForceDeleteContactsMutation, ForceDeleteContactsMutationVariables>;

/**
 * __useForceDeleteContactsMutation__
 *
 * To run a mutation, you first call `useForceDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteContactsMutation, { data, loading, error }] = useForceDeleteContactsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteContactsMutation, ForceDeleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteContactsMutation, ForceDeleteContactsMutationVariables>(ForceDeleteContactsDocument, options);
      }
export type ForceDeleteContactsMutationHookResult = ReturnType<typeof useForceDeleteContactsMutation>;
export type ForceDeleteContactsMutationResult = Apollo.MutationResult<ForceDeleteContactsMutation>;
export type ForceDeleteContactsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteContactsMutation, ForceDeleteContactsMutationVariables>;
export const EmptyContactTrashDocument = gql`
    mutation EmptyContactTrash {
  emptyContactTrash {
    id
  }
}
    `;
export type EmptyContactTrashMutationFn = Apollo.MutationFunction<EmptyContactTrashMutation, EmptyContactTrashMutationVariables>;

/**
 * __useEmptyContactTrashMutation__
 *
 * To run a mutation, you first call `useEmptyContactTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyContactTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyContactTrashMutation, { data, loading, error }] = useEmptyContactTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyContactTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyContactTrashMutation, EmptyContactTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyContactTrashMutation, EmptyContactTrashMutationVariables>(EmptyContactTrashDocument, options);
      }
export type EmptyContactTrashMutationHookResult = ReturnType<typeof useEmptyContactTrashMutation>;
export type EmptyContactTrashMutationResult = Apollo.MutationResult<EmptyContactTrashMutation>;
export type EmptyContactTrashMutationOptions = Apollo.BaseMutationOptions<EmptyContactTrashMutation, EmptyContactTrashMutationVariables>;
export const DonorListDocument = gql`
    query DonorList($page: Int, $trashed: Trashed) {
  donors(first: 20, page: $page, trashed: $trashed) {
    data {
      ...DonorListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${DonorListItemFragmentDoc}`;

/**
 * __useDonorListQuery__
 *
 * To run a query within a React component, call `useDonorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useDonorListQuery(baseOptions?: Apollo.QueryHookOptions<DonorListQuery, DonorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorListQuery, DonorListQueryVariables>(DonorListDocument, options);
      }
export function useDonorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorListQuery, DonorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorListQuery, DonorListQueryVariables>(DonorListDocument, options);
        }
export type DonorListQueryHookResult = ReturnType<typeof useDonorListQuery>;
export type DonorListLazyQueryHookResult = ReturnType<typeof useDonorListLazyQuery>;
export type DonorListQueryResult = Apollo.QueryResult<DonorListQuery, DonorListQueryVariables>;
export const DonorDetailDocument = gql`
    query DonorDetail($id: ID!) {
  donor(id: $id) {
    id
    ...DonorInfo
  }
}
    ${DonorInfoFragmentDoc}`;

/**
 * __useDonorDetailQuery__
 *
 * To run a query within a React component, call `useDonorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDonorDetailQuery(baseOptions: Apollo.QueryHookOptions<DonorDetailQuery, DonorDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorDetailQuery, DonorDetailQueryVariables>(DonorDetailDocument, options);
      }
export function useDonorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorDetailQuery, DonorDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorDetailQuery, DonorDetailQueryVariables>(DonorDetailDocument, options);
        }
export type DonorDetailQueryHookResult = ReturnType<typeof useDonorDetailQuery>;
export type DonorDetailLazyQueryHookResult = ReturnType<typeof useDonorDetailLazyQuery>;
export type DonorDetailQueryResult = Apollo.QueryResult<DonorDetailQuery, DonorDetailQueryVariables>;
export const DonorContactsDocument = gql`
    query DonorContacts($id: ID!) {
  donor(id: $id) {
    id
    contacts {
      ...ContactListItem
    }
  }
}
    ${ContactListItemFragmentDoc}`;

/**
 * __useDonorContactsQuery__
 *
 * To run a query within a React component, call `useDonorContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDonorContactsQuery(baseOptions: Apollo.QueryHookOptions<DonorContactsQuery, DonorContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorContactsQuery, DonorContactsQueryVariables>(DonorContactsDocument, options);
      }
export function useDonorContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorContactsQuery, DonorContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorContactsQuery, DonorContactsQueryVariables>(DonorContactsDocument, options);
        }
export type DonorContactsQueryHookResult = ReturnType<typeof useDonorContactsQuery>;
export type DonorContactsLazyQueryHookResult = ReturnType<typeof useDonorContactsLazyQuery>;
export type DonorContactsQueryResult = Apollo.QueryResult<DonorContactsQuery, DonorContactsQueryVariables>;
export const DonorContactSelectDocument = gql`
    query DonorContactSelect($id: ID!) {
  donor(id: $id) {
    id
    contacts {
      ...ContactSelect
    }
  }
}
    ${ContactSelectFragmentDoc}`;

/**
 * __useDonorContactSelectQuery__
 *
 * To run a query within a React component, call `useDonorContactSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorContactSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorContactSelectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDonorContactSelectQuery(baseOptions: Apollo.QueryHookOptions<DonorContactSelectQuery, DonorContactSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorContactSelectQuery, DonorContactSelectQueryVariables>(DonorContactSelectDocument, options);
      }
export function useDonorContactSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorContactSelectQuery, DonorContactSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorContactSelectQuery, DonorContactSelectQueryVariables>(DonorContactSelectDocument, options);
        }
export type DonorContactSelectQueryHookResult = ReturnType<typeof useDonorContactSelectQuery>;
export type DonorContactSelectLazyQueryHookResult = ReturnType<typeof useDonorContactSelectLazyQuery>;
export type DonorContactSelectQueryResult = Apollo.QueryResult<DonorContactSelectQuery, DonorContactSelectQueryVariables>;
export const DonorLocationsDocument = gql`
    query DonorLocations($id: ID!) {
  donor(id: $id) {
    id
    locations {
      ...LocationListItem
    }
  }
}
    ${LocationListItemFragmentDoc}`;

/**
 * __useDonorLocationsQuery__
 *
 * To run a query within a React component, call `useDonorLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorLocationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDonorLocationsQuery(baseOptions: Apollo.QueryHookOptions<DonorLocationsQuery, DonorLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorLocationsQuery, DonorLocationsQueryVariables>(DonorLocationsDocument, options);
      }
export function useDonorLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorLocationsQuery, DonorLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorLocationsQuery, DonorLocationsQueryVariables>(DonorLocationsDocument, options);
        }
export type DonorLocationsQueryHookResult = ReturnType<typeof useDonorLocationsQuery>;
export type DonorLocationsLazyQueryHookResult = ReturnType<typeof useDonorLocationsLazyQuery>;
export type DonorLocationsQueryResult = Apollo.QueryResult<DonorLocationsQuery, DonorLocationsQueryVariables>;
export const DonorLocationSelectDocument = gql`
    query DonorLocationSelect($id: ID!) {
  donor(id: $id) {
    id
    locations {
      ...LocationSelect
    }
  }
}
    ${LocationSelectFragmentDoc}`;

/**
 * __useDonorLocationSelectQuery__
 *
 * To run a query within a React component, call `useDonorLocationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorLocationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorLocationSelectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDonorLocationSelectQuery(baseOptions: Apollo.QueryHookOptions<DonorLocationSelectQuery, DonorLocationSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorLocationSelectQuery, DonorLocationSelectQueryVariables>(DonorLocationSelectDocument, options);
      }
export function useDonorLocationSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorLocationSelectQuery, DonorLocationSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorLocationSelectQuery, DonorLocationSelectQueryVariables>(DonorLocationSelectDocument, options);
        }
export type DonorLocationSelectQueryHookResult = ReturnType<typeof useDonorLocationSelectQuery>;
export type DonorLocationSelectLazyQueryHookResult = ReturnType<typeof useDonorLocationSelectLazyQuery>;
export type DonorLocationSelectQueryResult = Apollo.QueryResult<DonorLocationSelectQuery, DonorLocationSelectQueryVariables>;
export const CreateDonorDocument = gql`
    mutation CreateDonor($input: CreateDonorInput!) {
  createDonor(input: $input) {
    ...DonorInfo
  }
}
    ${DonorInfoFragmentDoc}`;
export type CreateDonorMutationFn = Apollo.MutationFunction<CreateDonorMutation, CreateDonorMutationVariables>;

/**
 * __useCreateDonorMutation__
 *
 * To run a mutation, you first call `useCreateDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonorMutation, { data, loading, error }] = useCreateDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonorMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonorMutation, CreateDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonorMutation, CreateDonorMutationVariables>(CreateDonorDocument, options);
      }
export type CreateDonorMutationHookResult = ReturnType<typeof useCreateDonorMutation>;
export type CreateDonorMutationResult = Apollo.MutationResult<CreateDonorMutation>;
export type CreateDonorMutationOptions = Apollo.BaseMutationOptions<CreateDonorMutation, CreateDonorMutationVariables>;
export const DonorEditDocument = gql`
    query DonorEdit($id: ID!) {
  donor(id: $id) {
    id
    ...DonorEditForm
  }
}
    ${DonorEditFormFragmentDoc}`;

/**
 * __useDonorEditQuery__
 *
 * To run a query within a React component, call `useDonorEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonorEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonorEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDonorEditQuery(baseOptions: Apollo.QueryHookOptions<DonorEditQuery, DonorEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonorEditQuery, DonorEditQueryVariables>(DonorEditDocument, options);
      }
export function useDonorEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonorEditQuery, DonorEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonorEditQuery, DonorEditQueryVariables>(DonorEditDocument, options);
        }
export type DonorEditQueryHookResult = ReturnType<typeof useDonorEditQuery>;
export type DonorEditLazyQueryHookResult = ReturnType<typeof useDonorEditLazyQuery>;
export type DonorEditQueryResult = Apollo.QueryResult<DonorEditQuery, DonorEditQueryVariables>;
export const UpdateDonorDocument = gql`
    mutation UpdateDonor($input: UpdateDonorInput!) {
  updateDonor(input: $input) {
    ...DonorInfo
  }
}
    ${DonorInfoFragmentDoc}`;
export type UpdateDonorMutationFn = Apollo.MutationFunction<UpdateDonorMutation, UpdateDonorMutationVariables>;

/**
 * __useUpdateDonorMutation__
 *
 * To run a mutation, you first call `useUpdateDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonorMutation, { data, loading, error }] = useUpdateDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDonorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonorMutation, UpdateDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonorMutation, UpdateDonorMutationVariables>(UpdateDonorDocument, options);
      }
export type UpdateDonorMutationHookResult = ReturnType<typeof useUpdateDonorMutation>;
export type UpdateDonorMutationResult = Apollo.MutationResult<UpdateDonorMutation>;
export type UpdateDonorMutationOptions = Apollo.BaseMutationOptions<UpdateDonorMutation, UpdateDonorMutationVariables>;
export const SetDonorLogoDocument = gql`
    mutation SetDonorLogo($input: SetMediaInput!) {
  setDonorLogo(input: $input) {
    id
    logo {
      name
      thumb_url
    }
  }
}
    `;
export type SetDonorLogoMutationFn = Apollo.MutationFunction<SetDonorLogoMutation, SetDonorLogoMutationVariables>;

/**
 * __useSetDonorLogoMutation__
 *
 * To run a mutation, you first call `useSetDonorLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDonorLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDonorLogoMutation, { data, loading, error }] = useSetDonorLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDonorLogoMutation(baseOptions?: Apollo.MutationHookOptions<SetDonorLogoMutation, SetDonorLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDonorLogoMutation, SetDonorLogoMutationVariables>(SetDonorLogoDocument, options);
      }
export type SetDonorLogoMutationHookResult = ReturnType<typeof useSetDonorLogoMutation>;
export type SetDonorLogoMutationResult = Apollo.MutationResult<SetDonorLogoMutation>;
export type SetDonorLogoMutationOptions = Apollo.BaseMutationOptions<SetDonorLogoMutation, SetDonorLogoMutationVariables>;
export const DeleteDonorDocument = gql`
    mutation DeleteDonor($id: ID!) {
  deleteDonor(id: $id) {
    id
  }
}
    `;
export type DeleteDonorMutationFn = Apollo.MutationFunction<DeleteDonorMutation, DeleteDonorMutationVariables>;

/**
 * __useDeleteDonorMutation__
 *
 * To run a mutation, you first call `useDeleteDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDonorMutation, { data, loading, error }] = useDeleteDonorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDonorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDonorMutation, DeleteDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDonorMutation, DeleteDonorMutationVariables>(DeleteDonorDocument, options);
      }
export type DeleteDonorMutationHookResult = ReturnType<typeof useDeleteDonorMutation>;
export type DeleteDonorMutationResult = Apollo.MutationResult<DeleteDonorMutation>;
export type DeleteDonorMutationOptions = Apollo.BaseMutationOptions<DeleteDonorMutation, DeleteDonorMutationVariables>;
export const RestoreDonorsDocument = gql`
    mutation RestoreDonors($ids: [ID!]!) {
  restoreDonors(ids: $ids) {
    id
  }
}
    `;
export type RestoreDonorsMutationFn = Apollo.MutationFunction<RestoreDonorsMutation, RestoreDonorsMutationVariables>;

/**
 * __useRestoreDonorsMutation__
 *
 * To run a mutation, you first call `useRestoreDonorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDonorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDonorsMutation, { data, loading, error }] = useRestoreDonorsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreDonorsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDonorsMutation, RestoreDonorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDonorsMutation, RestoreDonorsMutationVariables>(RestoreDonorsDocument, options);
      }
export type RestoreDonorsMutationHookResult = ReturnType<typeof useRestoreDonorsMutation>;
export type RestoreDonorsMutationResult = Apollo.MutationResult<RestoreDonorsMutation>;
export type RestoreDonorsMutationOptions = Apollo.BaseMutationOptions<RestoreDonorsMutation, RestoreDonorsMutationVariables>;
export const ForceDeleteDonorsDocument = gql`
    mutation ForceDeleteDonors($ids: [ID!]!) {
  forceDeleteDonors(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteDonorsMutationFn = Apollo.MutationFunction<ForceDeleteDonorsMutation, ForceDeleteDonorsMutationVariables>;

/**
 * __useForceDeleteDonorsMutation__
 *
 * To run a mutation, you first call `useForceDeleteDonorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteDonorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteDonorsMutation, { data, loading, error }] = useForceDeleteDonorsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteDonorsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteDonorsMutation, ForceDeleteDonorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteDonorsMutation, ForceDeleteDonorsMutationVariables>(ForceDeleteDonorsDocument, options);
      }
export type ForceDeleteDonorsMutationHookResult = ReturnType<typeof useForceDeleteDonorsMutation>;
export type ForceDeleteDonorsMutationResult = Apollo.MutationResult<ForceDeleteDonorsMutation>;
export type ForceDeleteDonorsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteDonorsMutation, ForceDeleteDonorsMutationVariables>;
export const EmptyDonorTrashDocument = gql`
    mutation EmptyDonorTrash {
  emptyDonorTrash {
    id
  }
}
    `;
export type EmptyDonorTrashMutationFn = Apollo.MutationFunction<EmptyDonorTrashMutation, EmptyDonorTrashMutationVariables>;

/**
 * __useEmptyDonorTrashMutation__
 *
 * To run a mutation, you first call `useEmptyDonorTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyDonorTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyDonorTrashMutation, { data, loading, error }] = useEmptyDonorTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyDonorTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyDonorTrashMutation, EmptyDonorTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyDonorTrashMutation, EmptyDonorTrashMutationVariables>(EmptyDonorTrashDocument, options);
      }
export type EmptyDonorTrashMutationHookResult = ReturnType<typeof useEmptyDonorTrashMutation>;
export type EmptyDonorTrashMutationResult = Apollo.MutationResult<EmptyDonorTrashMutation>;
export type EmptyDonorTrashMutationOptions = Apollo.BaseMutationOptions<EmptyDonorTrashMutation, EmptyDonorTrashMutationVariables>;
export const EmailDetailsDocument = gql`
    query EmailDetails($id: ID!) {
  email(id: $id) {
    id
    ...EmailOverlay
  }
}
    ${EmailOverlayFragmentDoc}`;

/**
 * __useEmailDetailsQuery__
 *
 * To run a query within a React component, call `useEmailDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailDetailsQuery(baseOptions: Apollo.QueryHookOptions<EmailDetailsQuery, EmailDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailDetailsQuery, EmailDetailsQueryVariables>(EmailDetailsDocument, options);
      }
export function useEmailDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailDetailsQuery, EmailDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailDetailsQuery, EmailDetailsQueryVariables>(EmailDetailsDocument, options);
        }
export type EmailDetailsQueryHookResult = ReturnType<typeof useEmailDetailsQuery>;
export type EmailDetailsLazyQueryHookResult = ReturnType<typeof useEmailDetailsLazyQuery>;
export type EmailDetailsQueryResult = Apollo.QueryResult<EmailDetailsQuery, EmailDetailsQueryVariables>;
export const EmployeeListDocument = gql`
    query EmployeeList($status: UserStatus, $page: Int, $trashed: Trashed) {
  employees(status: $status, first: 20, page: $page, trashed: $trashed) {
    data {
      ...EmployeeListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${EmployeeListItemFragmentDoc}`;

/**
 * __useEmployeeListQuery__
 *
 * To run a query within a React component, call `useEmployeeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useEmployeeListQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeListQuery, EmployeeListQueryVariables>(EmployeeListDocument, options);
      }
export function useEmployeeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeListQuery, EmployeeListQueryVariables>(EmployeeListDocument, options);
        }
export type EmployeeListQueryHookResult = ReturnType<typeof useEmployeeListQuery>;
export type EmployeeListLazyQueryHookResult = ReturnType<typeof useEmployeeListLazyQuery>;
export type EmployeeListQueryResult = Apollo.QueryResult<EmployeeListQuery, EmployeeListQueryVariables>;
export const EmployeeDetailDocument = gql`
    query EmployeeDetail($id: ID!) {
  employee(id: $id) {
    id
    ...EmployeeInfo
  }
}
    ${EmployeeInfoFragmentDoc}`;

/**
 * __useEmployeeDetailQuery__
 *
 * To run a query within a React component, call `useEmployeeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDetailQuery(baseOptions: Apollo.QueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(EmployeeDetailDocument, options);
      }
export function useEmployeeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(EmployeeDetailDocument, options);
        }
export type EmployeeDetailQueryHookResult = ReturnType<typeof useEmployeeDetailQuery>;
export type EmployeeDetailLazyQueryHookResult = ReturnType<typeof useEmployeeDetailLazyQuery>;
export type EmployeeDetailQueryResult = Apollo.QueryResult<EmployeeDetailQuery, EmployeeDetailQueryVariables>;
export const EmployeeEmailsDocument = gql`
    query EmployeeEmails($id: ID!, $page: Int) {
  employee(id: $id) {
    id
    emails(first: 10, page: $page) {
      data {
        ...EmailListItem
      }
      paginatorInfo {
        currentPage
        hasMorePages
        lastPage
      }
    }
  }
}
    ${EmailListItemFragmentDoc}`;

/**
 * __useEmployeeEmailsQuery__
 *
 * To run a query within a React component, call `useEmployeeEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeEmailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useEmployeeEmailsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeEmailsQuery, EmployeeEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeEmailsQuery, EmployeeEmailsQueryVariables>(EmployeeEmailsDocument, options);
      }
export function useEmployeeEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeEmailsQuery, EmployeeEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeEmailsQuery, EmployeeEmailsQueryVariables>(EmployeeEmailsDocument, options);
        }
export type EmployeeEmailsQueryHookResult = ReturnType<typeof useEmployeeEmailsQuery>;
export type EmployeeEmailsLazyQueryHookResult = ReturnType<typeof useEmployeeEmailsLazyQuery>;
export type EmployeeEmailsQueryResult = Apollo.QueryResult<EmployeeEmailsQuery, EmployeeEmailsQueryVariables>;
export const EmployeeEditDocument = gql`
    query EmployeeEdit($id: ID!) {
  employee(id: $id) {
    id
    ...EmployeeEditForm
  }
}
    ${EmployeeEditFormFragmentDoc}`;

/**
 * __useEmployeeEditQuery__
 *
 * To run a query within a React component, call `useEmployeeEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeEditQuery(baseOptions: Apollo.QueryHookOptions<EmployeeEditQuery, EmployeeEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeEditQuery, EmployeeEditQueryVariables>(EmployeeEditDocument, options);
      }
export function useEmployeeEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeEditQuery, EmployeeEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeEditQuery, EmployeeEditQueryVariables>(EmployeeEditDocument, options);
        }
export type EmployeeEditQueryHookResult = ReturnType<typeof useEmployeeEditQuery>;
export type EmployeeEditLazyQueryHookResult = ReturnType<typeof useEmployeeEditLazyQuery>;
export type EmployeeEditQueryResult = Apollo.QueryResult<EmployeeEditQuery, EmployeeEditQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    ...EmployeeInfo
  }
}
    ${EmployeeInfoFragmentDoc}`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($input: UpdateEmployeeInput!) {
  updateEmployee(input: $input) {
    ...EmployeeInfo
  }
}
    ${EmployeeInfoFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($id: ID!) {
  deleteEmployee(id: $id) {
    id
  }
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const RestoreEmployeesDocument = gql`
    mutation RestoreEmployees($ids: [ID!]!) {
  restoreEmployees(ids: $ids) {
    id
  }
}
    `;
export type RestoreEmployeesMutationFn = Apollo.MutationFunction<RestoreEmployeesMutation, RestoreEmployeesMutationVariables>;

/**
 * __useRestoreEmployeesMutation__
 *
 * To run a mutation, you first call `useRestoreEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEmployeesMutation, { data, loading, error }] = useRestoreEmployeesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEmployeesMutation, RestoreEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEmployeesMutation, RestoreEmployeesMutationVariables>(RestoreEmployeesDocument, options);
      }
export type RestoreEmployeesMutationHookResult = ReturnType<typeof useRestoreEmployeesMutation>;
export type RestoreEmployeesMutationResult = Apollo.MutationResult<RestoreEmployeesMutation>;
export type RestoreEmployeesMutationOptions = Apollo.BaseMutationOptions<RestoreEmployeesMutation, RestoreEmployeesMutationVariables>;
export const ForceDeleteEmployeesDocument = gql`
    mutation ForceDeleteEmployees($ids: [ID!]!) {
  forceDeleteEmployees(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteEmployeesMutationFn = Apollo.MutationFunction<ForceDeleteEmployeesMutation, ForceDeleteEmployeesMutationVariables>;

/**
 * __useForceDeleteEmployeesMutation__
 *
 * To run a mutation, you first call `useForceDeleteEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteEmployeesMutation, { data, loading, error }] = useForceDeleteEmployeesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteEmployeesMutation, ForceDeleteEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteEmployeesMutation, ForceDeleteEmployeesMutationVariables>(ForceDeleteEmployeesDocument, options);
      }
export type ForceDeleteEmployeesMutationHookResult = ReturnType<typeof useForceDeleteEmployeesMutation>;
export type ForceDeleteEmployeesMutationResult = Apollo.MutationResult<ForceDeleteEmployeesMutation>;
export type ForceDeleteEmployeesMutationOptions = Apollo.BaseMutationOptions<ForceDeleteEmployeesMutation, ForceDeleteEmployeesMutationVariables>;
export const EmptyEmployeeTrashDocument = gql`
    mutation EmptyEmployeeTrash {
  emptyEmployeeTrash {
    id
  }
}
    `;
export type EmptyEmployeeTrashMutationFn = Apollo.MutationFunction<EmptyEmployeeTrashMutation, EmptyEmployeeTrashMutationVariables>;

/**
 * __useEmptyEmployeeTrashMutation__
 *
 * To run a mutation, you first call `useEmptyEmployeeTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyEmployeeTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyEmployeeTrashMutation, { data, loading, error }] = useEmptyEmployeeTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyEmployeeTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyEmployeeTrashMutation, EmptyEmployeeTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyEmployeeTrashMutation, EmptyEmployeeTrashMutationVariables>(EmptyEmployeeTrashDocument, options);
      }
export type EmptyEmployeeTrashMutationHookResult = ReturnType<typeof useEmptyEmployeeTrashMutation>;
export type EmptyEmployeeTrashMutationResult = Apollo.MutationResult<EmptyEmployeeTrashMutation>;
export type EmptyEmployeeTrashMutationOptions = Apollo.BaseMutationOptions<EmptyEmployeeTrashMutation, EmptyEmployeeTrashMutationVariables>;
export const EventListDocument = gql`
    query EventList($page: Int, $status: EventStatus, $start: DateTimeRange, $donor: Int, $withArchived: Boolean, $onlyArchived: Boolean, $orderByColumn: QueryEventsOrderByColumn = START, $orderByOrder: SortOrder = ASC, $trashed: Trashed) {
  events(
    first: 20
    page: $page
    status: $status
    start: $start
    donor: $donor
    withArchived: $withArchived
    onlyArchived: $onlyArchived
    orderBy: [{column: $orderByColumn, order: $orderByOrder}, {column: CREATED_AT, order: ASC}]
    trashed: $trashed
  ) {
    data {
      ...EventListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${EventListItemFragmentDoc}`;

/**
 * __useEventListQuery__
 *
 * To run a query within a React component, call `useEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      status: // value for 'status'
 *      start: // value for 'start'
 *      donor: // value for 'donor'
 *      withArchived: // value for 'withArchived'
 *      onlyArchived: // value for 'onlyArchived'
 *      orderByColumn: // value for 'orderByColumn'
 *      orderByOrder: // value for 'orderByOrder'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useEventListQuery(baseOptions?: Apollo.QueryHookOptions<EventListQuery, EventListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventListQuery, EventListQueryVariables>(EventListDocument, options);
      }
export function useEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventListQuery, EventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventListQuery, EventListQueryVariables>(EventListDocument, options);
        }
export type EventListQueryHookResult = ReturnType<typeof useEventListQuery>;
export type EventListLazyQueryHookResult = ReturnType<typeof useEventListLazyQuery>;
export type EventListQueryResult = Apollo.QueryResult<EventListQuery, EventListQueryVariables>;
export const EventDetailDocument = gql`
    query EventDetail($id: ID!) {
  event(id: $id) {
    id
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;

/**
 * __useEventDetailQuery__
 *
 * To run a query within a React component, call `useEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventDetailQuery(baseOptions: Apollo.QueryHookOptions<EventDetailQuery, EventDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDetailQuery, EventDetailQueryVariables>(EventDetailDocument, options);
      }
export function useEventDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDetailQuery, EventDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDetailQuery, EventDetailQueryVariables>(EventDetailDocument, options);
        }
export type EventDetailQueryHookResult = ReturnType<typeof useEventDetailQuery>;
export type EventDetailLazyQueryHookResult = ReturnType<typeof useEventDetailLazyQuery>;
export type EventDetailQueryResult = Apollo.QueryResult<EventDetailQuery, EventDetailQueryVariables>;
export const EventEditDocument = gql`
    query EventEdit($id: ID!) {
  event(id: $id) {
    id
    ...EventEditForm
  }
}
    ${EventEditFormFragmentDoc}`;

/**
 * __useEventEditQuery__
 *
 * To run a query within a React component, call `useEventEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventEditQuery(baseOptions: Apollo.QueryHookOptions<EventEditQuery, EventEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventEditQuery, EventEditQueryVariables>(EventEditDocument, options);
      }
export function useEventEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventEditQuery, EventEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventEditQuery, EventEditQueryVariables>(EventEditDocument, options);
        }
export type EventEditQueryHookResult = ReturnType<typeof useEventEditQuery>;
export type EventEditLazyQueryHookResult = ReturnType<typeof useEventEditLazyQuery>;
export type EventEditQueryResult = Apollo.QueryResult<EventEditQuery, EventEditQueryVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($input: UpdateEventInput!) {
  updateEvent(input: $input) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const CancelEventDocument = gql`
    mutation CancelEvent($input: CancelEventInput!) {
  cancelEvent(input: $input) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type CancelEventMutationFn = Apollo.MutationFunction<CancelEventMutation, CancelEventMutationVariables>;

/**
 * __useCancelEventMutation__
 *
 * To run a mutation, you first call `useCancelEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEventMutation, { data, loading, error }] = useCancelEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelEventMutation(baseOptions?: Apollo.MutationHookOptions<CancelEventMutation, CancelEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEventMutation, CancelEventMutationVariables>(CancelEventDocument, options);
      }
export type CancelEventMutationHookResult = ReturnType<typeof useCancelEventMutation>;
export type CancelEventMutationResult = Apollo.MutationResult<CancelEventMutation>;
export type CancelEventMutationOptions = Apollo.BaseMutationOptions<CancelEventMutation, CancelEventMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const PublishEventDocument = gql`
    mutation PublishEvent($id: ID!) {
  publishEvent(id: $id) {
    id
    status
  }
}
    `;
export type PublishEventMutationFn = Apollo.MutationFunction<PublishEventMutation, PublishEventMutationVariables>;

/**
 * __usePublishEventMutation__
 *
 * To run a mutation, you first call `usePublishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventMutation, { data, loading, error }] = usePublishEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishEventMutation(baseOptions?: Apollo.MutationHookOptions<PublishEventMutation, PublishEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishEventMutation, PublishEventMutationVariables>(PublishEventDocument, options);
      }
export type PublishEventMutationHookResult = ReturnType<typeof usePublishEventMutation>;
export type PublishEventMutationResult = Apollo.MutationResult<PublishEventMutation>;
export type PublishEventMutationOptions = Apollo.BaseMutationOptions<PublishEventMutation, PublishEventMutationVariables>;
export const DeleteSignupDocument = gql`
    mutation DeleteSignup($id: ID!) {
  deleteSignup(id: $id) {
    id
  }
}
    `;
export type DeleteSignupMutationFn = Apollo.MutationFunction<DeleteSignupMutation, DeleteSignupMutationVariables>;

/**
 * __useDeleteSignupMutation__
 *
 * To run a mutation, you first call `useDeleteSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignupMutation, { data, loading, error }] = useDeleteSignupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignupMutation, DeleteSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignupMutation, DeleteSignupMutationVariables>(DeleteSignupDocument, options);
      }
export type DeleteSignupMutationHookResult = ReturnType<typeof useDeleteSignupMutation>;
export type DeleteSignupMutationResult = Apollo.MutationResult<DeleteSignupMutation>;
export type DeleteSignupMutationOptions = Apollo.BaseMutationOptions<DeleteSignupMutation, DeleteSignupMutationVariables>;
export const AcceptSignupsDocument = gql`
    mutation AcceptSignups($id: ID!, $token: String!) {
  acceptSignups(id: $id, token: $token) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type AcceptSignupsMutationFn = Apollo.MutationFunction<AcceptSignupsMutation, AcceptSignupsMutationVariables>;

/**
 * __useAcceptSignupsMutation__
 *
 * To run a mutation, you first call `useAcceptSignupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptSignupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptSignupsMutation, { data, loading, error }] = useAcceptSignupsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptSignupsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptSignupsMutation, AcceptSignupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptSignupsMutation, AcceptSignupsMutationVariables>(AcceptSignupsDocument, options);
      }
export type AcceptSignupsMutationHookResult = ReturnType<typeof useAcceptSignupsMutation>;
export type AcceptSignupsMutationResult = Apollo.MutationResult<AcceptSignupsMutation>;
export type AcceptSignupsMutationOptions = Apollo.BaseMutationOptions<AcceptSignupsMutation, AcceptSignupsMutationVariables>;
export const AddSignupsDocument = gql`
    mutation AddSignups($input: AddSignupsInput!) {
  addSignups(input: $input) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type AddSignupsMutationFn = Apollo.MutationFunction<AddSignupsMutation, AddSignupsMutationVariables>;

/**
 * __useAddSignupsMutation__
 *
 * To run a mutation, you first call `useAddSignupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSignupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSignupsMutation, { data, loading, error }] = useAddSignupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSignupsMutation(baseOptions?: Apollo.MutationHookOptions<AddSignupsMutation, AddSignupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSignupsMutation, AddSignupsMutationVariables>(AddSignupsDocument, options);
      }
export type AddSignupsMutationHookResult = ReturnType<typeof useAddSignupsMutation>;
export type AddSignupsMutationResult = Apollo.MutationResult<AddSignupsMutation>;
export type AddSignupsMutationOptions = Apollo.BaseMutationOptions<AddSignupsMutation, AddSignupsMutationVariables>;
export const InviteCandidatesDocument = gql`
    mutation InviteCandidates($id: ID!) {
  inviteCandidates(id: $id) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type InviteCandidatesMutationFn = Apollo.MutationFunction<InviteCandidatesMutation, InviteCandidatesMutationVariables>;

/**
 * __useInviteCandidatesMutation__
 *
 * To run a mutation, you first call `useInviteCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCandidatesMutation, { data, loading, error }] = useInviteCandidatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<InviteCandidatesMutation, InviteCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCandidatesMutation, InviteCandidatesMutationVariables>(InviteCandidatesDocument, options);
      }
export type InviteCandidatesMutationHookResult = ReturnType<typeof useInviteCandidatesMutation>;
export type InviteCandidatesMutationResult = Apollo.MutationResult<InviteCandidatesMutation>;
export type InviteCandidatesMutationOptions = Apollo.BaseMutationOptions<InviteCandidatesMutation, InviteCandidatesMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: ID!) {
  deleteEvent(id: $id) {
    id
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const RestoreEventsDocument = gql`
    mutation RestoreEvents($ids: [ID!]!) {
  restoreEvents(ids: $ids) {
    id
  }
}
    `;
export type RestoreEventsMutationFn = Apollo.MutationFunction<RestoreEventsMutation, RestoreEventsMutationVariables>;

/**
 * __useRestoreEventsMutation__
 *
 * To run a mutation, you first call `useRestoreEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEventsMutation, { data, loading, error }] = useRestoreEventsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreEventsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEventsMutation, RestoreEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEventsMutation, RestoreEventsMutationVariables>(RestoreEventsDocument, options);
      }
export type RestoreEventsMutationHookResult = ReturnType<typeof useRestoreEventsMutation>;
export type RestoreEventsMutationResult = Apollo.MutationResult<RestoreEventsMutation>;
export type RestoreEventsMutationOptions = Apollo.BaseMutationOptions<RestoreEventsMutation, RestoreEventsMutationVariables>;
export const ForceDeleteEventsDocument = gql`
    mutation ForceDeleteEvents($ids: [ID!]!) {
  forceDeleteEvents(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteEventsMutationFn = Apollo.MutationFunction<ForceDeleteEventsMutation, ForceDeleteEventsMutationVariables>;

/**
 * __useForceDeleteEventsMutation__
 *
 * To run a mutation, you first call `useForceDeleteEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteEventsMutation, { data, loading, error }] = useForceDeleteEventsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteEventsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteEventsMutation, ForceDeleteEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteEventsMutation, ForceDeleteEventsMutationVariables>(ForceDeleteEventsDocument, options);
      }
export type ForceDeleteEventsMutationHookResult = ReturnType<typeof useForceDeleteEventsMutation>;
export type ForceDeleteEventsMutationResult = Apollo.MutationResult<ForceDeleteEventsMutation>;
export type ForceDeleteEventsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteEventsMutation, ForceDeleteEventsMutationVariables>;
export const EmptyEventTrashDocument = gql`
    mutation EmptyEventTrash {
  emptyEventTrash {
    id
  }
}
    `;
export type EmptyEventTrashMutationFn = Apollo.MutationFunction<EmptyEventTrashMutation, EmptyEventTrashMutationVariables>;

/**
 * __useEmptyEventTrashMutation__
 *
 * To run a mutation, you first call `useEmptyEventTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyEventTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyEventTrashMutation, { data, loading, error }] = useEmptyEventTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyEventTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyEventTrashMutation, EmptyEventTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyEventTrashMutation, EmptyEventTrashMutationVariables>(EmptyEventTrashDocument, options);
      }
export type EmptyEventTrashMutationHookResult = ReturnType<typeof useEmptyEventTrashMutation>;
export type EmptyEventTrashMutationResult = Apollo.MutationResult<EmptyEventTrashMutation>;
export type EmptyEventTrashMutationOptions = Apollo.BaseMutationOptions<EmptyEventTrashMutation, EmptyEventTrashMutationVariables>;
export const LocationListDocument = gql`
    query LocationList($page: Int, $trashed: Trashed) {
  locations(first: 20, page: $page, trashed: $trashed) {
    data {
      ...LocationListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${LocationListItemFragmentDoc}`;

/**
 * __useLocationListQuery__
 *
 * To run a query within a React component, call `useLocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useLocationListQuery(baseOptions?: Apollo.QueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
      }
export function useLocationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
        }
export type LocationListQueryHookResult = ReturnType<typeof useLocationListQuery>;
export type LocationListLazyQueryHookResult = ReturnType<typeof useLocationListLazyQuery>;
export type LocationListQueryResult = Apollo.QueryResult<LocationListQuery, LocationListQueryVariables>;
export const LocationDetailDocument = gql`
    query LocationDetail($id: ID!) {
  location(id: $id) {
    id
    ...LocationInfo
  }
}
    ${LocationInfoFragmentDoc}`;

/**
 * __useLocationDetailQuery__
 *
 * To run a query within a React component, call `useLocationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDetailQuery(baseOptions: Apollo.QueryHookOptions<LocationDetailQuery, LocationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDetailQuery, LocationDetailQueryVariables>(LocationDetailDocument, options);
      }
export function useLocationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDetailQuery, LocationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDetailQuery, LocationDetailQueryVariables>(LocationDetailDocument, options);
        }
export type LocationDetailQueryHookResult = ReturnType<typeof useLocationDetailQuery>;
export type LocationDetailLazyQueryHookResult = ReturnType<typeof useLocationDetailLazyQuery>;
export type LocationDetailQueryResult = Apollo.QueryResult<LocationDetailQuery, LocationDetailQueryVariables>;
export const LocationDonorsDocument = gql`
    query LocationDonors($id: ID!) {
  location(id: $id) {
    id
    donors {
      ...DonorListItem
    }
  }
}
    ${DonorListItemFragmentDoc}`;

/**
 * __useLocationDonorsQuery__
 *
 * To run a query within a React component, call `useLocationDonorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDonorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDonorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDonorsQuery(baseOptions: Apollo.QueryHookOptions<LocationDonorsQuery, LocationDonorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDonorsQuery, LocationDonorsQueryVariables>(LocationDonorsDocument, options);
      }
export function useLocationDonorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDonorsQuery, LocationDonorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDonorsQuery, LocationDonorsQueryVariables>(LocationDonorsDocument, options);
        }
export type LocationDonorsQueryHookResult = ReturnType<typeof useLocationDonorsQuery>;
export type LocationDonorsLazyQueryHookResult = ReturnType<typeof useLocationDonorsLazyQuery>;
export type LocationDonorsQueryResult = Apollo.QueryResult<LocationDonorsQuery, LocationDonorsQueryVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    ...LocationInfo
  }
}
    ${LocationInfoFragmentDoc}`;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const LocationEditDocument = gql`
    query LocationEdit($id: ID!) {
  location(id: $id) {
    id
    ...LocationEditForm
  }
}
    ${LocationEditFormFragmentDoc}`;

/**
 * __useLocationEditQuery__
 *
 * To run a query within a React component, call `useLocationEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationEditQuery(baseOptions: Apollo.QueryHookOptions<LocationEditQuery, LocationEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationEditQuery, LocationEditQueryVariables>(LocationEditDocument, options);
      }
export function useLocationEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationEditQuery, LocationEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationEditQuery, LocationEditQueryVariables>(LocationEditDocument, options);
        }
export type LocationEditQueryHookResult = ReturnType<typeof useLocationEditQuery>;
export type LocationEditLazyQueryHookResult = ReturnType<typeof useLocationEditLazyQuery>;
export type LocationEditQueryResult = Apollo.QueryResult<LocationEditQuery, LocationEditQueryVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($input: UpdateLocationInput!) {
  updateLocation(input: $input) {
    ...LocationInfo
  }
}
    ${LocationInfoFragmentDoc}`;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const SetLocationPosterDocument = gql`
    mutation SetLocationPoster($input: SetMediaInput!) {
  setLocationPoster(input: $input) {
    id
    poster {
      name
      thumb_url
    }
  }
}
    `;
export type SetLocationPosterMutationFn = Apollo.MutationFunction<SetLocationPosterMutation, SetLocationPosterMutationVariables>;

/**
 * __useSetLocationPosterMutation__
 *
 * To run a mutation, you first call `useSetLocationPosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLocationPosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLocationPosterMutation, { data, loading, error }] = useSetLocationPosterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetLocationPosterMutation(baseOptions?: Apollo.MutationHookOptions<SetLocationPosterMutation, SetLocationPosterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLocationPosterMutation, SetLocationPosterMutationVariables>(SetLocationPosterDocument, options);
      }
export type SetLocationPosterMutationHookResult = ReturnType<typeof useSetLocationPosterMutation>;
export type SetLocationPosterMutationResult = Apollo.MutationResult<SetLocationPosterMutation>;
export type SetLocationPosterMutationOptions = Apollo.BaseMutationOptions<SetLocationPosterMutation, SetLocationPosterMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: ID!) {
  deleteLocation(id: $id) {
    id
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const RestoreLocationsDocument = gql`
    mutation RestoreLocations($ids: [ID!]!) {
  restoreLocations(ids: $ids) {
    id
  }
}
    `;
export type RestoreLocationsMutationFn = Apollo.MutationFunction<RestoreLocationsMutation, RestoreLocationsMutationVariables>;

/**
 * __useRestoreLocationsMutation__
 *
 * To run a mutation, you first call `useRestoreLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLocationsMutation, { data, loading, error }] = useRestoreLocationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreLocationsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLocationsMutation, RestoreLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLocationsMutation, RestoreLocationsMutationVariables>(RestoreLocationsDocument, options);
      }
export type RestoreLocationsMutationHookResult = ReturnType<typeof useRestoreLocationsMutation>;
export type RestoreLocationsMutationResult = Apollo.MutationResult<RestoreLocationsMutation>;
export type RestoreLocationsMutationOptions = Apollo.BaseMutationOptions<RestoreLocationsMutation, RestoreLocationsMutationVariables>;
export const ForceDeleteLocationsDocument = gql`
    mutation ForceDeleteLocations($ids: [ID!]!) {
  forceDeleteLocations(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteLocationsMutationFn = Apollo.MutationFunction<ForceDeleteLocationsMutation, ForceDeleteLocationsMutationVariables>;

/**
 * __useForceDeleteLocationsMutation__
 *
 * To run a mutation, you first call `useForceDeleteLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteLocationsMutation, { data, loading, error }] = useForceDeleteLocationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteLocationsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteLocationsMutation, ForceDeleteLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteLocationsMutation, ForceDeleteLocationsMutationVariables>(ForceDeleteLocationsDocument, options);
      }
export type ForceDeleteLocationsMutationHookResult = ReturnType<typeof useForceDeleteLocationsMutation>;
export type ForceDeleteLocationsMutationResult = Apollo.MutationResult<ForceDeleteLocationsMutation>;
export type ForceDeleteLocationsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteLocationsMutation, ForceDeleteLocationsMutationVariables>;
export const EmptyLocationTrashDocument = gql`
    mutation EmptyLocationTrash {
  emptyLocationTrash {
    id
  }
}
    `;
export type EmptyLocationTrashMutationFn = Apollo.MutationFunction<EmptyLocationTrashMutation, EmptyLocationTrashMutationVariables>;

/**
 * __useEmptyLocationTrashMutation__
 *
 * To run a mutation, you first call `useEmptyLocationTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyLocationTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyLocationTrashMutation, { data, loading, error }] = useEmptyLocationTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyLocationTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyLocationTrashMutation, EmptyLocationTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyLocationTrashMutation, EmptyLocationTrashMutationVariables>(EmptyLocationTrashDocument, options);
      }
export type EmptyLocationTrashMutationHookResult = ReturnType<typeof useEmptyLocationTrashMutation>;
export type EmptyLocationTrashMutationResult = Apollo.MutationResult<EmptyLocationTrashMutation>;
export type EmptyLocationTrashMutationOptions = Apollo.BaseMutationOptions<EmptyLocationTrashMutation, EmptyLocationTrashMutationVariables>;
export const EventMatchingDocument = gql`
    query EventMatching($id: ID!) {
  event(id: $id) {
    id
    ...MatchingPage
  }
}
    ${MatchingPageFragmentDoc}`;

/**
 * __useEventMatchingQuery__
 *
 * To run a query within a React component, call `useEventMatchingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventMatchingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventMatchingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventMatchingQuery(baseOptions: Apollo.QueryHookOptions<EventMatchingQuery, EventMatchingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventMatchingQuery, EventMatchingQueryVariables>(EventMatchingDocument, options);
      }
export function useEventMatchingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventMatchingQuery, EventMatchingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventMatchingQuery, EventMatchingQueryVariables>(EventMatchingDocument, options);
        }
export type EventMatchingQueryHookResult = ReturnType<typeof useEventMatchingQuery>;
export type EventMatchingLazyQueryHookResult = ReturnType<typeof useEventMatchingLazyQuery>;
export type EventMatchingQueryResult = Apollo.QueryResult<EventMatchingQuery, EventMatchingQueryVariables>;
export const UpdateEventCandidatesDocument = gql`
    mutation UpdateEventCandidates($input: UpdateCandidatesInput!) {
  updateCandidates(input: $input) {
    ...EventDetailPage
  }
}
    ${EventDetailPageFragmentDoc}`;
export type UpdateEventCandidatesMutationFn = Apollo.MutationFunction<UpdateEventCandidatesMutation, UpdateEventCandidatesMutationVariables>;

/**
 * __useUpdateEventCandidatesMutation__
 *
 * To run a mutation, you first call `useUpdateEventCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventCandidatesMutation, { data, loading, error }] = useUpdateEventCandidatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventCandidatesMutation, UpdateEventCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventCandidatesMutation, UpdateEventCandidatesMutationVariables>(UpdateEventCandidatesDocument, options);
      }
export type UpdateEventCandidatesMutationHookResult = ReturnType<typeof useUpdateEventCandidatesMutation>;
export type UpdateEventCandidatesMutationResult = Apollo.MutationResult<UpdateEventCandidatesMutation>;
export type UpdateEventCandidatesMutationOptions = Apollo.BaseMutationOptions<UpdateEventCandidatesMutation, UpdateEventCandidatesMutationVariables>;
export const CandidateSignupDocument = gql`
    query CandidateSignup($id: ID!) {
  signup(id: $id) {
    id
    ...CandidateListItem
  }
}
    ${CandidateListItemFragmentDoc}`;

/**
 * __useCandidateSignupQuery__
 *
 * To run a query within a React component, call `useCandidateSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateSignupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateSignupQuery(baseOptions: Apollo.QueryHookOptions<CandidateSignupQuery, CandidateSignupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateSignupQuery, CandidateSignupQueryVariables>(CandidateSignupDocument, options);
      }
export function useCandidateSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateSignupQuery, CandidateSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateSignupQuery, CandidateSignupQueryVariables>(CandidateSignupDocument, options);
        }
export type CandidateSignupQueryHookResult = ReturnType<typeof useCandidateSignupQuery>;
export type CandidateSignupLazyQueryHookResult = ReturnType<typeof useCandidateSignupLazyQuery>;
export type CandidateSignupQueryResult = Apollo.QueryResult<CandidateSignupQuery, CandidateSignupQueryVariables>;
export const ProspectSignupDocument = gql`
    query ProspectSignup($id: ID!) {
  signup(id: $id) {
    id
    ...ProspectListItem
  }
}
    ${ProspectListItemFragmentDoc}`;

/**
 * __useProspectSignupQuery__
 *
 * To run a query within a React component, call `useProspectSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectSignupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProspectSignupQuery(baseOptions: Apollo.QueryHookOptions<ProspectSignupQuery, ProspectSignupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectSignupQuery, ProspectSignupQueryVariables>(ProspectSignupDocument, options);
      }
export function useProspectSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectSignupQuery, ProspectSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectSignupQuery, ProspectSignupQueryVariables>(ProspectSignupDocument, options);
        }
export type ProspectSignupQueryHookResult = ReturnType<typeof useProspectSignupQuery>;
export type ProspectSignupLazyQueryHookResult = ReturnType<typeof useProspectSignupLazyQuery>;
export type ProspectSignupQueryResult = Apollo.QueryResult<ProspectSignupQuery, ProspectSignupQueryVariables>;
export const ProspectGroupSignupDocument = gql`
    query ProspectGroupSignup($id: ID!) {
  signup(id: $id) {
    id
    ...ProspectGroupListItem
  }
}
    ${ProspectGroupListItemFragmentDoc}`;

/**
 * __useProspectGroupSignupQuery__
 *
 * To run a query within a React component, call `useProspectGroupSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectGroupSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectGroupSignupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProspectGroupSignupQuery(baseOptions: Apollo.QueryHookOptions<ProspectGroupSignupQuery, ProspectGroupSignupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectGroupSignupQuery, ProspectGroupSignupQueryVariables>(ProspectGroupSignupDocument, options);
      }
export function useProspectGroupSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectGroupSignupQuery, ProspectGroupSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectGroupSignupQuery, ProspectGroupSignupQueryVariables>(ProspectGroupSignupDocument, options);
        }
export type ProspectGroupSignupQueryHookResult = ReturnType<typeof useProspectGroupSignupQuery>;
export type ProspectGroupSignupLazyQueryHookResult = ReturnType<typeof useProspectGroupSignupLazyQuery>;
export type ProspectGroupSignupQueryResult = Apollo.QueryResult<ProspectGroupSignupQuery, ProspectGroupSignupQueryVariables>;
export const CompanionMatchingDocument = gql`
    query CompanionMatching($id: ID!) {
  event(id: $id) {
    id
    ...CompanionMatchingTab
  }
}
    ${CompanionMatchingTabFragmentDoc}`;

/**
 * __useCompanionMatchingQuery__
 *
 * To run a query within a React component, call `useCompanionMatchingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionMatchingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionMatchingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanionMatchingQuery(baseOptions: Apollo.QueryHookOptions<CompanionMatchingQuery, CompanionMatchingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionMatchingQuery, CompanionMatchingQueryVariables>(CompanionMatchingDocument, options);
      }
export function useCompanionMatchingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionMatchingQuery, CompanionMatchingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionMatchingQuery, CompanionMatchingQueryVariables>(CompanionMatchingDocument, options);
        }
export type CompanionMatchingQueryHookResult = ReturnType<typeof useCompanionMatchingQuery>;
export type CompanionMatchingLazyQueryHookResult = ReturnType<typeof useCompanionMatchingLazyQuery>;
export type CompanionMatchingQueryResult = Apollo.QueryResult<CompanionMatchingQuery, CompanionMatchingQueryVariables>;
export const SoulAttendsDocument = gql`
    query SoulAttends($id: ID!, $first: Int = 20, $page: Int) {
  soul(id: $id) {
    id
    attends(first: $first, page: $page) {
      data {
        ...AttendListItem
      }
      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
      }
    }
  }
}
    ${AttendListItemFragmentDoc}`;

/**
 * __useSoulAttendsQuery__
 *
 * To run a query within a React component, call `useSoulAttendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoulAttendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoulAttendsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSoulAttendsQuery(baseOptions: Apollo.QueryHookOptions<SoulAttendsQuery, SoulAttendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoulAttendsQuery, SoulAttendsQueryVariables>(SoulAttendsDocument, options);
      }
export function useSoulAttendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoulAttendsQuery, SoulAttendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoulAttendsQuery, SoulAttendsQueryVariables>(SoulAttendsDocument, options);
        }
export type SoulAttendsQueryHookResult = ReturnType<typeof useSoulAttendsQuery>;
export type SoulAttendsLazyQueryHookResult = ReturnType<typeof useSoulAttendsLazyQuery>;
export type SoulAttendsQueryResult = Apollo.QueryResult<SoulAttendsQuery, SoulAttendsQueryVariables>;
export const CompanionAttendsDocument = gql`
    query CompanionAttends($id: ID!, $first: Int = 20, $page: Int) {
  companion(id: $id) {
    id
    attends(first: $first, page: $page) {
      data {
        ...AttendListItem
      }
      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
      }
    }
  }
}
    ${AttendListItemFragmentDoc}`;

/**
 * __useCompanionAttendsQuery__
 *
 * To run a query within a React component, call `useCompanionAttendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionAttendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionAttendsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCompanionAttendsQuery(baseOptions: Apollo.QueryHookOptions<CompanionAttendsQuery, CompanionAttendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionAttendsQuery, CompanionAttendsQueryVariables>(CompanionAttendsDocument, options);
      }
export function useCompanionAttendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionAttendsQuery, CompanionAttendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionAttendsQuery, CompanionAttendsQueryVariables>(CompanionAttendsDocument, options);
        }
export type CompanionAttendsQueryHookResult = ReturnType<typeof useCompanionAttendsQuery>;
export type CompanionAttendsLazyQueryHookResult = ReturnType<typeof useCompanionAttendsLazyQuery>;
export type CompanionAttendsQueryResult = Apollo.QueryResult<CompanionAttendsQuery, CompanionAttendsQueryVariables>;
export const SoulFutureSignupsDocument = gql`
    query SoulFutureSignups($id: ID!, $first: Int = 20, $page: Int) {
  soul(id: $id) {
    id
    future_signups(first: $first, page: $page) {
      data {
        ...FutureSignupListItem
      }
      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
      }
    }
  }
}
    ${FutureSignupListItemFragmentDoc}`;

/**
 * __useSoulFutureSignupsQuery__
 *
 * To run a query within a React component, call `useSoulFutureSignupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoulFutureSignupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoulFutureSignupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSoulFutureSignupsQuery(baseOptions: Apollo.QueryHookOptions<SoulFutureSignupsQuery, SoulFutureSignupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoulFutureSignupsQuery, SoulFutureSignupsQueryVariables>(SoulFutureSignupsDocument, options);
      }
export function useSoulFutureSignupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoulFutureSignupsQuery, SoulFutureSignupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoulFutureSignupsQuery, SoulFutureSignupsQueryVariables>(SoulFutureSignupsDocument, options);
        }
export type SoulFutureSignupsQueryHookResult = ReturnType<typeof useSoulFutureSignupsQuery>;
export type SoulFutureSignupsLazyQueryHookResult = ReturnType<typeof useSoulFutureSignupsLazyQuery>;
export type SoulFutureSignupsQueryResult = Apollo.QueryResult<SoulFutureSignupsQuery, SoulFutureSignupsQueryVariables>;
export const CompanionFutureSignupsDocument = gql`
    query CompanionFutureSignups($id: ID!, $first: Int = 20, $page: Int) {
  companion(id: $id) {
    id
    future_signups(first: $first, page: $page) {
      data {
        ...FutureSignupListItem
      }
      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
      }
    }
  }
}
    ${FutureSignupListItemFragmentDoc}`;

/**
 * __useCompanionFutureSignupsQuery__
 *
 * To run a query within a React component, call `useCompanionFutureSignupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanionFutureSignupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionFutureSignupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCompanionFutureSignupsQuery(baseOptions: Apollo.QueryHookOptions<CompanionFutureSignupsQuery, CompanionFutureSignupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanionFutureSignupsQuery, CompanionFutureSignupsQueryVariables>(CompanionFutureSignupsDocument, options);
      }
export function useCompanionFutureSignupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanionFutureSignupsQuery, CompanionFutureSignupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanionFutureSignupsQuery, CompanionFutureSignupsQueryVariables>(CompanionFutureSignupsDocument, options);
        }
export type CompanionFutureSignupsQueryHookResult = ReturnType<typeof useCompanionFutureSignupsQuery>;
export type CompanionFutureSignupsLazyQueryHookResult = ReturnType<typeof useCompanionFutureSignupsLazyQuery>;
export type CompanionFutureSignupsQueryResult = Apollo.QueryResult<CompanionFutureSignupsQuery, CompanionFutureSignupsQueryVariables>;
export const NewsletterListDocument = gql`
    query NewsletterList($page: Int, $sentAt: DateTimeRange, $trashed: Trashed) {
  newsletters(
    first: 20
    page: $page
    sent_at: $sentAt
    orderBy: [{column: "created_at", order: DESC}]
    trashed: $trashed
  ) {
    data {
      ...NewsletterListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${NewsletterListItemFragmentDoc}`;

/**
 * __useNewsletterListQuery__
 *
 * To run a query within a React component, call `useNewsletterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sentAt: // value for 'sentAt'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useNewsletterListQuery(baseOptions?: Apollo.QueryHookOptions<NewsletterListQuery, NewsletterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsletterListQuery, NewsletterListQueryVariables>(NewsletterListDocument, options);
      }
export function useNewsletterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsletterListQuery, NewsletterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsletterListQuery, NewsletterListQueryVariables>(NewsletterListDocument, options);
        }
export type NewsletterListQueryHookResult = ReturnType<typeof useNewsletterListQuery>;
export type NewsletterListLazyQueryHookResult = ReturnType<typeof useNewsletterListLazyQuery>;
export type NewsletterListQueryResult = Apollo.QueryResult<NewsletterListQuery, NewsletterListQueryVariables>;
export const NewsletterDetailDocument = gql`
    query NewsletterDetail($id: ID!) {
  newsletter(id: $id) {
    id
    ...NewsletterDetailPage
  }
}
    ${NewsletterDetailPageFragmentDoc}`;

/**
 * __useNewsletterDetailQuery__
 *
 * To run a query within a React component, call `useNewsletterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterDetailQuery(baseOptions: Apollo.QueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(NewsletterDetailDocument, options);
      }
export function useNewsletterDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(NewsletterDetailDocument, options);
        }
export type NewsletterDetailQueryHookResult = ReturnType<typeof useNewsletterDetailQuery>;
export type NewsletterDetailLazyQueryHookResult = ReturnType<typeof useNewsletterDetailLazyQuery>;
export type NewsletterDetailQueryResult = Apollo.QueryResult<NewsletterDetailQuery, NewsletterDetailQueryVariables>;
export const CreateNewsletterDocument = gql`
    mutation CreateNewsletter($input: CreateNewsletterInput!) {
  createNewsletter(input: $input) {
    ...NewsletterDetailPage
  }
}
    ${NewsletterDetailPageFragmentDoc}`;
export type CreateNewsletterMutationFn = Apollo.MutationFunction<CreateNewsletterMutation, CreateNewsletterMutationVariables>;

/**
 * __useCreateNewsletterMutation__
 *
 * To run a mutation, you first call `useCreateNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsletterMutation, { data, loading, error }] = useCreateNewsletterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsletterMutation, CreateNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsletterMutation, CreateNewsletterMutationVariables>(CreateNewsletterDocument, options);
      }
export type CreateNewsletterMutationHookResult = ReturnType<typeof useCreateNewsletterMutation>;
export type CreateNewsletterMutationResult = Apollo.MutationResult<CreateNewsletterMutation>;
export type CreateNewsletterMutationOptions = Apollo.BaseMutationOptions<CreateNewsletterMutation, CreateNewsletterMutationVariables>;
export const OrganisationListDocument = gql`
    query OrganisationList($trashed: Trashed) {
  organisations(trashed: $trashed) {
    ...OrganisationListItem
  }
}
    ${OrganisationListItemFragmentDoc}`;

/**
 * __useOrganisationListQuery__
 *
 * To run a query within a React component, call `useOrganisationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationListQuery({
 *   variables: {
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useOrganisationListQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationListQuery, OrganisationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationListQuery, OrganisationListQueryVariables>(OrganisationListDocument, options);
      }
export function useOrganisationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationListQuery, OrganisationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationListQuery, OrganisationListQueryVariables>(OrganisationListDocument, options);
        }
export type OrganisationListQueryHookResult = ReturnType<typeof useOrganisationListQuery>;
export type OrganisationListLazyQueryHookResult = ReturnType<typeof useOrganisationListLazyQuery>;
export type OrganisationListQueryResult = Apollo.QueryResult<OrganisationListQuery, OrganisationListQueryVariables>;
export const OrganisationDetailDocument = gql`
    query OrganisationDetail($id: ID!) {
  organisation(id: $id) {
    id
    ...OrganisationDetailPage
  }
}
    ${OrganisationDetailPageFragmentDoc}`;

/**
 * __useOrganisationDetailQuery__
 *
 * To run a query within a React component, call `useOrganisationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationDetailQuery(baseOptions: Apollo.QueryHookOptions<OrganisationDetailQuery, OrganisationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationDetailQuery, OrganisationDetailQueryVariables>(OrganisationDetailDocument, options);
      }
export function useOrganisationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationDetailQuery, OrganisationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationDetailQuery, OrganisationDetailQueryVariables>(OrganisationDetailDocument, options);
        }
export type OrganisationDetailQueryHookResult = ReturnType<typeof useOrganisationDetailQuery>;
export type OrganisationDetailLazyQueryHookResult = ReturnType<typeof useOrganisationDetailLazyQuery>;
export type OrganisationDetailQueryResult = Apollo.QueryResult<OrganisationDetailQuery, OrganisationDetailQueryVariables>;
export const OrganisationEditDocument = gql`
    query OrganisationEdit($id: ID!) {
  organisation(id: $id) {
    id
    ...OrganisationEditForm
  }
}
    ${OrganisationEditFormFragmentDoc}`;

/**
 * __useOrganisationEditQuery__
 *
 * To run a query within a React component, call `useOrganisationEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationEditQuery(baseOptions: Apollo.QueryHookOptions<OrganisationEditQuery, OrganisationEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationEditQuery, OrganisationEditQueryVariables>(OrganisationEditDocument, options);
      }
export function useOrganisationEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationEditQuery, OrganisationEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationEditQuery, OrganisationEditQueryVariables>(OrganisationEditDocument, options);
        }
export type OrganisationEditQueryHookResult = ReturnType<typeof useOrganisationEditQuery>;
export type OrganisationEditLazyQueryHookResult = ReturnType<typeof useOrganisationEditLazyQuery>;
export type OrganisationEditQueryResult = Apollo.QueryResult<OrganisationEditQuery, OrganisationEditQueryVariables>;
export const CreateOrganisationDocument = gql`
    mutation CreateOrganisation($input: CreateOrganisationInput!) {
  createOrganisation(input: $input) {
    ...OrganisationDetailPage
  }
}
    ${OrganisationDetailPageFragmentDoc}`;
export type CreateOrganisationMutationFn = Apollo.MutationFunction<CreateOrganisationMutation, CreateOrganisationMutationVariables>;

/**
 * __useCreateOrganisationMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationMutation, { data, loading, error }] = useCreateOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationMutation, CreateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationMutation, CreateOrganisationMutationVariables>(CreateOrganisationDocument, options);
      }
export type CreateOrganisationMutationHookResult = ReturnType<typeof useCreateOrganisationMutation>;
export type CreateOrganisationMutationResult = Apollo.MutationResult<CreateOrganisationMutation>;
export type CreateOrganisationMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationMutation, CreateOrganisationMutationVariables>;
export const UpdateOrganisationDocument = gql`
    mutation UpdateOrganisation($input: UpdateOrganisationInput!) {
  updateOrganisation(input: $input) {
    ...OrganisationDetailPage
  }
}
    ${OrganisationDetailPageFragmentDoc}`;
export type UpdateOrganisationMutationFn = Apollo.MutationFunction<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;

/**
 * __useUpdateOrganisationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationMutation, { data, loading, error }] = useUpdateOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>(UpdateOrganisationDocument, options);
      }
export type UpdateOrganisationMutationHookResult = ReturnType<typeof useUpdateOrganisationMutation>;
export type UpdateOrganisationMutationResult = Apollo.MutationResult<UpdateOrganisationMutation>;
export type UpdateOrganisationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;
export const DeleteOrganisationDocument = gql`
    mutation DeleteOrganisation($id: ID!) {
  deleteOrganisation(id: $id) {
    id
  }
}
    `;
export type DeleteOrganisationMutationFn = Apollo.MutationFunction<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;

/**
 * __useDeleteOrganisationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationMutation, { data, loading, error }] = useDeleteOrganisationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>(DeleteOrganisationDocument, options);
      }
export type DeleteOrganisationMutationHookResult = ReturnType<typeof useDeleteOrganisationMutation>;
export type DeleteOrganisationMutationResult = Apollo.MutationResult<DeleteOrganisationMutation>;
export type DeleteOrganisationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;
export const RestoreOrganisationsDocument = gql`
    mutation RestoreOrganisations($ids: [ID!]!) {
  restoreOrganisations(ids: $ids) {
    id
  }
}
    `;
export type RestoreOrganisationsMutationFn = Apollo.MutationFunction<RestoreOrganisationsMutation, RestoreOrganisationsMutationVariables>;

/**
 * __useRestoreOrganisationsMutation__
 *
 * To run a mutation, you first call `useRestoreOrganisationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrganisationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrganisationsMutation, { data, loading, error }] = useRestoreOrganisationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreOrganisationsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreOrganisationsMutation, RestoreOrganisationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreOrganisationsMutation, RestoreOrganisationsMutationVariables>(RestoreOrganisationsDocument, options);
      }
export type RestoreOrganisationsMutationHookResult = ReturnType<typeof useRestoreOrganisationsMutation>;
export type RestoreOrganisationsMutationResult = Apollo.MutationResult<RestoreOrganisationsMutation>;
export type RestoreOrganisationsMutationOptions = Apollo.BaseMutationOptions<RestoreOrganisationsMutation, RestoreOrganisationsMutationVariables>;
export const ForceDeleteOrganisationsDocument = gql`
    mutation ForceDeleteOrganisations($ids: [ID!]!) {
  forceDeleteOrganisations(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteOrganisationsMutationFn = Apollo.MutationFunction<ForceDeleteOrganisationsMutation, ForceDeleteOrganisationsMutationVariables>;

/**
 * __useForceDeleteOrganisationsMutation__
 *
 * To run a mutation, you first call `useForceDeleteOrganisationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteOrganisationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteOrganisationsMutation, { data, loading, error }] = useForceDeleteOrganisationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteOrganisationsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteOrganisationsMutation, ForceDeleteOrganisationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteOrganisationsMutation, ForceDeleteOrganisationsMutationVariables>(ForceDeleteOrganisationsDocument, options);
      }
export type ForceDeleteOrganisationsMutationHookResult = ReturnType<typeof useForceDeleteOrganisationsMutation>;
export type ForceDeleteOrganisationsMutationResult = Apollo.MutationResult<ForceDeleteOrganisationsMutation>;
export type ForceDeleteOrganisationsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteOrganisationsMutation, ForceDeleteOrganisationsMutationVariables>;
export const EmptyOrganisationTrashDocument = gql`
    mutation EmptyOrganisationTrash {
  emptyOrganisationTrash {
    id
  }
}
    `;
export type EmptyOrganisationTrashMutationFn = Apollo.MutationFunction<EmptyOrganisationTrashMutation, EmptyOrganisationTrashMutationVariables>;

/**
 * __useEmptyOrganisationTrashMutation__
 *
 * To run a mutation, you first call `useEmptyOrganisationTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyOrganisationTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyOrganisationTrashMutation, { data, loading, error }] = useEmptyOrganisationTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyOrganisationTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptyOrganisationTrashMutation, EmptyOrganisationTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyOrganisationTrashMutation, EmptyOrganisationTrashMutationVariables>(EmptyOrganisationTrashDocument, options);
      }
export type EmptyOrganisationTrashMutationHookResult = ReturnType<typeof useEmptyOrganisationTrashMutation>;
export type EmptyOrganisationTrashMutationResult = Apollo.MutationResult<EmptyOrganisationTrashMutation>;
export type EmptyOrganisationTrashMutationOptions = Apollo.BaseMutationOptions<EmptyOrganisationTrashMutation, EmptyOrganisationTrashMutationVariables>;
export const RoleListDocument = gql`
    query RoleList {
  roles {
    ...RoleListItem
  }
}
    ${RoleListItemFragmentDoc}`;

/**
 * __useRoleListQuery__
 *
 * To run a query within a React component, call `useRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleListQuery(baseOptions?: Apollo.QueryHookOptions<RoleListQuery, RoleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleListQuery, RoleListQueryVariables>(RoleListDocument, options);
      }
export function useRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleListQuery, RoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleListQuery, RoleListQueryVariables>(RoleListDocument, options);
        }
export type RoleListQueryHookResult = ReturnType<typeof useRoleListQuery>;
export type RoleListLazyQueryHookResult = ReturnType<typeof useRoleListLazyQuery>;
export type RoleListQueryResult = Apollo.QueryResult<RoleListQuery, RoleListQueryVariables>;
export const RoleDetailDocument = gql`
    query RoleDetail($id: ID!) {
  role(id: $id) {
    id
    ...RoleDetailPage
  }
}
    ${RoleDetailPageFragmentDoc}`;

/**
 * __useRoleDetailQuery__
 *
 * To run a query within a React component, call `useRoleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleDetailQuery(baseOptions: Apollo.QueryHookOptions<RoleDetailQuery, RoleDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleDetailQuery, RoleDetailQueryVariables>(RoleDetailDocument, options);
      }
export function useRoleDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleDetailQuery, RoleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleDetailQuery, RoleDetailQueryVariables>(RoleDetailDocument, options);
        }
export type RoleDetailQueryHookResult = ReturnType<typeof useRoleDetailQuery>;
export type RoleDetailLazyQueryHookResult = ReturnType<typeof useRoleDetailLazyQuery>;
export type RoleDetailQueryResult = Apollo.QueryResult<RoleDetailQuery, RoleDetailQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    ...RoleDetailPage
  }
}
    ${RoleDetailPageFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const RoleEditDocument = gql`
    query RoleEdit($id: ID!) {
  role(id: $id) {
    id
    ...RoleEditForm
  }
}
    ${RoleEditFormFragmentDoc}`;

/**
 * __useRoleEditQuery__
 *
 * To run a query within a React component, call `useRoleEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleEditQuery(baseOptions: Apollo.QueryHookOptions<RoleEditQuery, RoleEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleEditQuery, RoleEditQueryVariables>(RoleEditDocument, options);
      }
export function useRoleEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleEditQuery, RoleEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleEditQuery, RoleEditQueryVariables>(RoleEditDocument, options);
        }
export type RoleEditQueryHookResult = ReturnType<typeof useRoleEditQuery>;
export type RoleEditLazyQueryHookResult = ReturnType<typeof useRoleEditLazyQuery>;
export type RoleEditQueryResult = Apollo.QueryResult<RoleEditQuery, RoleEditQueryVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    ...RoleDetailPage
  }
}
    ${RoleDetailPageFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: ID!) {
  deleteRole(id: $id) {
    id
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const CurrentTenantDetailDocument = gql`
    query CurrentTenantDetail {
  currentTenant {
    id
    ...SettingsDetailPage
  }
}
    ${SettingsDetailPageFragmentDoc}`;

/**
 * __useCurrentTenantDetailQuery__
 *
 * To run a query within a React component, call `useCurrentTenantDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTenantDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTenantDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentTenantDetailQuery(baseOptions?: Apollo.QueryHookOptions<CurrentTenantDetailQuery, CurrentTenantDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentTenantDetailQuery, CurrentTenantDetailQueryVariables>(CurrentTenantDetailDocument, options);
      }
export function useCurrentTenantDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentTenantDetailQuery, CurrentTenantDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentTenantDetailQuery, CurrentTenantDetailQueryVariables>(CurrentTenantDetailDocument, options);
        }
export type CurrentTenantDetailQueryHookResult = ReturnType<typeof useCurrentTenantDetailQuery>;
export type CurrentTenantDetailLazyQueryHookResult = ReturnType<typeof useCurrentTenantDetailLazyQuery>;
export type CurrentTenantDetailQueryResult = Apollo.QueryResult<CurrentTenantDetailQuery, CurrentTenantDetailQueryVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($input: UpdateTenantInput!) {
  updateTenant(input: $input) {
    ...SettingsDetailPage
  }
}
    ${SettingsDetailPageFragmentDoc}`;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const RegenerateApiKeyDocument = gql`
    mutation RegenerateApiKey($id: ID!) {
  regenerateApiKey(id: $id) {
    ...SettingsDetailPage
  }
}
    ${SettingsDetailPageFragmentDoc}`;
export type RegenerateApiKeyMutationFn = Apollo.MutationFunction<RegenerateApiKeyMutation, RegenerateApiKeyMutationVariables>;

/**
 * __useRegenerateApiKeyMutation__
 *
 * To run a mutation, you first call `useRegenerateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateApiKeyMutation, { data, loading, error }] = useRegenerateApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateApiKeyMutation, RegenerateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateApiKeyMutation, RegenerateApiKeyMutationVariables>(RegenerateApiKeyDocument, options);
      }
export type RegenerateApiKeyMutationHookResult = ReturnType<typeof useRegenerateApiKeyMutation>;
export type RegenerateApiKeyMutationResult = Apollo.MutationResult<RegenerateApiKeyMutation>;
export type RegenerateApiKeyMutationOptions = Apollo.BaseMutationOptions<RegenerateApiKeyMutation, RegenerateApiKeyMutationVariables>;
export const SoulListDocument = gql`
    query SoulList($status: UserStatus, $orderByColumn: QuerySoulsOrderByColumn = LAST_NAME, $orderByOrder: SortOrder = ASC, $page: Int, $trashed: Trashed) {
  souls(
    status: $status
    first: 20
    orderBy: [{column: $orderByColumn, order: $orderByOrder}]
    page: $page
    trashed: $trashed
  ) {
    data {
      ...SoulListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${SoulListItemFragmentDoc}`;

/**
 * __useSoulListQuery__
 *
 * To run a query within a React component, call `useSoulListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoulListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoulListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      orderByColumn: // value for 'orderByColumn'
 *      orderByOrder: // value for 'orderByOrder'
 *      page: // value for 'page'
 *      trashed: // value for 'trashed'
 *   },
 * });
 */
export function useSoulListQuery(baseOptions?: Apollo.QueryHookOptions<SoulListQuery, SoulListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoulListQuery, SoulListQueryVariables>(SoulListDocument, options);
      }
export function useSoulListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoulListQuery, SoulListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoulListQuery, SoulListQueryVariables>(SoulListDocument, options);
        }
export type SoulListQueryHookResult = ReturnType<typeof useSoulListQuery>;
export type SoulListLazyQueryHookResult = ReturnType<typeof useSoulListLazyQuery>;
export type SoulListQueryResult = Apollo.QueryResult<SoulListQuery, SoulListQueryVariables>;
export const SoulDetailDocument = gql`
    query SoulDetail($id: ID!) {
  soul(id: $id) {
    id
    ...SoulInfo
  }
}
    ${SoulInfoFragmentDoc}`;

/**
 * __useSoulDetailQuery__
 *
 * To run a query within a React component, call `useSoulDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoulDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoulDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoulDetailQuery(baseOptions: Apollo.QueryHookOptions<SoulDetailQuery, SoulDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoulDetailQuery, SoulDetailQueryVariables>(SoulDetailDocument, options);
      }
export function useSoulDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoulDetailQuery, SoulDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoulDetailQuery, SoulDetailQueryVariables>(SoulDetailDocument, options);
        }
export type SoulDetailQueryHookResult = ReturnType<typeof useSoulDetailQuery>;
export type SoulDetailLazyQueryHookResult = ReturnType<typeof useSoulDetailLazyQuery>;
export type SoulDetailQueryResult = Apollo.QueryResult<SoulDetailQuery, SoulDetailQueryVariables>;
export const SoulEmailsDocument = gql`
    query SoulEmails($id: ID!, $page: Int) {
  soul(id: $id) {
    id
    emails(first: 10, page: $page) {
      data {
        ...EmailListItem
      }
      paginatorInfo {
        currentPage
        hasMorePages
        lastPage
      }
    }
  }
}
    ${EmailListItemFragmentDoc}`;

/**
 * __useSoulEmailsQuery__
 *
 * To run a query within a React component, call `useSoulEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoulEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoulEmailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSoulEmailsQuery(baseOptions: Apollo.QueryHookOptions<SoulEmailsQuery, SoulEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoulEmailsQuery, SoulEmailsQueryVariables>(SoulEmailsDocument, options);
      }
export function useSoulEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoulEmailsQuery, SoulEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoulEmailsQuery, SoulEmailsQueryVariables>(SoulEmailsDocument, options);
        }
export type SoulEmailsQueryHookResult = ReturnType<typeof useSoulEmailsQuery>;
export type SoulEmailsLazyQueryHookResult = ReturnType<typeof useSoulEmailsLazyQuery>;
export type SoulEmailsQueryResult = Apollo.QueryResult<SoulEmailsQuery, SoulEmailsQueryVariables>;
export const SoulEditDocument = gql`
    query SoulEdit($id: ID!) {
  soul(id: $id) {
    ...SoulEditForm
  }
}
    ${SoulEditFormFragmentDoc}`;

/**
 * __useSoulEditQuery__
 *
 * To run a query within a React component, call `useSoulEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoulEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoulEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoulEditQuery(baseOptions: Apollo.QueryHookOptions<SoulEditQuery, SoulEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoulEditQuery, SoulEditQueryVariables>(SoulEditDocument, options);
      }
export function useSoulEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoulEditQuery, SoulEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoulEditQuery, SoulEditQueryVariables>(SoulEditDocument, options);
        }
export type SoulEditQueryHookResult = ReturnType<typeof useSoulEditQuery>;
export type SoulEditLazyQueryHookResult = ReturnType<typeof useSoulEditLazyQuery>;
export type SoulEditQueryResult = Apollo.QueryResult<SoulEditQuery, SoulEditQueryVariables>;
export const CreateSoulDocument = gql`
    mutation CreateSoul($input: CreateSoulInput!) {
  createSoul(input: $input) {
    ...SoulInfo
  }
}
    ${SoulInfoFragmentDoc}`;
export type CreateSoulMutationFn = Apollo.MutationFunction<CreateSoulMutation, CreateSoulMutationVariables>;

/**
 * __useCreateSoulMutation__
 *
 * To run a mutation, you first call `useCreateSoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoulMutation, { data, loading, error }] = useCreateSoulMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoulMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoulMutation, CreateSoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoulMutation, CreateSoulMutationVariables>(CreateSoulDocument, options);
      }
export type CreateSoulMutationHookResult = ReturnType<typeof useCreateSoulMutation>;
export type CreateSoulMutationResult = Apollo.MutationResult<CreateSoulMutation>;
export type CreateSoulMutationOptions = Apollo.BaseMutationOptions<CreateSoulMutation, CreateSoulMutationVariables>;
export const UpdateSoulDocument = gql`
    mutation UpdateSoul($input: UpdateSoulInput!) {
  updateSoul(input: $input) {
    ...SoulInfo
  }
}
    ${SoulInfoFragmentDoc}`;
export type UpdateSoulMutationFn = Apollo.MutationFunction<UpdateSoulMutation, UpdateSoulMutationVariables>;

/**
 * __useUpdateSoulMutation__
 *
 * To run a mutation, you first call `useUpdateSoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSoulMutation, { data, loading, error }] = useUpdateSoulMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSoulMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSoulMutation, UpdateSoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSoulMutation, UpdateSoulMutationVariables>(UpdateSoulDocument, options);
      }
export type UpdateSoulMutationHookResult = ReturnType<typeof useUpdateSoulMutation>;
export type UpdateSoulMutationResult = Apollo.MutationResult<UpdateSoulMutation>;
export type UpdateSoulMutationOptions = Apollo.BaseMutationOptions<UpdateSoulMutation, UpdateSoulMutationVariables>;
export const ApproveSoulDocument = gql`
    mutation ApproveSoul($id: ID!) {
  approveSoul(id: $id) {
    id
    status
  }
}
    `;
export type ApproveSoulMutationFn = Apollo.MutationFunction<ApproveSoulMutation, ApproveSoulMutationVariables>;

/**
 * __useApproveSoulMutation__
 *
 * To run a mutation, you first call `useApproveSoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSoulMutation, { data, loading, error }] = useApproveSoulMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveSoulMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSoulMutation, ApproveSoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSoulMutation, ApproveSoulMutationVariables>(ApproveSoulDocument, options);
      }
export type ApproveSoulMutationHookResult = ReturnType<typeof useApproveSoulMutation>;
export type ApproveSoulMutationResult = Apollo.MutationResult<ApproveSoulMutation>;
export type ApproveSoulMutationOptions = Apollo.BaseMutationOptions<ApproveSoulMutation, ApproveSoulMutationVariables>;
export const DenySoulDocument = gql`
    mutation DenySoul($id: ID!) {
  denySoul(id: $id) {
    id
    status
  }
}
    `;
export type DenySoulMutationFn = Apollo.MutationFunction<DenySoulMutation, DenySoulMutationVariables>;

/**
 * __useDenySoulMutation__
 *
 * To run a mutation, you first call `useDenySoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenySoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denySoulMutation, { data, loading, error }] = useDenySoulMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDenySoulMutation(baseOptions?: Apollo.MutationHookOptions<DenySoulMutation, DenySoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenySoulMutation, DenySoulMutationVariables>(DenySoulDocument, options);
      }
export type DenySoulMutationHookResult = ReturnType<typeof useDenySoulMutation>;
export type DenySoulMutationResult = Apollo.MutationResult<DenySoulMutation>;
export type DenySoulMutationOptions = Apollo.BaseMutationOptions<DenySoulMutation, DenySoulMutationVariables>;
export const ActivateSoulDocument = gql`
    mutation ActivateSoul($id: ID!) {
  activateSoul(id: $id) {
    id
    status
  }
}
    `;
export type ActivateSoulMutationFn = Apollo.MutationFunction<ActivateSoulMutation, ActivateSoulMutationVariables>;

/**
 * __useActivateSoulMutation__
 *
 * To run a mutation, you first call `useActivateSoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSoulMutation, { data, loading, error }] = useActivateSoulMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateSoulMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSoulMutation, ActivateSoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSoulMutation, ActivateSoulMutationVariables>(ActivateSoulDocument, options);
      }
export type ActivateSoulMutationHookResult = ReturnType<typeof useActivateSoulMutation>;
export type ActivateSoulMutationResult = Apollo.MutationResult<ActivateSoulMutation>;
export type ActivateSoulMutationOptions = Apollo.BaseMutationOptions<ActivateSoulMutation, ActivateSoulMutationVariables>;
export const DeactivateSoulDocument = gql`
    mutation DeactivateSoul($id: ID!) {
  deactivateSoul(id: $id) {
    id
    status
  }
}
    `;
export type DeactivateSoulMutationFn = Apollo.MutationFunction<DeactivateSoulMutation, DeactivateSoulMutationVariables>;

/**
 * __useDeactivateSoulMutation__
 *
 * To run a mutation, you first call `useDeactivateSoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSoulMutation, { data, loading, error }] = useDeactivateSoulMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateSoulMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateSoulMutation, DeactivateSoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateSoulMutation, DeactivateSoulMutationVariables>(DeactivateSoulDocument, options);
      }
export type DeactivateSoulMutationHookResult = ReturnType<typeof useDeactivateSoulMutation>;
export type DeactivateSoulMutationResult = Apollo.MutationResult<DeactivateSoulMutation>;
export type DeactivateSoulMutationOptions = Apollo.BaseMutationOptions<DeactivateSoulMutation, DeactivateSoulMutationVariables>;
export const DeleteSoulDocument = gql`
    mutation DeleteSoul($id: ID!) {
  deleteSoul(id: $id) {
    id
  }
}
    `;
export type DeleteSoulMutationFn = Apollo.MutationFunction<DeleteSoulMutation, DeleteSoulMutationVariables>;

/**
 * __useDeleteSoulMutation__
 *
 * To run a mutation, you first call `useDeleteSoulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSoulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSoulMutation, { data, loading, error }] = useDeleteSoulMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSoulMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSoulMutation, DeleteSoulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSoulMutation, DeleteSoulMutationVariables>(DeleteSoulDocument, options);
      }
export type DeleteSoulMutationHookResult = ReturnType<typeof useDeleteSoulMutation>;
export type DeleteSoulMutationResult = Apollo.MutationResult<DeleteSoulMutation>;
export type DeleteSoulMutationOptions = Apollo.BaseMutationOptions<DeleteSoulMutation, DeleteSoulMutationVariables>;
export const RestoreSoulsDocument = gql`
    mutation RestoreSouls($ids: [ID!]!) {
  restoreSouls(ids: $ids) {
    id
  }
}
    `;
export type RestoreSoulsMutationFn = Apollo.MutationFunction<RestoreSoulsMutation, RestoreSoulsMutationVariables>;

/**
 * __useRestoreSoulsMutation__
 *
 * To run a mutation, you first call `useRestoreSoulsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreSoulsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreSoulsMutation, { data, loading, error }] = useRestoreSoulsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreSoulsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreSoulsMutation, RestoreSoulsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreSoulsMutation, RestoreSoulsMutationVariables>(RestoreSoulsDocument, options);
      }
export type RestoreSoulsMutationHookResult = ReturnType<typeof useRestoreSoulsMutation>;
export type RestoreSoulsMutationResult = Apollo.MutationResult<RestoreSoulsMutation>;
export type RestoreSoulsMutationOptions = Apollo.BaseMutationOptions<RestoreSoulsMutation, RestoreSoulsMutationVariables>;
export const ForceDeleteSoulsDocument = gql`
    mutation ForceDeleteSouls($ids: [ID!]!) {
  forceDeleteSouls(ids: $ids) {
    id
  }
}
    `;
export type ForceDeleteSoulsMutationFn = Apollo.MutationFunction<ForceDeleteSoulsMutation, ForceDeleteSoulsMutationVariables>;

/**
 * __useForceDeleteSoulsMutation__
 *
 * To run a mutation, you first call `useForceDeleteSoulsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteSoulsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDeleteSoulsMutation, { data, loading, error }] = useForceDeleteSoulsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useForceDeleteSoulsMutation(baseOptions?: Apollo.MutationHookOptions<ForceDeleteSoulsMutation, ForceDeleteSoulsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceDeleteSoulsMutation, ForceDeleteSoulsMutationVariables>(ForceDeleteSoulsDocument, options);
      }
export type ForceDeleteSoulsMutationHookResult = ReturnType<typeof useForceDeleteSoulsMutation>;
export type ForceDeleteSoulsMutationResult = Apollo.MutationResult<ForceDeleteSoulsMutation>;
export type ForceDeleteSoulsMutationOptions = Apollo.BaseMutationOptions<ForceDeleteSoulsMutation, ForceDeleteSoulsMutationVariables>;
export const EmptySoulTrashDocument = gql`
    mutation EmptySoulTrash {
  emptySoulTrash {
    id
  }
}
    `;
export type EmptySoulTrashMutationFn = Apollo.MutationFunction<EmptySoulTrashMutation, EmptySoulTrashMutationVariables>;

/**
 * __useEmptySoulTrashMutation__
 *
 * To run a mutation, you first call `useEmptySoulTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptySoulTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptySoulTrashMutation, { data, loading, error }] = useEmptySoulTrashMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptySoulTrashMutation(baseOptions?: Apollo.MutationHookOptions<EmptySoulTrashMutation, EmptySoulTrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptySoulTrashMutation, EmptySoulTrashMutationVariables>(EmptySoulTrashDocument, options);
      }
export type EmptySoulTrashMutationHookResult = ReturnType<typeof useEmptySoulTrashMutation>;
export type EmptySoulTrashMutationResult = Apollo.MutationResult<EmptySoulTrashMutation>;
export type EmptySoulTrashMutationOptions = Apollo.BaseMutationOptions<EmptySoulTrashMutation, EmptySoulTrashMutationVariables>;
export const OverviewStatsDocument = gql`
    query OverviewStats($input: OverviewStatsInput!) {
  overviewStats(input: $input) {
    tickets
    signups
    attends
  }
}
    `;

/**
 * __useOverviewStatsQuery__
 *
 * To run a query within a React component, call `useOverviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverviewStatsQuery(baseOptions: Apollo.QueryHookOptions<OverviewStatsQuery, OverviewStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewStatsQuery, OverviewStatsQueryVariables>(OverviewStatsDocument, options);
      }
export function useOverviewStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewStatsQuery, OverviewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewStatsQuery, OverviewStatsQueryVariables>(OverviewStatsDocument, options);
        }
export type OverviewStatsQueryHookResult = ReturnType<typeof useOverviewStatsQuery>;
export type OverviewStatsLazyQueryHookResult = ReturnType<typeof useOverviewStatsLazyQuery>;
export type OverviewStatsQueryResult = Apollo.QueryResult<OverviewStatsQuery, OverviewStatsQueryVariables>;
export const TargetGroupStatsDocument = gql`
    query TargetGroupStats($input: TargetGroupStatsInput!) {
  targetGroupStats(input: $input) {
    target_group
    ...TargetGroupStats
  }
}
    ${TargetGroupStatsFragmentDoc}`;

/**
 * __useTargetGroupStatsQuery__
 *
 * To run a query within a React component, call `useTargetGroupStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetGroupStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetGroupStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTargetGroupStatsQuery(baseOptions: Apollo.QueryHookOptions<TargetGroupStatsQuery, TargetGroupStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetGroupStatsQuery, TargetGroupStatsQueryVariables>(TargetGroupStatsDocument, options);
      }
export function useTargetGroupStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetGroupStatsQuery, TargetGroupStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetGroupStatsQuery, TargetGroupStatsQueryVariables>(TargetGroupStatsDocument, options);
        }
export type TargetGroupStatsQueryHookResult = ReturnType<typeof useTargetGroupStatsQuery>;
export type TargetGroupStatsLazyQueryHookResult = ReturnType<typeof useTargetGroupStatsLazyQuery>;
export type TargetGroupStatsQueryResult = Apollo.QueryResult<TargetGroupStatsQuery, TargetGroupStatsQueryVariables>;
export const CategoryStatsDocument = gql`
    query CategoryStats($input: CategoryStatsInput!) {
  categoryStats(input: $input) {
    category {
      id
    }
    ...CategoryStats
  }
}
    ${CategoryStatsFragmentDoc}`;

/**
 * __useCategoryStatsQuery__
 *
 * To run a query within a React component, call `useCategoryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCategoryStatsQuery(baseOptions: Apollo.QueryHookOptions<CategoryStatsQuery, CategoryStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryStatsQuery, CategoryStatsQueryVariables>(CategoryStatsDocument, options);
      }
export function useCategoryStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryStatsQuery, CategoryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryStatsQuery, CategoryStatsQueryVariables>(CategoryStatsDocument, options);
        }
export type CategoryStatsQueryHookResult = ReturnType<typeof useCategoryStatsQuery>;
export type CategoryStatsLazyQueryHookResult = ReturnType<typeof useCategoryStatsLazyQuery>;
export type CategoryStatsQueryResult = Apollo.QueryResult<CategoryStatsQuery, CategoryStatsQueryVariables>;
export const TagListDocument = gql`
    query TagList {
  tags {
    ...TagListItem
  }
}
    ${TagListItemFragmentDoc}`;

/**
 * __useTagListQuery__
 *
 * To run a query within a React component, call `useTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagListQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagListQuery(baseOptions?: Apollo.QueryHookOptions<TagListQuery, TagListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagListQuery, TagListQueryVariables>(TagListDocument, options);
      }
export function useTagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagListQuery, TagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagListQuery, TagListQueryVariables>(TagListDocument, options);
        }
export type TagListQueryHookResult = ReturnType<typeof useTagListQuery>;
export type TagListLazyQueryHookResult = ReturnType<typeof useTagListLazyQuery>;
export type TagListQueryResult = Apollo.QueryResult<TagListQuery, TagListQueryVariables>;
export const TagDetailDocument = gql`
    query TagDetail($id: ID!) {
  tag(id: $id) {
    id
    ...TagDetailPage
  }
}
    ${TagDetailPageFragmentDoc}`;

/**
 * __useTagDetailQuery__
 *
 * To run a query within a React component, call `useTagDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagDetailQuery(baseOptions: Apollo.QueryHookOptions<TagDetailQuery, TagDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagDetailQuery, TagDetailQueryVariables>(TagDetailDocument, options);
      }
export function useTagDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagDetailQuery, TagDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagDetailQuery, TagDetailQueryVariables>(TagDetailDocument, options);
        }
export type TagDetailQueryHookResult = ReturnType<typeof useTagDetailQuery>;
export type TagDetailLazyQueryHookResult = ReturnType<typeof useTagDetailLazyQuery>;
export type TagDetailQueryResult = Apollo.QueryResult<TagDetailQuery, TagDetailQueryVariables>;
export const TagEditDocument = gql`
    query TagEdit($id: ID!) {
  tag(id: $id) {
    id
    ...TagEditForm
  }
}
    ${TagEditFormFragmentDoc}`;

/**
 * __useTagEditQuery__
 *
 * To run a query within a React component, call `useTagEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagEditQuery(baseOptions: Apollo.QueryHookOptions<TagEditQuery, TagEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagEditQuery, TagEditQueryVariables>(TagEditDocument, options);
      }
export function useTagEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagEditQuery, TagEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagEditQuery, TagEditQueryVariables>(TagEditDocument, options);
        }
export type TagEditQueryHookResult = ReturnType<typeof useTagEditQuery>;
export type TagEditLazyQueryHookResult = ReturnType<typeof useTagEditLazyQuery>;
export type TagEditQueryResult = Apollo.QueryResult<TagEditQuery, TagEditQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    ...TagDetailPage
  }
}
    ${TagDetailPageFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    ...TagDetailPage
  }
}
    ${TagDetailPageFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteTag(id: $id) {
    id
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const TagsDocument = gql`
    query Tags {
  tags {
    ...PersonTagMultiSelect
  }
}
    ${PersonTagMultiSelectFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const PermissionsDocument = gql`
    query Permissions {
  permissions {
    ...PermissionMultiSelect
  }
}
    ${PermissionMultiSelectFragmentDoc}`;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const RolesDocument = gql`
    query Roles {
  roles {
    ...RoleMultiSelect
  }
}
    ${RoleMultiSelectFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const CategoriesDocument = gql`
    query Categories {
  categories {
    ...CategoryMultiSelect
  }
}
    ${CategoryMultiSelectFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const AllotmentsDocument = gql`
    query Allotments {
  allotments {
    ...AllotmentSelect
  }
}
    ${AllotmentSelectFragmentDoc}`;

/**
 * __useAllotmentsQuery__
 *
 * To run a query within a React component, call `useAllotmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllotmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllotmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllotmentsQuery(baseOptions?: Apollo.QueryHookOptions<AllotmentsQuery, AllotmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllotmentsQuery, AllotmentsQueryVariables>(AllotmentsDocument, options);
      }
export function useAllotmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllotmentsQuery, AllotmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllotmentsQuery, AllotmentsQueryVariables>(AllotmentsDocument, options);
        }
export type AllotmentsQueryHookResult = ReturnType<typeof useAllotmentsQuery>;
export type AllotmentsLazyQueryHookResult = ReturnType<typeof useAllotmentsLazyQuery>;
export type AllotmentsQueryResult = Apollo.QueryResult<AllotmentsQuery, AllotmentsQueryVariables>;
export const OrganisationsDocument = gql`
    query Organisations {
  organisations {
    ...PersonOrganisationSelect
  }
}
    ${PersonOrganisationSelectFragmentDoc}`;

/**
 * __useOrganisationsQuery__
 *
 * To run a query within a React component, call `useOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
      }
export function useOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
export type OrganisationsQueryHookResult = ReturnType<typeof useOrganisationsQuery>;
export type OrganisationsLazyQueryHookResult = ReturnType<typeof useOrganisationsLazyQuery>;
export type OrganisationsQueryResult = Apollo.QueryResult<OrganisationsQuery, OrganisationsQueryVariables>;
export const EmailUsersDocument = gql`
    mutation EmailUsers($input: EmailUsersInput!) {
  emailUsers(input: $input)
}
    `;
export type EmailUsersMutationFn = Apollo.MutationFunction<EmailUsersMutation, EmailUsersMutationVariables>;

/**
 * __useEmailUsersMutation__
 *
 * To run a mutation, you first call `useEmailUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailUsersMutation, { data, loading, error }] = useEmailUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailUsersMutation(baseOptions?: Apollo.MutationHookOptions<EmailUsersMutation, EmailUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailUsersMutation, EmailUsersMutationVariables>(EmailUsersDocument, options);
      }
export type EmailUsersMutationHookResult = ReturnType<typeof useEmailUsersMutation>;
export type EmailUsersMutationResult = Apollo.MutationResult<EmailUsersMutation>;
export type EmailUsersMutationOptions = Apollo.BaseMutationOptions<EmailUsersMutation, EmailUsersMutationVariables>;
export const SendResetLinkForUserDocument = gql`
    mutation SendResetLinkForUser($id: ID!) {
  sendResetLinkForUser(id: $id)
}
    `;
export type SendResetLinkForUserMutationFn = Apollo.MutationFunction<SendResetLinkForUserMutation, SendResetLinkForUserMutationVariables>;

/**
 * __useSendResetLinkForUserMutation__
 *
 * To run a mutation, you first call `useSendResetLinkForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetLinkForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetLinkForUserMutation, { data, loading, error }] = useSendResetLinkForUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendResetLinkForUserMutation(baseOptions?: Apollo.MutationHookOptions<SendResetLinkForUserMutation, SendResetLinkForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetLinkForUserMutation, SendResetLinkForUserMutationVariables>(SendResetLinkForUserDocument, options);
      }
export type SendResetLinkForUserMutationHookResult = ReturnType<typeof useSendResetLinkForUserMutation>;
export type SendResetLinkForUserMutationResult = Apollo.MutationResult<SendResetLinkForUserMutation>;
export type SendResetLinkForUserMutationOptions = Apollo.BaseMutationOptions<SendResetLinkForUserMutation, SendResetLinkForUserMutationVariables>;